{
  "_license": "Copyright (c) 2025 Goffy. This file belongs to Goffy. All Rights Reserved.",
  "push": {
    "channelName": "Goffy-aviseringar"
  },
  "course": {
    "error": "Kan inte ladda golfklubbar",
    "insecure": "Använder en standardplacering (kräver HTTPS för exakt position).",
    "label": "Använd närmaste golfklubb",
    "enableLocationHint": "(Aktivera plats för detta)",
    "loading": "Hitta golfklubbar",
    "none": "Inga golfklubbar i närheten",
    "permissionDenied": "Platsbehörigheter nekade",
    "helpLabel": "Hjälp för plats",
    "helpTitle": "Aktivera plats för närmaste golfklubb",
    "helpDescription": "Tillåt platsåtkomst i webbläsaren eller enhetens inställningar för att automatiskt hitta klubbar i närheten.",
    "refresh": "Uppdatera",
    "select": "Välj golfklubb"
  },
  "appError": {
    "title": "Något gick fel",
    "message": "Ladda om sidan. Om problemet kvarstår, kontakta support.",
    "retry": "Försök igen"
  },
  "edit": {
    "autosave": "Ändra texten, spara filen så uppdateras din app automatiskt.",
    "help": "Tryck här om din app inte uppdateras automatiskt efter att du har gjort ändringar",
    "openCode": "Öppna koden för den här skärmen:"
  },
  "menu": {
    "adminTools": "Adminverktyg",
    "profile": "Profil",
    "statistics": "Statistik",
    "about": "Tjänststatus",
    "aboutTitle": "Tjänststatus",
    "aboutLoading": "Hämtar status...",
    "aboutEmpty": "Ingen statusdata tillgänglig.",
    "aboutError": "Fel:",
    "aboutLoadError": "Kunde inte hämta status.",
    "aboutUnknownService": "Okänd tjänst",
    "aboutUnknownImage": "Okänd bild",
    "viewAs": "Visa som…",
    "viewAsActive": "Visa som: {role}",
    "viewAsTitle": "Visa appen som roll",
    "viewAsHint": "Endast visning – servern kontrollerar fortfarande dina riktiga roller.",
    "viewAsDeveloper": "Utvecklare",
    "viewAsAdmin": "Administratör",
    "viewAsPaidUser": "Betalande användare",
    "viewAsUser": "Användare",
    "viewAsPlayer": "Spelare (inga roller)",
    "viewAsReset": "Återställ till mina riktiga roller",
    "home": "Hem",
    "referee": "Goffy AI-domare",
    "createAccount": "Skapa konto",
    "friends": "Vänner",
    "hole": "Hål",
    "selectGames": "Välj spel",
    "tour": "Tour",
    "tourSettings": "Tourinställningar",
    "tourLeaderboard": "Tourledartavla",
    "golfCourses": "Golfbanor",
    "gameCalculator": "Game Calculator",
    "golfGamesAdmin": "Golf Games Admin",
    "configCourse": "Konfigurera bana",
    "scoreAllHoles": "Skapa resultat alla hål (debug)",
    "scoreAllHolesRunning": "Skapar resultat…",
    "scoreAllHolesDone": "La in {scores} resultat på {holes} hål för {players} spelare. Händelser: {events}, mystery: {mystery}.",
    "scoreAllHolesError": "Kunde inte skapa resultat för alla hål.",
    "roundInfo": "Rondinformation",
    "roundInfoLoading": "Laddar rondinformation…",
    "roundInfoError": "Kunde inte ladda rondinformation.",
    "roundInfoCopy": "Kopiera",
    "scoreAllHolesCountLabel": "Hur många hål ska fyllas i?",
    "scoreAllHolesStart": "Skapa resultat",
    "scoreAllHolesImport": "Importera fil…",
    "scoreAllHolesClean": "Rensa befintliga spelare och resultat före import",
    "scoreAllHolesImportHint": "Importfil: skapa den med tools/game-calculator/fetch-round-scores.py export <ROUND_ID> (prod-DB via ./scripts/open_ports_ssm.py). Spelare matchas på namn, spel och resultat spelas upp på denna rond.",
    "scoreAllHolesImportError": "Kunde inte importera rondfil.",
    "scoreAllHolesHole": "Hål {hole} (par {par})",
    "scoreAllHolesRow": "{name}: {strokes}",
    "scoreAllHolesMystery": "Mystery-vinnare",
    "scoreAllHolesMysteryRow": "Hål {hole}: {name}",
    "ok": "OK",
    "roundResults": "Runda",
    "scorecard": "Scorekort",
    "holeView": "Vy",
    "more": "Meny",
    "back": "<- Tillbaka",
    "logout": "Logga ut",
    "close": "Stäng",
    "anonymous": "Gäst",
    "privacy": "Integritetspolicy",
    "courseMapping": "Bankartläggning",
    "courseMappingReview": "Granska bankartläggning",
    "manageSubscription": "Hantera prenumeration",
    "paymentsAdmin": "Betalningar och prenumerationer",
    "golfCourseAdmin": "Golfbaneadministration",
    "adminStatistics": "Plattformsstatistik",
    "batchFleet": "Batch-flotta",
    "terms": "Tjänstevillkor",
    "appInfo": "Om",
    "reportBug": "Rapportera bugg",
    "reportBugTitle": "Rapportera bugg",
    "reportBugHint": "Beskriv vad som hände. Inkludera förväntat och faktiskt resultat.",
    "reportBugDescriptionPlaceholder": "Vad hände? Vad förväntade du dig?",
    "reportBugAddImage": "Lägg till bild",
    "reportBugRemoveImage": "Ta bort bild",
    "reportBugPasteHint": "Tips: klistra in en bild från urklipp när den här dialogen är öppen.",
    "reportBugSend": "Skicka rapport",
    "reportBugSending": "Skickar...",
    "reportBugSent": "Buggrapport skickad till Slack #bugs.",
    "reportBugSendFailed": "Kunde inte skicka buggrapport",
    "reportBugInvalidImage": "Endast bildfiler stöds.",
    "reportBugImageTooLarge": "Bilden är för stor (max 8 MB).",
    "reportBugMissingContent": "Lägg till en beskrivning eller bild innan du skickar.",
    "reportBugFileUnsupported": "Filuppladdning stöds bara på webben.",
    "myRounds": "Mina ronder",
    "mlTraining": "ML och träning",
    "analysisOverview": "Analysöversikt",
    "documentation": "Dokumentation"
  },
  "analysisFlowPage": {
    "jobsHeading": "Körningens jobb ({count})",
    "laneAttempt": "försök {attempt}",
    "runId": "Körning {id}",
    "correlationId": "Korrelation {id}",
    "requestedAt": "Begärd {time}",
    "startedAt": "Startad {time}",
    "finishedAt": "Avslutad {time}",
    "lanePlanned": "planerat {time}",
    "laneDispatched": "utskickat {time}",
    "laneFinished": "klart {time}",
    "laneOpen": "pågår fortfarande",
    "laneLegend": "Prickat: väntar på att skickas ut · stapel: på en server · ◆ kartan avgjordes från det här svaret",
    "title": "Analysflöde",
    "noRun": "Ingen körning angavs, så det finns inget att rita.",
    "sourcesHeading": "Banans datakällor",
    "sourceOsm": "OSM: {holes} hål · {greens} greenar · {bunkers} bunkrar · {fairways} fairways",
    "sourceOsmNone": "OSM: inget importerat",
    "sourceScorecard": "Golf i Sverige: {holes} hål · {tees} tees · importerat {date}",
    "sourceScorecardNone": "Golf i Sverige: ingen scorekortsimport rapporterad"
  },
  "analysisHelpPage": {
    "title": "Så fungerar en bananalys",
    "intro": "De elva stegen en körning går igenom, från förfrågan geodata bygger till de objekt banan får.",
    "stepCount": "Steg {step} av {total}",
    "back": "Tillbaka",
    "next": "Nästa",
    "steps": {
      "request": {
        "title": "Förfrågan",
        "body": "geodata-service bygger den av det banan redan vet: var hålen ligger, greenerna som ska växas från en känd position, gränserna en starkare källa redan ritat, och linjen varje hål spelas längs. Den avgör också hur stor yta som ska täckas — radien växer per bana så att varje hål hamnar väl innanför bilden."
      },
      "dispatch": {
        "title": "Från en förfrågan till många jobb",
        "body": "En förfrågan blir en körning, och körningen planeras som en omgång jobb innan något publiceras: en klassisk detektering per bildleverantör, en modelldetektering per tränad modell flottan har, trädhöjden, höjdprofilerna, hålbilderna. Varje jobb går ut på sin egen kö så snart dess egen indata finns — en leverantör utan lagring direkt, en lagrad leverantör när dess bilder hämtats — och batch-servrar utanför molnet tar dem parallellt, ett tungt jobb per analysator så att ingen analysator OOM-dödas med två banor i minnet."
      },
      "jobs": {
        "title": "En omgång jobb, en klocka",
        "body": "Körningen pågår tills varje jobb har svarat; vad den är värd kommer från de detekteringar som publicerar. Varje jobbrad säger var det är — väntar på en hämtning, ute på en server, klart, misslyckat — och en misslyckad biprodukt (en höjdläsning, en bildbeskärning) syns på sin rad utan att sänka en omgång vars karta har ett svar. Körningssidan ritar omgången som banor på en klocka; flottsidan listar jobben och vad vart och ett väntar på."
      },
      "imagery": {
        "title": "Bilder, ett fönster i taget",
        "body": "En bana är 1,5–2 km tvärs över och en mosaik kostar sin sida i kvadrat, så bilden tas i överlappande fönster i stället för en enda ruta. Varje fönster hämtas från bildleverantören, eller läses ur den baskarta föregående analys sparade — vilket är skillnaden mellan en tvåminuters omanalys och en på trettio minuter."
      },
      "detect": {
        "title": "Att hitta former",
        "body": "Inne i varje fönster gör detektorn pixlar till masker, och masker till former. Den klassiska detektorn använder handtrimmade färg- och texturgränser; en modellkörning byter bara ut den funktionen mot en tränad checkpoint. Allt efter masken är identiskt i båda fallen, och det är det som gör dem jämförbara."
      },
      "filter": {
        "title": "Vad som sållas bort",
        "body": "Det mesta detektorn ser blir aldrig ett objekt. Former som är för små, för taggiga eller för långt från där hålet spelas tas bort, och det som återstår knyts till ett hål via hålets spellinje — färg ensam kan inte skilja en fairway från nästa, för det är samma gräs."
      },
      "merge": {
        "title": "Slå ihop överlappet",
        "body": "Fönstren överlappar så att inget faller emellan, vilket betyder att en bunker nära en kant hittas två gånger. Dubbletter slås ihop i slutet av körningen, så banan får ett objekt per markbit i stället för ett per fönster som råkade se den."
      },
      "promote": {
        "title": "Publicering",
        "body": "Först nu blir något en del av banan. Publicering är vinnaren-tar-marken med fast rangordning — en persons redigering slår GPS, GPS slår OSM, OSM slår en analys — så en detektion som hamnar på mark en starkare källa redan beskriver tas bort i stället för att publiceras. Det räknas, det sker inte tyst: körningen registrerar hur många den skrev och hur många den hoppade över."
      },
      "canopy": {
        "title": "Trädkronorna, uppmätta",
        "body": "Trädkronor har en färg, och det har skugga på vatten också. Laserprodukten mäter höjd i stället: trädhöjdsjobbet läser det lagrade höjdplanet en gång för hela banan och ritar allt två meter eller mer över marken som bestånd. Bestånden är inte objekt — de är bevis. När banan avgörs litar vi lite mer på en trädkandidat som kronorna täcker och lite mindre på en de inte täcker, oavsett vilket jobb som blev klart först; bestånden själva ligger kvar i kandidatlagret för vem som helst att titta på."
      },
      "model": {
        "title": "Var ett modelljobb stannar",
        "body": "En modelldetektering är ett jobb i omgången som alla andra — ett per tränad modell flottan har, på de lagrade bilderna, parallellt med den klassiska. Det publicerar ingenting: resultatet sparas som kandidater mot sitt eget jobb och ritas på begäran. Publicering skulle radera just de klassiska objekt modellen ska jämföras mot, så att göra en modell till banans svar förblir ett granskningsbeslut."
      },
      "time": {
        "title": "Var tiden går",
        "body": "Att hämta pixlar är det mesta av en detektering; segmenteringen är det mesta av resten, och sammanslagning och avgörande är sekunder. Jobben går parallellt, så en omgång tar ungefär lika lång tid som sitt långsammaste jobb plus köväntan framför det. Varje jobb och varje steg registreras per körning — öppna en bananalys på flottsidan och tryck Visa steg för de verkliga siffrorna i stället för de här."
      }
    }
  },
  "analysisOverviewPage": {
    "title": "Analysöversikt",
    "intro": "Alla banor som analyserats och vad det gav: när den senast lyckades, hur många körningar det tog och vad banan innehåller nu.",
    "loading": "Hämtar översikten…",
    "failed": "Kunde inte hämta analysöversikten.",
    "forbidden": "Den här sidan är för utvecklare och administratörer.",
    "retry": "Försök igen",
    "refresh": "Uppdatera",
    "empty": "Inga banor än.",
    "summary": "{analysed} av {courses} banor analyserade · {features} objekt · {pending} väntar på granskning",
    "neverAnalysed": "Aldrig analyserad",
    "queued": "I kö",
    "runs": "{count} körningar",
    "failedRuns": "{count} misslyckade",
    "modelRuns": "{count} modellkörningar",
    "features": "{total} objekt ({satellite} från bilder)",
    "pending": "{count} att granska"
  },
  "profile": {
    "title": "Profil",
    "loading": "Hämtar profil...",
    "loadFailed": "Kunde inte hämta profil.",
    "playerProvisioning": "Skapar din spelarprofil...",
    "displayNameLabel": "Visningsnamn",
    "displayNamePlaceholder": "Ditt smeknamn",
    "fullNameLabel": "Fullständigt namn",
    "fullNamePlaceholder": "Ditt fullständiga namn",
    "nameLabel": "Namn",
    "namePlaceholder": "Ange ditt namn",
    "emailLabel": "E-post",
    "emailPlaceholder": "namn@example.com",
    "genderLabel": "Kön",
    "genderPlaceholder": "man, kvinna eller annat",
    "genderMale": "Man",
    "genderFemale": "Kvinna",
    "genderNeutral": "Neutral",
    "handicapLabel": "Handicap",
    "handicapPlaceholder": "t.ex. 12,4",
    "handicapDateLabel": "Handicapdatum",
    "handicapDatePlaceholder": "ÅÅÅÅ-MM-DD",
    "golfIdLabel": "Golf-ID",
    "golfIdPlaceholder": "t.ex. 901231-001",
    "golfIdHelp": "Ditt Golf-ID från förbundet. Andra spelare kan hitta dig med det om du tillåter det nedan.",
    "invalidGolfId": "Ange ett giltigt Golf-ID (bokstäver, siffror och bindestreck).",
    "golfIdTaken": "Det Golf-ID:t används redan av ett annat konto.",
    "searchVisibilityLabel": "Vem kan hitta mig",
    "searchVisibilityName": "Via namn",
    "searchVisibilityGolfId": "Endast via Golf-ID",
    "searchVisibilityNever": "Ingen",
    "searchVisibilityNameHelp": "Du visas i spellistor och kan sökas fram på namn.",
    "searchVisibilityGolfIdHelp": "Du döljs i spellistor; bara den som skriver ditt exakta Golf-ID kan hitta dig.",
    "searchVisibilityNeverHelp": "Du visas aldrig i sökning eller spellistor. Vänner och deltagare i dina tourer ser dig ändå.",
    "searchVisibilityGolfIdRequired": "Lägg till ditt Golf-ID innan du väljer att bara hittas via Golf-ID.",
    "imageLabel": "Profilbild",
    "uploadImage": "Ladda upp bild",
    "selectAvatar": "Välj avatar",
    "removeAvatar": "Ta bort avatar",
    "avatarPickerTitle": "Välj en avatar",
    "avatarMore": "Fler",
    "avatarLoading": "Laddar avatarer...",
    "close": "Stäng",
    "save": "Spara",
    "autosaveSaved": "Sparat",
    "autosaveFailed": "Inte sparat",
    "saving": "Sparar...",
    "saveSuccess": "Profil sparad.",
    "saveFailed": "Kunde inte spara profil.",
    "handicapRequired": "Ange handicap när handicapdatum är satt.",
    "handicapDateRequired": "Ange handicapdatum när handicap är satt.",
    "invalidHandicap": "Ange ett giltigt handicapvärde.",
    "invalidHandicapDate": "Ange ett giltigt handicapdatum (ÅÅÅÅ-MM-DD).",
    "homeClubsLabel": "Hemmklubbar",
    "homeClubsEmpty": "Inga hemmklubbar valda.",
    "homeClubsAdd": "Lägg till hemmklubb",
    "homeClubsCreate": "Lägg till ny klubb",
    "homeClubsPrimary": "Primär",
    "homeClubsSetPrimary": "Sätt som primär",
    "homeClubsRemove": "Ta bort",
    "homeClubsPickerTitle": "Välj hemmklubb",
    "homeClubsSearchPlaceholder": "Sök klubb...",
    "homeClubsLoading": "Laddar klubbar...",
    "homeClubsNoResults": "Inga klubbar hittades.",
    "homeClubsUnknownLocation": "Okänd plats",
    "homeClubsRefresh": "Uppdatera",
    "homeClubsLoadFailed": "Kunde inte ladda klubbar.",
    "uploading": "Laddar upp bild...",
    "uploadSuccess": "Bild uppladdad.",
    "uploadFailed": "Kunde inte ladda upp bild.",
    "permissionDenied": "Behov av fotobibliotekstillstånd.",
    "passwordSectionLabel": "Lösenord",
    "changePassword": "Byt lösenord",
    "setPassword": "Skapa lösenord",
    "passwordSetHint": "Du loggade in med Google. Skapa ett lösenord för att också kunna logga in med e-post och lösenord.",
    "currentPasswordLabel": "Nuvarande lösenord",
    "newPasswordLabel": "Nytt lösenord",
    "newPasswordPlaceholder": "Minst {min} tecken",
    "repeatPasswordLabel": "Upprepa nytt lösenord",
    "passwordMismatch": "Lösenorden matchar inte.",
    "passwordTooShort": "Lösenordet måste vara minst {min} tecken.",
    "currentPasswordRequired": "Ange ditt nuvarande lösenord.",
    "currentPasswordInvalid": "Nuvarande lösenord är felaktigt.",
    "passwordAccountLocked": "För många försök. Försök igen senare.",
    "passwordChangeFailed": "Det gick inte att byta lösenord.",
    "passwordChangeTimeout": "Begäran tog för lång tid. Försök igen.",
    "passwordChanged": "Lösenordet har uppdaterats.",
    "passwordSaving": "Uppdaterar lösenord...",
    "deleteAccountSectionLabel": "Radera konto",
    "deleteAccountHint": "Tar bort din inloggning och din profil. Det går inte att ångra.",
    "deleteAccount": "Radera mitt konto",
    "deleteAccountConfirmTitle": "Vill du radera ditt konto?",
    "deleteAccountConfirmBody": "Din inloggning, profil, bild och dina inställningar raderas permanent. Det går inte att ångra.",
    "deleteAccountConfirmHistory": "Ronder och tourer du spelat finns kvar på de andra spelarnas scorekort, fortfarande med ditt namn. Att ta bort dem skulle skriva om någon annans rond.",
    "deleteAccountConfirm": "Radera konto",
    "deleteAccountCancel": "Avbryt",
    "deleteAccountPending": "Raderar...",
    "deleteAccountFailed": "Kunde inte radera kontot. Försök igen.",
    "apiAccessSectionLabel": "API-åtkomst",
    "apiAccessHint": "Läs din egen Goffy-data från skript och andra appar med en personlig åtkomsttoken. Tokens är skrivskyddade och agerar som du, så håll dem hemliga.",
    "apiTokensLoading": "Laddar tokens...",
    "apiTokensEmpty": "Du har inga åtkomsttokens ännu.",
    "apiTokensLoadFailed": "Kunde inte ladda dina åtkomsttokens.",
    "apiTokenCreatedAt": "Skapad {date}",
    "apiTokenLastUsed": "Senast använd {date}",
    "apiTokenNeverUsed": "Aldrig använd",
    "apiTokenExpires": "Går ut {date}",
    "apiTokenRevoke": "Återkalla",
    "apiTokenRevokeConfirmTitle": "Återkalla denna token?",
    "apiTokenRevokeConfirmBody": "Allt som använder \"{name}\" slutar fungera direkt. Detta kan inte ångras.",
    "apiTokenRevokeConfirm": "Återkalla token",
    "apiTokenRevoking": "Återkallar...",
    "apiTokenRevokeFailed": "Kunde inte återkalla din token. Försök igen.",
    "apiTokenCancel": "Avbryt",
    "apiTokenCreate": "Skapa token",
    "apiTokenCreateTitle": "Ny åtkomsttoken",
    "apiTokenNameLabel": "Namn",
    "apiTokenNamePlaceholder": "t.ex. Skript på datorn",
    "apiTokenCreating": "Skapar...",
    "apiTokenCreateFailed": "Kunde inte skapa din token. Försök igen.",
    "apiTokenLimitReached": "Du har redan det högsta antalet tokens. Återkalla en först.",
    "apiTokenRevealTitle": "Kopiera din token nu",
    "apiTokenRevealWarning": "Det här är enda gången din token visas. Spara den på ett säkert ställe. Om du tappar bort den, återkalla den och skapa en ny.",
    "apiTokenCopy": "Kopiera",
    "apiTokenCopied": "Kopierad till urklipp.",
    "apiTokenCopyFailed": "Kunde inte kopiera. Markera din token och kopiera den för hand.",
    "apiTokenDone": "Klar",
    "exportAction": "Ladda ner min data",
    "exportHint": "En JSON-fil med allt API:et returnerar om dig: profil, tourer, ronder och statistik.",
    "exportTitle": "Goffy dataexport",
    "exportPreparing": "Förbereder din export...",
    "exportDownloaded": "Din data sparades bland dina nedladdningar.",
    "exportUnsupported": "Att spara filer stöds inte på den här enheten.",
    "exportFailed": "Kunde inte exportera din data. Försök igen.",
    "apiDocsHint": "Så använder du API:et:",
    "apiDocsLink": "Utvecklardokumentation",
    "enhancedInputSectionLabel": "Slagdetaljer",
    "enhancedInputHint": "Registrera fairwayträffar, puttar och greener på reglementerat antal slag på dina egna resultat. Ingen annan ser dem, och inget annat i ronden påverkas.",
    "enhancedInputToggleLabel": "Registrera slagdetaljer",
    "enhancedInputOn": "På",
    "enhancedInputOff": "Av",
    "skinSectionLabel": "Utseende",
    "skinHint": "Välj vilket utseende den här enheten visar. Bara för administratörer medan utseenden provas; valet stannar på enheten.",
    "skinRestartHint": "Stäng och öppna appen igen för att använda det nya utseendet.",
    "shotTrackingSectionLabel": "Automatisk slaglängd",
    "shotTrackingHint": "Mät hur långt du slår varje slag, helt utan knapptryck. Telefonen lyssnar efter träffljudet bara medan du står stilla och använder GPS för avståndet. Inget ljud sparas eller lämnar telefonen — bara själva träffögonblicket. Fungerar tillsammans med klockan när du bär en.",
    "shotTrackingToggleLabel": "Mät mina slag",
    "shotTrackingOn": "På",
    "shotTrackingOff": "Av",
    "shotTrackingAndroidOnly": "Telefonbaserad detektering fungerar för närvarande på Android. På andra enheter kan klockan fortfarande markera dina slag.",
    "showDistanceSectionLabel": "Avstånd till green",
    "showDistanceHint": "Visa ditt levande avstånd till mitten av greenen bredvid Par och Index på hålskärmen. Använder telefonens GPS.",
    "showDistanceToggleLabel": "Visa avstånd",
    "showDistanceOn": "På",
    "hazardAnimationsSectionLabel": "Hinderanimationer",
    "hazardAnimationsHint": "Visa ett litet animerat djur bredvid spelare som hamnat i ett hinder.",
    "hazardAnimationsToggleLabel": "Visa hinderanimationer",
    "hazardAnimationsOn": "På",
    "hazardAnimationsOff": "Av",
    "showDistanceOff": "Av",
    "coachTipsSectionLabel": "Tips",
    "coachTipsHint": "Tipsen pekar ut funktioner medan du spelar. De visas tills du döljer dem.",
    "coachTipsToggleLabel": "Visa tips",
    "coachTipsOn": "På",
    "coachTipsOff": "Av",
    "coachTipsReset": "Visa dolda tips igen",
    "coachTipsResetting": "Återställer tips...",
    "coachTipsSaveFailed": "Kunde inte uppdatera tipsen.",
    "distanceUnitSectionLabel": "Avstånd",
    "distanceUnitHint": "Hur avstånd visas i appen. Allt lagras i meter, så valet ändrar bara det du läser.",
    "distanceUnitMetric": "Meter och kilometer",
    "distanceUnitImperial": "Yards och miles",
    "shotTrackingDebugLink": "Felsökning slagmätning (utvecklare)"
  },
  "statistics": {
    "title": "Min statistik",
    "tabGames": "Spel & tourer",
    "tabScoring": "Score",
    "allTime": "Alla år",
    "loading": "Hämtar statistik...",
    "loadFailed": "Kunde inte hämta din statistik.",
    "noPlayer": "Ingen spelarprofil hittades för ditt konto än.",
    "signedOut": "Logga in för att se din statistik.",
    "retry": "Försök igen",
    "emptyTitle": "Inga ronder än",
    "emptyHint": "Spela och registrera en rond, så börjar din statistik byggas upp här.",
    "roundsPlayed": "Spelade ronder",
    "tours": "Tourer",
    "activeSuffix": "· {count} pågår",
    "gamesPlayed": "Spelade spel",
    "meritsEarned": "Intjänade pinnar",
    "vsLastSeason": "{delta} mot förra säsongen",
    "sameAsLastSeason": "Samma som förra säsongen",
    "activeTours": "Pågående tourer",
    "noActiveTours": "Ingen tour pågår just nu.",
    "tourLeading": "av {players} spelare · leder",
    "tourBehind": "av {players} spelare · {merits} pinnar efter",
    "trophyCabinet": "Prisskåp",
    "trophyCabinetNote": "Alla år, oavsett vald period.",
    "tourWins": "Tourvinster",
    "tourRunnerUps": "Andraplatser",
    "tourPodiums": "Pallplatser",
    "roundWins": "Rondvinster",
    "gamesPlayedAndWon": "Spel — spelade och vunna",
    "noGames": "Inga spel spelade under perioden.",
    "gameWinsOfRounds": "{wins} av {rounds}",
    "unknownGame": "Spel",
    "recentRounds": "Senaste ronder",
    "noRounds": "Inga ronder under perioden.",
    "roundScore": "{gross} · {toPar}",
    "positionOf": "{position} av {total}",
    "averageToPar": "Snitt mot par · per 18",
    "bestRound": "Bästa rond",
    "bestRoundAt": "Bästa rond · {course}, {date}",
    "playingHandicap": "Spelhandicap",
    "playingHandicapNote": "Spelhandicapet som registrerats på varje rond, äldst till nyast.",
    "handicapDown": "▼ {delta} under perioden",
    "handicapUp": "▲ {delta} under perioden",
    "formTitle": "Form — score mot par, senaste {count} ronderna",
    "average": "snitt",
    "formLegend": "Kortare är bättre. Tryck på en rond för att öppna scorekortet.",
    "scoreDistribution": "Score · {holes} hål",
    "noHoles": "Inga registrerade hål under perioden.",
    "eagle": "Eagle",
    "birdie": "Birdie",
    "par": "Par",
    "bogey": "Bogey",
    "doublePlus": "Dubbel+",
    "countWithShare": "{count} · {share} %",
    "pickupsExcluded": "{count} upplockade hål räknas inte.",
    "averageOverPar": "Snitt över par",
    "parN": "Par {par}",
    "frontNine": "Ut 9",
    "backNine": "In 9",
    "shotDetail": "Slagdetaljer",
    "fairwaysHit": "Fairwayträffar",
    "greensInRegulation": "Greener på reglementerat",
    "puttsPerRound": "Puttar per rond",
    "puttsPerGir": "Puttar per träffad green",
    "shotDetailOfHoles": "{part} av {total} hål",
    "shotDetailPuttsHint": "{perHole} per hål över {holes} hål",
    "recordsAndStreaks": "Rekord & sviter",
    "mostBirdies": "Flest birdies på en rond",
    "longestStreak": "Längsta svit med par eller bättre",
    "holesCount": "{count} hål",
    "bestComeback": "Bästa in-nia mot ut-nia",
    "holeInOnes": "Hole in one",
    "nemesisHole": "Skräckhål",
    "nemesisValue": "#{hole} {course}",
    "nemesisHint": "{average} i snitt på {plays} spel"
  },
  "teamDraw": {
    "title": "Lottade lag"
  },
  "serviceStatus": {
    "buttonLabel": "Tjänststatus",
    "alert": "!",
    "title": "Tjänster saknas",
    "allOk": "Alla tjänster är igång.",
    "warningsFound": "Varningar eller fel hittades i loggar.",
    "unknownTimestamp": "Okänd tidpunkt",
    "unknownService": "Okänd tjänst",
    "unknownBody": "Ingen loggtext",
    "continueMissing": "Fortsätt (saknas: {missing})",
    "close": "Stäng",
    "checkedAt": "Kontrollerad: {time}",
    "bffName": "backend-for-frontend-service",
    "host": "Värd: {host}",
    "httpCode": "Returkod: {code}",
    "unknownHost": "Okänd värd",
    "envVar": "Miljövariabel: {envVar}",
    "unknownEnvVar": "Miljövariabel: okänd",
    "ipAddress": "Uppslagen IP: {ip}"
  },
  "debug": {
    "button": "Debug",
    "buttonLabel": "Debug-information",
    "title": "Debug-info",
    "userLabel": "Användare",
    "userIdLabel": "Användar-ID",
    "playerIdLabel": "Spelar-ID",
    "roundLabel": "Rond-ID",
    "roundNameLabel": "Rondnamn",
    "tourLabel": "Tour-ID",
    "tourNameLabel": "Tournamn",
    "holeViewTraceLabel": "TraceId hålvy",
    "holeScoreTraceLabel": "TraceId hålscore",
    "traceNone": "Ingen",
    "copyIdsLabel": "Kopiera debug-ID",
    "copyIdLabel": "Kopiera {label}",
    "loading": "Hämtar namn...",
    "unknown": "Okänt",
    "close": "Stäng",
    "disable": "Stäng av debug",
    "resetCoachMarks": "Återställ coach marks",
    "resetCoachMarksRunning": "Återställer coach marks...",
    "resetCoachMarksSuccess": "Coach marks återställda för användaren.",
    "resetCoachMarksError": "Kunde inte återställa coach marks.",
    "coachMarksTitle": "Coach marks",
    "coachMarksEmpty": "Inga coach marks laddades.",
    "coachMarkLabel": "Coach mark: {key}",
    "deeplinkTitle": "Deep link-debugg",
    "deeplinkPlatform": "Plattform",
    "deeplinkLatest": "Senaste URL",
    "deeplinkEmpty": "Ingen deep link mottagen ännu.",
    "coachMarkDismissed": "dolt"
  },
  "welcome": {
    "title": "Välkommen",
    "body": "Välj hur du vill starta: skapa en enkel runda, starta en ny tour eller öppna dina befintliga tours och ej avslutade rundor.",
    "startSingleRound": "Starta enkel runda",
    "startQuickRound": "Snabbrunda",
    "startTour": "Skapa tour",
    "myTours": "Mina tours och rundor",
    "myToursOpenSummary": "Öppna tours: {tours} · Enkla rundor: {singleRounds}",
    "myToursNav": "Mina rundor"
  },
  "quickRound": {
    "trackingTitle": "Registrera"
  },
  "friendInvite": {
    "title": "Bli vänner",
    "showTitle": "Låt dem skanna den här",
    "showSubtitle": "Rikta den andra telefonens kamera mot koden",
    "expiryNote": "Koden förnyas med några minuters mellanrum",
    "shareAction": "Dela länk",
    "shareError": "Kunde inte dela länken.",
    "loadError": "Kunde inte skapa en inbjudningskod.",
    "regenerate": "Ny kod",
    "close": "Stäng",
    "previewTitle": "{name} vill bli vän",
    "previewUnknown": "Någon vill bli vän på Goffy",
    "signInToConnect": "Logga in för att ansluta",
    "connecting": "Ansluter...",
    "connected": "Du och {name} är nu vänner",
    "alreadyConnected": "Du är redan vän med {name}",
    "seeFriends": "Visa mina vänner",
    "errorExpired": "Koden har gått ut. Be om en ny.",
    "errorInvalid": "Inbjudningslänken är inte giltig.",
    "errorSelf": "Det är din egen inbjudningskod.",
    "errorPlayerRequired": "Det här kontot kan inte läggas till som vän ännu.",
    "errorUnauthenticated": "Logga in för att ansluta.",
    "errorFailed": "Kunde inte ansluta. Försök igen."
  },
  "friends": {
    "connectViaQr": "Anslut via QR",
    "title": "Vänner",
    "loading": "Laddar vänner...",
    "empty": "Inga vänner tillagda ännu.",
    "myFriends": "Mina vänner",
    "linked": "Vän",
    "addLinked": "Lägg till en vän",
    "searchPlaceholder": "Sök på namn eller Golf-ID",
    "add": "Lägg till",
    "remove": "Ta bort",
    "editNickname": "Redigera smeknamn",
    "cancel": "Avbryt",
    "nicknamePlaceholder": "Smeknamn (valfritt)",
    "saveNickname": "Spara smeknamn",
    "actionFailed": "Kunde inte uppdatera vänner.",
    "findPlayersPlaceholder": "Hitta spelare...",
    "filterAll": "Alla",
    "filterLinked": "Vänner",
    "filterGuests": "Mina gäster",
    "guest": "Gäst",
    "countAll": "Spelare {count}",
    "countLinked": "Vänner {count}",
    "countGuests": "Mina gäster {count}",
    "guestsEmpty": "Inga gästspelare tillagda ännu.",
    "guestsFailed": "Kunde inte ladda dina gästspelare.",
    "noMatches": "Inga vänner matchar din sökning.",
    "searchHint": "Skriv ett namn, eller ett exakt Golf-ID för att hitta spelare som bara går att hitta så.",
    "searchNoResults": "Inga spelare matchar din sökning.",
    "searchFailed": "Kunde inte söka spelare.",
    "searching": "Söker..."
  },
  "coachMarks": {
    "tournamentsCreateTitle": "Skapa din första tour",
    "tournamentsCreateBody": "Använd knappen för att skapa en ny tour och gå vidare till rundinställningar.",
    "profileImageActionsTitle": "Välj profilbild",
    "profileImageActionsBody": "Ladda upp en bild eller välj en avatar som visas tillsammans med ditt namn.",
    "holeScoreTitle": "Tips för score-raden",
    "holeScoreBody": "Tryck på Score för att öppna poänginmatning och registrera hazard- eller mystery-resultat.",
    "gotIt": "Jag förstår",
    "hideForever": "Visa inte det här tipset igen",
    "disableAll": "Stäng av alla tips"
  },
  "courseConfig": {
    "title": "Konfigurera bana",
    "manageSelectorLabel": "Bana att hantera",
    "manageCreateNew": "Ny bana",
    "manageSelectedCourse": "Vald bana",
    "manageNoCourses": "Inga banor att hantera än",
    "manageSearchPlaceholder": "Sök bana, klubb eller ort",
    "manageNoMatches": "Ingen bana matchar ”{query}”",
    "clubLabel": "Klubb",
    "clubPlaceholder": "Klubbnamn",
    "cityLabel": "Ort",
    "clubWebsiteLabel": "Klubbens webbplats",
    "clubWebsitePlaceholder": "https://exempel.se",
    "cityPlaceholder": "Ortnamn",
    "coordinatesLabel": "Koordinater",
    "courseLabel": "Bana",
    "coursePlaceholder": "Bannamn",
    "scanButton": "AI-skanna scorekort",
    "cameraCapture": "Ta bild",
    "cameraCancel": "Avbryt",
    "cameraUnavailable": "Kunde inte öppna kameran. Kontrollera kamerabehörigheter och försök igen.",
    "scanRunning": "AI:n läser scorekortet…",
    "scanThinkingHint": "Analyserar bilden — det kan ta upp till en minut.",
    "scanSuccess": "Scorekortet inläst — kontrollera värdena.",
    "scanFailed": "Kunde inte läsa scorekortet. Ange hålen manuellt.",
    "scanNotConfigured": "Skanning av scorekort är inte konfigurerat på servern än.",
    "scanPermissionDenied": "Kameratillstånd krävs för att skanna.",
    "holeHeader": "Hål",
    "parHeader": "Par",
    "strokeIndexHeader": "Index",
    "teesTitle": "Tee-inställning",
    "addTeeButton": "Lägg till tee",
    "teeLabel": "Tee {index}",
    "removeTeeButton": "Ta bort",
    "teeNameLabel": "Tee-namn",
    "teeNamePlaceholder": "Gul",
    "teeGenderLabel": "Kön",
    "genderMale": "Man",
    "genderFemale": "Kvinna",
    "genderUnisex": "Unisex",
    "teeColorLabel": "Tee-färg",
    "teeColorPlaceholder": "gul",
    "teeParLabel": "Tee par",
    "makeOfficialLabel": "Lägg till bland officiella banor",
    "makeOfficialHint": "Officiella banor delas med alla. Lämna omarkerad för att hålla banan privat för dig.",
    "disableCourseLabel": "Inaktivera den här banan",
    "disableCourseHint": "En inaktiverad bana döljs från alla banval men raderas inte. Avmarkera och spara för att återställa den.",
    "visibilityLabel": "Synlighet",
    "visibility_official": "Officiell",
    "visibility_private": "Privat",
    "visibility_pending": "Väntar",
    "visibilityHint_official": "Delas med alla.",
    "visibilityHint_private": "Syns bara för dig och spelare du delar den med.",
    "visibilityHint_pending": "Inskickad för godkännande; syns bara för dig tills den godkänts.",
    "courseRatingLabel": "Course rating",
    "slopeRatingLabel": "Slope rating",
    "cancelButton": "Avbryt",
    "saveButton": "Spara bana",
    "saving": "Sparar bana...",
    "waitingConnection": "Väntar på websocket-anslutning...",
    "saveSuccess": "Bana sparad {id}",
    "saveRejected": "Det gick inte att spara banan.",
    "clubRequired": "Klubbnamn måste anges.",
    "courseRequired": "Bannamn måste anges.",
    "invalidPar": "Alla hål måste ha ett parvärde.",
    "invalidStrokeIndex": "Alla hål måste ha ett index.",
    "teesRequired": "Lägg till minst en tee.",
    "teeNameRequired": "Alla tees måste ha ett namn.",
    "teeGenderRequired": "Alla tees måste ha ett kön.",
    "invalidCourseRating": "Alla tees måste ha ett giltigt course rating-värde.",
    "invalidSlopeRating": "Alla tees måste ha ett giltigt slope rating-värde.",
    "invalidTeePar": "Alla tees måste ha ett giltigt parvärde.",
    "fixBeforeSave": "Åtgärda följande innan du sparar:",
    "saveWithErrorsLabel": "Spara ändå (med fel)",
    "parSumMismatch": "Summan av alla håls par ({sum}) måste vara lika med Tee par ({teePar}).",
    "strokeIndexDuplicate": "Index {value} används av fler än ett hål (hål {holes}). Varje index får bara användas en gång.",
    "strokeIndexRange": "Index måste vara ett tal mellan 1 och 18 (hål {hole} har {value}).",
    "lengthHeader": "Längd (m)",
    "invalidLength": "Hållängden måste vara ett positivt tal, eller lämnas tom om den är okänd.",
    "osmButton": "Importera data från OpenStreetMap",
    "osmSearching": "Söker…",
    "osmImporting": "Importerar hål…",
    "osmUnnamed": "Namnlös bana",
    "osmSuccess": "Importerade {count} hål — kontrollera värdena.",
    "osmPartial": "Importerat. {count} index gick inte att läsa i OpenStreetMap, så de lämnades orörda.",
    "osmNoCourses": "Hittade ingen bana i OpenStreetMap med användbar data.",
    "osmNoHoles": "Den banan har inga hål kartlagda i OpenStreetMap.",
    "osmNoLocation": "Kunde inte fastställa någon position att söka utifrån.",
    "osmFailed": "Sökningen i OpenStreetMap misslyckades. Försök igen.",
    "osmAttribution": "Håldata © OpenStreetMap-bidragsgivare (ODbL)",
    "osmSearch": "Sök",
    "osmModeNearby": "I närheten",
    "osmModeName": "På namn",
    "osmNamePlaceholder": "Bana eller klubb",
    "osmNameTooShort": "Ange minst tre tecken för att söka på namn.",
    "osmChooseData": "Välj vad som ska importeras:",
    "osmCategoryHoles": "Hålinformation",
    "osmCategoryHolesDetail": "{count} hål med par och index",
    "osmCategoryTees": "Tees",
    "osmCategoryTeesDetail": "{count} namngivna tees",
    "osmCategoryGps": "GPS",
    "osmCategoryGpsDetail": "{greens} greenpositioner, {tees} teepositioner",
    "osmCategoryTerrain": "Bunkrar, vatten och fairways",
    "osmCategoryTerrainDetail": "{count} inritade konturer — används i stället för dem som hittas i satellitbilder",
    "osmImportAction": "Importera",
    "osmBack": "Tillbaka",
    "osmImportSummary": "Importerade {holes} hål, {tees} teeuppsättningar och {positions} positioner — kontrollera värdena.",
    "osmDistanceMeta": "{distance} m bort",
    "osmNothingToImport": "OpenStreetMap har ingenting om den banan — inte ens en position.",
    "osmCategoryPosition": "Banans position",
    "osmCategoryPositionDetail": "Var banan ligger. Räcker i sig för att analysera satellitbilder efter greener, bunkrar och vatten.",
    "osmImportSummaryWithPosition": "Importerade {holes} hål, {tees} teeuppsättningar och {positions} positioner samt banans position — satellitbilder analyseras inom kort.",
    "osmImportSummaryPositionOnly": "Banans position är satt. OpenStreetMap har inga hål, tees eller greener för banan, så satellitbilder analyseras för att hitta dem.",
    "osmCategoryGpsApproximate": "{greens} greenpositioner, {tees} teepositioner — hämtade från hålens sträckning, på några meter när, en per hål",
    "osmLoadingCounts": "Kollar vad OpenStreetMap har för den här banan…",
    "osmCoordinateLine": "{origin} {originCoords} · OSM {osmCoords} · {distance}",
    "osmOriginStored": "Sparad",
    "osmOriginDevice": "Enhet",
    "osmOriginMap": "Vald",
    "osmPositionUseOsm": "OSM-position ({distance} bort)",
    "osmPositionUsePicked": "Min valda position",
    "osmPickLocation": "Välj plats på karta",
    "osmUsePickedAnyway": "Ingen av dessa — använd den valda platsen ändå",
    "osmMapUseMyLocation": "Använd min nuvarande plats",
    "osmMapLocateDenied": "Platsbehörighet gavs inte.",
    "osmMapLocateFailed": "Kunde inte fastställa enhetens plats.",
    "osmMapGotoPlaceholder": "Latitud, longitud",
    "osmMapGotoInvalid": "Kunde inte tolka det som en latitud och longitud. Prova \"56.6776, 12.8578\".",
    "osmMapGo": "Gå",
    "osmMapConfirm": "Sök härifrån",
    "osmMapUseAsPosition": "OSM har inget här — använd denna exakta plats",
    "osmMapCancel": "Avbryt",
    "osmMapHint": "Dra kartan så att hårkorset ligger över banan, och bekräfta sedan.",
    "osmMapPlacePlaceholder": "Sök efter en plats",
    "osmMapPlaceTooShort": "Skriv minst 3 tecken.",
    "osmMapPlaceFailed": "Platssökningen misslyckades.",
    "osmMapPlaceNoResults": "Inga platser hittades.",
    "osmDebugToggle": "Debug · {count} loggade",
    "osmDebugEmpty": "Inget loggat än.",
    "osmDebugCurlHint": "Kommandona använder $GOFFY_TOKEN — exportera din bearer-token innan du kör dem.",
    "osmDebugCopy": "Kopiera kommando",
    "osmHolesUnnumbered": "OpenStreetMap har {drawn} hålmarkering(ar) för banan, men {unnumbered} av dem saknar hålnummer — importen behöver ett numrerat hål (OSM-taggen ref=1…18) för att veta vilket hål som är vilket.",
    "osmHolesAmbiguous": "Hålnummer {holes} används av mer än en hålmarkering här, oftast för att flera banor delar anläggning. De lämnades utanför scorekortet i stället för att gissas; markeringarna importeras och analyseras ändå.",
    "osmTerrainNoHoles": "Bunkrar, vatten och fairways importerades inte: OpenStreetMap saknar numrerade hålmarkeringar för banan att koppla dem till."
  },
  "tournaments": {
    "title": "Tävlingar",
    "loading": "Laddar tours...",
    "menuLabel": "Tourval",
    "showFinished": "Visa avslutade",
    "hideFinished": "Dölj avslutade",
    "showFinishedSingleRounds": "Visa avslutade enkla rundor",
    "hideFinishedSingleRounds": "Dölj avslutade enkla rundor",
    "statusContinue": "Fortsätt",
    "statusPause": "Pausa",
    "statusArchive": "Arkivera",
    "statusSleep": "Viloläge",
    "statusCancel": "Avbryt",
    "statusDelete": "Radera",
    "deleteConfirmTitle": "Radera touren?",
    "deleteConfirmMessage": "\"{name}\" tas bort från dina tourer. Detta kan inte ångras.",
    "deleteConfirmCta": "Radera",
    "deleteConfirmKeep": "Behåll",
    "deleteRoundConfirmTitle": "Radera rundan?",
    "deleteRoundConfirmMessage": "\"{name}\" tas bort från dina rundor. Detta kan inte ångras.",
    "statusUpdateSent": "Uppdaterar status till {status}...",
    "statusUpdateAck": "Tourstatus uppdaterad.",
    "statusUpdateFailed": "Kunde inte uppdatera tourstatusen.",
    "statusUpdateQueued": "Väntar på websocket...",
    "archiveTitle": "Tour uppdaterad",
    "archiveMessage": "Tourstatus uppdaterades.",
    "loadError": "Det gick inte att hämta tours.",
    "empty": "Ingen tour hittades. Skapa en ny.",
    "noTours": "Ingen tour hittades.",
    "defaultName": "Ny tour",
    "namePlaceholder": "Tour namn",
    "createTitle": "Ny tour",
    "nameLabel": "Namn",
    "nameRequired": "Ge touren ett namn först.",
    "createConfirm": "Skapa",
    "createCancel": "Avbryt",
    "statusFinish": "Avsluta tour",
    "statusFinishConfirm": "Avsluta den här touren? Slutställningen låses och tourpoängen delas ut. Du kan öppna den igen senare.",
    "statusReopen": "Öppna tour igen",
    "statusFinishRound": "Avsluta rundan",
    "statusFinishRoundConfirm": "Avsluta den här rundan? Resultaten låses och räknas ihop.",
    "roundMenuLabel": "Rundval",
    "creating": "Skapar tour...",
    "createCta": "Ny tour",
    "singleRoundCta": "Enkel runda",
    "createdNotice": "Ny tour har skapats. Välj tour från listan.",
    "createdWithId": "Tour skapad: {id}",
    "createFailed": "Kunde inte skapa tour just nu. Försök igen.",
    "membersTitle": "Tourmedlemmar",
    "membersLoading": "Laddar spelare...",
    "membersCount": "Valda: {selected}/{max}",
    "membersLoadError": "Det gick inte att ladda plattformsspelare.",
    "playerProvisioning": "Skapar din spelarprofil...",
    "playerProvisioningRetry": "Spelarprofilen är försenad. Försök igen.",
    "playerProvisioningTimeout": "Tiden gick ut för att skapa spelarprofilen. Försök igen.",
    "playerProvisioningActionRetry": "Försök igen",
    "playerProvisioningBlocked": "Vänta tills din spelarprofil är klar innan du skapar en tour.",
    "creatorMemberLocked": "Din spelare är alltid med i touren och kan inte tas bort.",
    "creatorMemberRequired": "Din spelarprofil måste vara med innan du kan skapa en tour.",
    "shareCta": "Dela",
    "shareTitle": "Dela {name}",
    "shareSubtitle": "Alla med länken kan se live-resultat för touren.",
    "shareAction": "Dela länk",
    "shareClose": "Stäng",
    "shareLoadError": "Kunde inte skapa en inbjudningslänk för den här touren.",
    "shareSendError": "Det gick inte att dela inbjudningslänken på den här enheten.",
    "shareCopied": "Inbjudningslänk kopierad.",
    "openButton": "Öppna",
    "newRoundCta": "Lägg till runda",
    "roundsTitle": "Rundor",
    "unfinishedRoundsTitle": "Ej avslutade rundor",
    "hiddenToursSingleRoundsTitle": "Enkla rundor",
    "roundsLoading": "Laddar rundor...",
    "roundsEmpty": "Inga rundor hittades.",
    "roundsLoadError": "Det gick inte att ladda rundor.",
    "myToursAndRoundsSummary": "Tours: {tours} · Ej avslutade rundor: {rounds}",
    "roundFallbackName": "Runda",
    "roundOpen": "Öppna",
    "roundStart": "Starta",
    "roundUpdate": "Uppdatera",
    "roundSettings": "Rondinställningar",
    "tourSettings": "Tourinställningar",
    "roundResults": "Resultat",
    "roundStatus": "Status: {status}",
    "roundStatusWithDate": "Status: {status} · {date}",
    "editCta": "Redigera",
    "gamesTitle": "Spel",
    "gamesCount": "{count} spel",
    "gamesLoading": "Laddar spel...",
    "gamesEmpty": "Inga spel valda.",
    "gamesLoadError": "Det gick inte att ladda spel.",
    "groupsLoading": "Laddar grupper...",
    "groupsLoadError": "Det gick inte att ladda grupper.",
    "gameFallbackName": "Spel",
    "gameTypeUnknown": "Övrigt",
    "gameTypeLabel": "Typ:",
    "gameTypeMissing": "Typ: Okänd",
    "gameWeightLabel": "Vikt",
    "gameDetailsTitle": "Speldetaljer",
    "gameDetailsEmpty": "Ingen beskrivning tillgänglig.",
    "gameCalculationLabel": "Beräkning:",
    "addGame": "Lägg till spel",
    "addGameTitle": "Lägg till spel",
    "addGameEmpty": "Alla spel är redan tillagda."
  },
  "tourEdit": {
    "playersTitle": "Spelare",
    "addPlayer": "Lägg till spelare",
    "removePlayer": "Ta bort",
    "playerCreateTemporary": "Skapa tillfällig",
    "playerTemporarySelected": "Tillfällig vald",
    "playerSearchPlaceholder": "Sök spelare",
    "playerCurrentUserFallback": "Du",
    "playerConfirmSelectOrTemporary": "Välj en befintlig spelare eller markera som tillfällig innan du bekräftar.",
    "playerConfirmEmpty": "Ange ett spelarnamn innan du bekräftar.",
    "playerAlreadyInTour": "Spelaren finns redan i touren.",
    "playerConfirmA11y": "Bekräfta spelarrad",
    "playerCancelA11y": "Avbryt spelarrad",
    "playerTemporaryToggleA11y": "Växla tillfällig spelare",
    "playerInviteTooltip": "Bjud in",
    "playerInviteA11y": "Bjud in {name}",
    "playerInviteTitle": "Bjud in {name}",
    "playerInviteSubtitle": "Dela den här länken med {name} för att gå med i touren.",
    "playerInviteLoadError": "Kunde inte skapa en inbjudningslänk för den här spelaren.",
    "playerInviteShareError": "Det gick inte att dela inbjudningslänken.",
    "playerInviteCopied": "Inbjudningslänk kopierad.",
    "title": "Tour redigering",
    "breadcrumbTitle": "Tävling - redigering",
    "subtitle": "Webbversion",
    "backToTours": "Till tours",
    "tourIdLabel": "Tour-ID",
    "tourIdMissing": "Tour-ID saknas.",
    "webOnlyNote": "Den här sidan finns bara på webben.",
    "nameLabel": "Tour-namn",
    "namePlaceholder": "Ange tournamn",
    "saveCta": "Spara",
    "saving": "Sparar...",
    "saveSent": "Sparar tour...",
    "saveQueued": "Väntar på websocket...",
    "saveAck": "Tour uppdaterad.",
    "saveFailed": "Det gick inte att uppdatera tour.",
    "saveAll": "Spara alla",
    "saveAllSent": "Sparar alla inställningar...",
    "loading": "Laddar tour...",
    "loadError": "Det gick inte att ladda tour.",
    "nameRequired": "Ange ett tournamn.",
    "addRound": "Lägg till runda",
    "roundNameLabel": "Rundanamn",
    "roundDateLabel": "Speldatum",
    "roundDateUnset": "Välj datum",
    "roundDatePicker": "Öppna kalender",
    "roundDatePickerTitle": "Välj datum",
    "roundDatePickerToday": "Idag",
    "roundCreate": "Skapa runda",
    "roundCreateSaving": "Skapar...",
    "roundCreateFailed": "Det gick inte att skapa rundan.",
    "roundCreateNoPlayers": "Inga spelare hittades för tävlingen.",
    "roundCreatePlayerLoading": "Laddar spelare...",
    "addImage": "Lägg till bild",
    "uploadingImage": "Laddar upp bild...",
    "imageUploadFailed": "Det gick inte att ladda upp bilden.",
    "imagePermissionDenied": "Goffy behöver åtkomst till dina bilder för att ange en tourbild.",
    "imageUploadSuccess": "Tävlingsbilden uppdaterad.",
    "roundPlayersTitle": "Rundspelare",
    "roundPlayersLoading": "Laddar rundspelare...",
    "roundPlayersEmpty": "Inga spelare i rundan ännu.",
    "memberRemoving": "Tar bort spelare från touren...",
    "memberRemoveSent": "Tar bort spelare från touren...",
    "memberRemoved": "Spelaren togs bort från touren.",
    "memberRemoveRejected": "Det gick inte att ta bort spelaren från touren.",
    "memberRemoveTimeout": "Tidsgränsen för borttagning av tourspelare överskreds.",
    "roundMemberRemoving": "Tar bort spelare från rundan...",
    "roundMemberRemoveSent": "Tar bort spelare från rundan...",
    "roundMemberRemoved": "Spelaren togs bort från rundan.",
    "roundMemberRemoveRejected": "Det gick inte att ta bort spelaren från rundan.",
    "roundMemberRemoveTimeout": "Tidsgränsen för borttagning av rundspelare överskreds.",
    "removeRound": "Ta bort runda",
    "roundRemoving": "Tar bort runda...",
    "roundRemoveSent": "Tar bort runda...",
    "roundRemoved": "Rundan togs bort.",
    "roundRemoveRejected": "Det gick inte att ta bort rundan.",
    "roundRemoveTimeout": "Tidsgränsen för borttagning av runda överskreds.",
    "roundRemoveBlockedScores": "Rundan har registrerade scorer",
    "roundRemoveA11y": "Ta bort runda",
    "roundPlayerRemoveBlockedScores": "Har registrerade scorer",
    "roundPlayerRemoveBlockedLastPlayer": "Sista spelaren i rundan",
    "roundPlayerRemoveA11y": "Ta bort spelare från rundan",
    "roundPlayerRemoveDisabledA11y": "Spelaren kan inte tas bort från rundan",
    "roundAddPlayer": "Lägg till spelare",
    "roundAddPlayerPlaceholder": "Välj tourmedlem",
    "roundAddPlayerNoCandidates": "Inga tillgängliga tourmedlemmar att lägga till.",
    "roundAddPlayerStatusBlocked": "Rundstatus tillåter inte att spelare läggs till.",
    "tournamentGamesTitle": "Turneringsspel",
    "tournamentGamesEmpty": "Inga turneringsspel valda.",
    "tournamentAddGame": "Lägg till turneringsspel",
    "tournamentRemoveGame": "Ta bort",
    "tournamentManagedLabel": "Turneringsstyrt",
    "gameDetailsPanelTitle": "Speldetaljer",
    "gameDetailsEmptyState": "Välj ett spel för att se detaljer.",
    "gameDetailsScopeLabel": "Omfattning:",
    "gameDetailsTypeLabel": "Typ:",
    "gameScopeLibrary": "Bibliotek",
    "gameScopeTournament": "Turnering",
    "gameScopeRoundLocal": "Rundlokalt",
    "cancelRound": "Avbryt",
    "done": "Klar",
    "playerSearchNoResults": "Inga spelare hittades.",
    "sidebarTourSettings": "Tourinställningar",
    "sidebarTourBasics": "Grundinställningar",
    "sidebarGames": "Spel",
    "sidebarRounds": "Rundor",
    "sidebarRoundSettings": "Inställningar",
    "sidebarGoToRound": "Gå till rundan →",
    "sidebarDeleteRoundA11y": "Ta bort {name}",
    "roundFallbackName": "Runda",
    "roundFallbackNumbered": "Runda {number}",
    "mobileMenu": "Meny",
    "mobileBackToMenuA11y": "Tillbaka till menyn",
    "navPromptNext": "Vad vill du göra nu?",
    "navPromptAllDone": "Klart! Vad vill du göra nu?",
    "navPromptNeedsRound": "Touren behöver minst en runda för att kunna spelas.",
    "navAddAnotherRound": "Lägg till en runda till",
    "navConfigureRound": "Ställ in rundan",
    "navAddARound": "Lägg till en runda",
    "navNext": "Nästa",
    "breadcrumbTours": "Tourer",
    "breadcrumbTourFallback": "Tour",
    "breadcrumbEdit": "Redigera",
    "deleteRoundTitle": "Ta bort runda",
    "deleteRoundMessage": "Är du säker på att du vill ta bort \"{name}\"? Det går inte att ångra.",
    "deleteRoundMessageWithScores": "\"{name}\" har registrerade scores. Om du tar bort rundan raderas alla dess scores och resultat permanent. Det går inte att ångra.",
    "confirmDelete": "Ta bort",
    "confirmCancel": "Avbryt",
    "nameHint": "Visas på tourkortet och i resultatlistan.",
    "imageLabel": "Tourbild",
    "imageHint": "Valfritt. Gör det lättare att skilja dina tourer åt.",
    "imageUploading": "Laddar upp…",
    "changeImage": "Byt bild",
    "roundSettingsTitle": "Rundinställningar",
    "roundTitleLabel": "Titel (valfritt)",
    "roundTitlePlaceholder": "t.ex. Lördagsrundan",
    "roundDateSelect": "Välj datum",
    "roundCourseLabel": "Bana",
    "roundCoursesLoading": "Laddar banor...",
    "roundCourseSelected": "Vald",
    "roundHolesCountLabel": "Antal hål",
    "roundHolesCountOption": "{count} hål",
    "roundPlayerBench": "Till bänken",
    "roundPlayerSwap": "Byt",
    "roundPlayerSwapHint": "Välj en spelare från ett annat lag att byta med.",
    "roundGroupTitle": "GRUPP {number}",
    "roundTeamLabel": "Lag {number}",
    "roundBenchTitle": "BÄNKEN",
    "roundBenchCount": "{count} SPELARE",
    "roundBenchEmpty": "Alla tourens spelare är med i rundan",
    "tourPlayersTitle": "Tourspelare",
    "tourPlayerRemoveA11y": "Ta bort {name}",
    "tourPlayerAddPlaceholder": "Lägg till spelare i touren...",
    "tourPlayerFriendBadge": "Vän",
    "tourPlayerAddAsNew": "Lägg till \"{name}\" som ny spelare",
    "tourPlayersOverLimit": "Touren har {count} spelare, fler än gränsen på {max}. Ta bort någon innan du lägger till fler.",
    "tourPlayersMaxReached": "Max {max} spelare uppnått",
    "tourPlayerRemoveTitle": "Ta bort spelare",
    "tourPlayerRemoveMessage": "Ta bort {name} från touren? Spelaren tas också bort från alla rundor.",
    "tourPlayerRemoveFallbackName": "den här spelaren",
    "tourGamesTitle": "Tourspel",
    "roundGamesTitle": "Rundspel",
    "gamesEmpty": "Inga spel tillgängliga",
    "roundGamesHint": "Tourens spel ingår automatiskt och kan inte tas bort. Övriga spel kan slås på och av.",
    "roundGameLockedTour": "Tour"
  },
  "auth": {
    "loginTitle": "Logga in",
    "loginCardTitle": "Välkommen tillbaka",
    "loginCta": "Login",
    "loggingIn": "Loggar in...",
    "loginSubtitle": "Inloggning",
    "loginHint": "Du skickas till Keycloak för att logga in.",
    "debugLabel": "Inloggad",
    "debugNone": "Ingen",
    "callbackLoading": "Slutför inloggning...",
    "callbackReady": "Väntar på svar från Keycloak",
    "continueWithGoogle": "Fortsätt med Google",
    "orDivider": "eller"
  },
  "login": {
    "userNotFound": "Din anvandare finns inte langre. Logga in igen."
  },
  "start": {
    "title": "Välkommen till Goffy",
    "subtitle": "Ange en inbjudningskod om du har en, eller fortsätt med ett nytt eller befintligt konto.",
    "roundCodeLabel": "Inbjudningskod",
    "roundCodePlaceholder": "Ange inbjudningskod",
    "roundCodeRequired": "Ange en inbjudningskod för att fortsätta.",
    "roundCodeInvalid": "Den inbjudningskoden kunde inte hittas.",
    "roundCodeLookupFailed": "Det gick inte att öppna inbjudningskoden. Försök igen.",
    "joinWithCodeCta": "Gå med med kod",
    "scanQrCta": "Skanna QR-kod",
    "qrScanTitle": "Skanna QR-kod för inbjudan",
    "qrScanSubtitle": "Rikta kameran mot QR-koden från inbjudan till touren eller ronden.",
    "qrScanCancelCta": "Avbryt",
    "qrScanGrantCta": "Tillåt kameran",
    "qrScanPermissionPrompt": "Goffy behöver kameran för att läsa QR-koden för inbjudan.",
    "qrScanPermissionDenied": "Åtkomst till kameran nekades, så QR-koden kan inte läsas.",
    "qrScanPermissionBlocked": "Åtkomst till kameran är blockerad. Tillåt kameran för Goffy i inställningarna för enheten eller webbläsaren och försök igen.",
    "qrScanUnrecognized": "QR-koden är inte en inbjudan från Goffy.",
    "qrScanFriendInvite": "Det är en vänförfrågan. Logga in först och skanna den sedan igen.",
    "resumeClaimTitle": "Fortsätt som {name}",
    "resumeClaimBody": "Du för fortfarande resultat i {tour} på den här enheten. Ingen inloggning behövs.",
    "resumeClaimCta": "Fortsätt föra resultat",
    "resumeClaimLeaderboardCta": "Öppna tourens leaderboard",
    "resumeClaimFallbackName": "din spelare",
    "resumeClaimFallbackTour": "touren",
    "signUpCta": "Skapa konto",
    "logInCta": "Logga in",
    "emailLabel": "E-post",
    "emailPlaceholder": "du@exempel.se",
    "passwordLabel": "Lösenord",
    "passwordPlaceholder": "Ange lösenord",
    "orDivider": "eller",
    "googleCta": "Fortsätt med Google",
    "forgotPasswordCta": "Glömt lösenord?",
    "credentialsRequired": "Ange din e-post och ditt lösenord.",
    "loginFailed": "Fel e-post eller lösenord.",
    "watchBoardCta": "Visa resultattavla",
    "boardCodeInvalid": "Den tavelkoden hittades inte.",
    "boardCodeLookupFailed": "Kunde inte öppna tavelkoden. Försök igen.",
    "boardCodeNoRound": "Tavelkoden har ingen runda att visa än."
  },
  "register": {
    "title": "Skapa konto",
    "cardTitle": "Skapa ditt konto",
    "usernameLabel": "Användarnamn",
    "usernamePlaceholder": "dittnamn",
    "displayNameLabel": "Visningsnamn",
    "displayNamePlaceholder": "Ditt smeknamn",
    "emailLabel": "E-post",
    "emailPlaceholder": "namn@example.com",
    "passwordLabel": "Lösenord",
    "passwordPlaceholder": "Minst 6 tecken",
    "creating": "Skapar...",
    "createCta": "Skapa konto",
    "connectionLabel": "BFF-anslutning: {status}",
    "connectionUp": "aktiv",
    "connectionDown": "frånkopplad",
    "backToLogin": "Till startsidan",
    "statusQueued": "Skickar förfrågan...",
    "statusSuccess": "Konto skapat! Logga in med din e-post och ditt lösenord.",
    "validationMissing": "Ange e-post, visningsnamn och lösenord.",
    "validationPasswordTooShort": "Lösenordet måste vara minst {min} tecken.",
    "connectionMissing": "Ingen anslutning till BFF. Försök igen.",
    "createTimeout": "Skapa-förfrågan tog för lång tid. Försök igen.",
    "userExists": "En användare med den e-posten finns redan.",
    "createFailed": "Kunde inte skapa användare.",
    "openTermsCta": "Tjänstevillkor",
    "openPrivacyCta": "Integritetspolicy",
    "claimAdoptNotice": "Du skapar ett konto för {name}. Dina hittillsvarande resultat behålls.",
    "claimProofInvalid": "Din spelare kunde inte verifieras. Öppna inbjudningslänken och gör anspråk på din spelare igen.",
    "statusReconnecting": "Anslutningen bröts — vi slutför registreringen...",
    "termsNotice": "Genom att skapa ett konto godkänner du tjänstens villkor och integritetspolicy.",
    "loginInsteadCta": "Logga in i stället",
    "emailSuggestion": "Menade du {email}?",
    "emailSuggestionApply": "Använd den adressen",
    "emailSuggestionDismiss": "Behåll det jag skrev"
  },
  "home": {
    "addPlayers": "+ Lägg till spelare",
    "maxPlayers": "Max {count} spelare",
    "namePlaceholder": "Ange namn",
    "primaryCta": "Välj spel",
    "saveError": "Det gick inte att spara spelare.",
    "saving": "Sparande...",
    "scpPlaceholder": "SHCP",
    "scpRequired": "Ange spel-hcp för alla spelare.",
    "title": "Lägg till spelare",
    "playerLabel": "Spelare {index}",
    "validationRequired": "Ange minst en spelare."
  },
  "selectGames": {
    "title": "Välj spel",
    "waiting": "Väntar på tour-ID...",
    "tourIdLabel": "Aktuellt tour-ID",
    "tourLabel": "Tour",
    "roundLabel": "Runda",
    "playersLabel": "Spelare: {count}",
    "gamesLabel": "Speltyper: {count}",
    "missing": "saknas",
    "hint": "Håll skärmen öppen tills touren är klar.",
    "quickRoundPreparing": "Ställer in din snabbrunda...",
    "quickRoundError": "Kunde inte starta rundan.",
    "gameListTitle": "Välj ett spel",
    "recommendedBadge": "Rekommenderad",
    "gameInfo": "Info",
    "gameDescription": "Beskrivning",
    "infoIcon": "i",
    "gameInfoSetup": "Info och inställningar",
    "infoSetupIcon": "⚙",
    "infoVideoTitle": "Mystery-spel info",
    "infoVideoTitleByGame": "{name} spelinfo",
    "gameNameFallback": "Spel",
    "copyFromRound": "Kopiera från tidigare runda",
    "copyFromRoundTitle": "Kopiera från tidigare runda",
    "copyFromRoundSubtitle": "Hämtar spel och vikter. Allt går att ändra efteråt.",
    "copyFromRoundEmpty": "Ingen av dina tidigare rundor har spel att kopiera än.",
    "copyFromRoundClose": "Stäng",
    "infoDescriptionTitle": "Beskrivning",
    "infoDescriptionEmpty": "Ingen beskrivning tillgänglig.",
    "infoDescriptionExtra": "Det här spelet räknas hål för hål och påverkar rundans totalresultat utifrån sin vikt.",
    "infoGameTypeTitle": "Speltyp",
    "infoGameTypeDefault": "Poängbaserat sidospel",
    "infoWeightTitle": "Viktinställning",
    "infoWeightValue": "Aktuell vikt: {weight}%",
    "infoWeightHelp": "Vikten styr hur mycket spelet påverkar det totala antalet pinnar. 100% ger full effekt, lägre värden minskar påverkan.",
    "infoWeightLockedHelp": "Touren bestämmer vikten. Den kan bara ändras i tourens inställningar.",
    "infoMeritsTitle": "Pinnar",
    "infoMeritsValue": "{merits} {kind}",
    "infoMeritsPosition": "Plats {position}",
    "closeVideo": "Stäng",
    "gameLoadError": "Kunde inte ladda spel",
    "gameStartError": "Kunde inte starta spel",
    "startGame": "Starta spel",
    "startRound": "Starta runda",
    "updateCta": "Spara och fortsätt",
    "tournamentManagedLocked": "Turneringsstyrt",
    "fourballLocked": "Kräver ett antal spelare delbart med 4 ({count} nu)",
    "meritsLabel": "pinnar",
    "meritsPerTeamLabel": "pinnar per lagspelare",
    "meritsPerAchievementLabel": "pinnar per prestation",
    "meritsPerEventLabel": "pinnar per event",
    "meritDistributionTitle": "Pinnfördelning",
    "meritDistributionTotal": "{merits} pinnar till vinnaren",
    "meritDistributionTotalTour": "{merits} pinnar att vinna över {rounds} rundor",
    "meritWeightSetByTour": "Styrs av touren",
    "meritLadderA11y": "Pinnar per placering för {name}: {ladder}, vikt {weight}%",
    "meritLadderMore": "+{count} till",
    "rulesButton": "Regler",
    "rulesSectionTitle": "Regler",
    "rulesTitle": "Regler för {name}",
    "rulesSubtitleRound": "Välj regeluppsättning för den här rundan.",
    "rulesSubtitleTour": "Välj regeluppsättning som nya rundor i touren utgår från.",
    "rulesBack": "Tillbaka",
    "rulesClose": "Stäng",
    "rulesDefaultBadge": "Standard",
    "rulesTourDefaultBadge": "Tourens standard",
    "rulesEmpty": "Det här spelet har en regeluppsättning.",
    "rulesReadOnlyHint": "Bestäms av touren.",
    "rulesNoDescription": "Ingen beskrivning tillgänglig.",
    "rulesA11ySelect": "Använd regeluppsättning {name}",
    "rulesTileLabel": "Regler: {name}",
    "recommendedFor": "Rekommenderas för {count} spelare",
    "roundMissingTitle": "Ingen runda hittades",
    "roundMissingHint": "Gå tillbaka och starta rundan igen.",
    "roundMissingSupport": "Om felet kvarstår, kontakta support.",
    "roundMissingBack": "Tillbaka",
    "starting": "Startar..."
  },
  "roundStartSetup": {
    "title": "Rondinställningar",
    "subtitleNamed": "Konfigurera spelare och spel för {name}",
    "subtitleFallback": "Konfigurera spelare och spel för den här rundan",
    "loading": "Laddar rondstart...",
    "loadError": "Kunde inte ladda rondstart.",
    "playersTitle": "Rondspelare",
    "playersEmpty": "Inga spelare kopplade till rundan.",
    "playingHandicapLabel": "Spel-hcp",
    "playingHandicapPlaceholder": "Spel-hcp",
    "addHandicap": "Ange hcp",
    "editPlayer": "Redigera spelare",
    "playerNameLabel": "Namn",
    "handicapHelp": "Spelarens spel-hcp för den här rundan (-10 till 54).",
    "saveHandicap": "Spara",
    "newPlayer": "Ny spelare",
    "pickFriend": "eller välj en vän",
    "friendTag": "Vän",
    "duplicatePlayerName": "Du har redan en spelare som heter {name}. Sparar du läggs ytterligare en till.",
    "searchFriends": "Sök vänner…",
    "addedPlayers": "Tillagda",
    "hcpSourcePlayer": "Spelarens hcp från senaste ronden här",
    "hcpSourceCalculated": "Beräknad spel-hcp för vald tee",
    "hcpSourceDefault": "Standard – justera till spelarens hcp",
    "hcpSourceProfile": "Spelarens hcp från profilen – justera för banan",
    "groupsTitle": "Grupper och lag",
    "groupsHint": "Dra en spelare till en lagkamrats kort för att gå med i laget, till en annan grupp för att byta plats, eller tryck på två kort för att byta.",
    "groupsLocked": "Grupper är låsta när rundan inte längre är utkast.",
    "groupsEmpty": "Ingen grupplayout tillgänglig.",
    "groupsUneven": "Lagen är ojämna – jämna ut dem innan grupperna kan sparas eller rundan startas.",
    "fourballSkipped": "{name} spelas inte i den här ronden: {count} spelare, kräver ett antal delbart med 4.",
    "groupsNewTeamHint": "Släpp här för att starta ett nytt lag",
    "groupLabel": "Grupp {index}",
    "teamLabel": "Lag {index}",
    "roundTeamsTitle": "Lag för Bästa i laget",
    "roundTeamsHint": "Tryck på en spelare för att flytta hen till nästa lag. Lagmedlemmar kan spela i olika grupper.",
    "roundTeamLabel": "Lag {index}",
    "roundTeamNone": "Inget lag",
    "groupsUpdateSending": "Sparar gruppbyte...",
    "groupsUpdateSaved": "Grupper uppdaterade.",
    "groupsUpdateQueued": "Gruppbyte köat tills websocket är tillbaka.",
    "groupsUpdateRejected": "Kunde inte uppdatera grupper.",
    "groupsUpdateSendFailed": "Kunde inte skicka gruppbyte.",
    "groupsUpdateTimeout": "Tidsgräns nåddes för bekräftelse av gruppbyte.",
    "gamesTitle": "Rondspel",
    "gamesEmpty": "Inga spel kopplade till rundan.",
    "addMoreGamesCta": "Lägg till fler spel",
    "removePlayerCta": "Ta bort",
    "removingPlayer": "Tar bort spelare...",
    "removeQueued": "Borttagning av spelare köad.",
    "removeSent": "Spelaren är borttagen.",
    "removeRejected": "Det gick inte att ta bort spelaren från rundan.",
    "disableGameCta": "Inaktivera",
    "enableGameCta": "Aktivera",
    "gamesUpdateQueued": "Ronduppdatering köad.",
    "gamesUpdateSent": "Rondspel uppdaterade.",
    "updateCta": "Uppdatera",
    "openRoundCta": "Öppna runda",
    "openRoundSending": "Öppnar runda...",
    "openRoundQueued": "Rundans statusuppdatering köad.",
    "openRoundConfirmed": "Rundan är nu aktiv.",
    "openRoundSendFailed": "Kunde inte skicka rundans statusuppdatering.",
    "openRoundTimeout": "Rundan blev inte aktiv i tid. Försök igen."
  },
  "tourLeaderboard": {
    "title": "Tour Leaderboard",
    "tourName": "Tour: {name}",
    "roundCount": "Rundor: {count}",
    "overallTitle": "Total ställning",
    "roundsPlayed": "{count} rundor",
    "highlightsTitle": "Höjdpunkter",
    "highlightBestRound": "Bästa rond",
    "highlightMostWins": "Flest rondsegrar",
    "highlightLatestWinner": "Senaste rondvinnare",
    "highlightLead": "Ledningsmarginal",
    "perGameTitle": "Resultat per spel",
    "winsCount": "{count} segrar",
    "parBetterTitle": "Par eller bättre",
    "albatrossCount": "{count} albatross",
    "eaglesCount": "{count} eagles",
    "birdiesCount": "{count} birdies",
    "parsCount": "{count} par",
    "points": "{points} pinnar",
    "gamePoints": "{points} p",
    "player": "Spelare",
    "total": "Pinnar",
    "gameFallback": "Spel",
    "roundsTitle": "Rundor",
    "roundSectionsTitle": "Rundor",
    "roundSectionTitle": "Runda {round}: {name}",
    "roundMembersEmpty": "Inga medlemmar i den här rundan.",
    "roundRowLabel": "Runda",
    "roundFallback": "Runda",
    "roundEmpty": "Inga poäng ännu.",
    "empty": "Inga resultat ännu.",
    "missingTour": "Ingen tour vald.",
    "goTours": "Gå till tours",
    "loadError": "Kunde inte ladda leaderboard.",
    "wsConnecting": "Ansluter till live leaderboard...",
    "wsWaitingData": "Ansluten. Väntar på leaderboard-data...",
    "wsRetrying": "Väntar fortfarande på leaderboard-data (försök {count}).",
    "unknownPlayer": "Okänd spelare",
    "resultsHeader": "Resultat",
    "resultsButton": "Graf",
    "resultsTitle": "Tourresultat",
    "resultsTableTitle": "Resultattabell",
    "resultsClose": "Stäng",
    "resultsError": "Kunde inte ladda resultat.",
    "resultsTableButton": "Tabell",
    "downloadCsv": "Ladda ner CSV",
    "csvError": "Inga tourresultat att ladda ner.",
    "csvUnsupported": "CSV-nedladdning finns bara på webben.",
    "roundPoints": "Rondpinnar",
    "claimHeader": "Claima",
    "claimCta": "Claima",
    "claiming": "Claimar...",
    "claimPending": "Begäran om claim skickad.",
    "claimSuccess": "Spelaren är nu claimad till din profil.",
    "claimTokenMissing": "Claim lyckades, men tillfällig åtkomst kunde inte upprättas. Försök igen.",
    "claimRejected": "Det gick inte att claima spelaren.",
    "claimSendError": "Kunde inte skicka claim-begäran.",
    "claimTimeout": "Inget svar på claim-begäran. Kontrollera anslutningen och försök igen.",
    "claimReleaseCta": "Avbryt claim",
    "claimReleaseSendError": "Kunde inte avbryta claim.",
    "claimReleased": "Claimen är avbruten.",
    "waitingForRoundSetupTitle": "Rundans Setup Pågår",
    "waitingForRoundSetup": "Väntar på att rundans setup ska bli klar. Du skickas automatiskt till hål 1.",
    "membersTitle": "Tourmedlemmar",
    "membersClaimHint": "Claima tillfälliga medlemmar här.",
    "membersReadOnlyHint": "Logga in för att claima tillfälliga medlemmar.",
    "unassignedPlayersTitle": "Oclaimade spelare",
    "unassignedPlayersHint": "Välj din spelare för att börja registrera score.",
    "unassignedPlayersEmpty": "Inga oclaimade spelare kvar.",
    "membersEmpty": "Inga medlemmar i den här touren.",
    "memberTemporary": "Tillfällig medlem",
    "memberClaimed": "Kopplad medlem",
    "eclecticTitle": "Eclectic",
    "eclecticSubtitle": "Bästa Stablefordpoäng per hål över alla rundor",
    "eclecticGridHint": "Bästa poäng per hål, med rundan de kom ifrån",
    "freezeTitle": "Eclectic Freeze",
    "freezeSubtitle": "Låsta poäng hittills – öppna hål räknas i sista rundan",
    "freezeFinalSubtitle": "Slutresultat: låsta poäng + sista rundan på öppna hål",
    "freezeFinalRoundSubtitle": "Sista rundan pågår: låsta poäng + löpande poäng på öppna hål",
    "freezeMerits": "+{merits} pinnar",
    "tourGamesHeader": "Tourspel",
    "highlightBestParAvg": "Bästa par {par}-snitt",
    "strokesAvg": "{avg} slag",
    "freezeLockedCount": "{locked}/{total} låsta",
    "freezeLockedAvg": "snitt {avg}",
    "freezeGridHint": "Låsta {locked} + öppna {open}",
    "freezeGridHintLocked": "Låsta {locked}",
    "freezeStale": "saknas",
    "freezeLockCta": "Frys hål",
    "roundNotStarted": "Inte startad"
  },
  "tourPreview": {
    "title": "Tourens översikt",
    "loading": "Hämtar touren…",
    "loadFailed": "Kunde inte hämta tourens översikt.",
    "retry": "Försök igen",
    "dateNotSet": "Datum ej bestämt",
    "courseNotChosen": "Bana ej vald ännu",
    "courseNotMapped": "Bankarta saknas ännu",
    "playPreview": "Spela upp banöversikt",
    "holesCount": "{count} hål",
    "holeCaption": "Hål {number}",
    "parShort": "Par {par}",
    "strokeIndexShort": "Index {strokeIndex}",
    "play": "Spela",
    "pause": "Pausa",
    "previousHole": "Föregående",
    "nextHole": "Nästa",
    "videoPosition": "Position i flygningen",
    "holeOfTotal": "{position} av {total}",
    "bunkerCount": "Bunkrar: {count}",
    "water": "Vatten",
    "teeCount": "Tees: {count}"
  },
  "tourPhotos": {
    "title": "Tourbilder",
    "openAction": "Bilder",
    "count": "{count} bilder",
    "filterAll": "Alla",
    "filterUnassigned": "Ingen runda",
    "unnamedRound": "Runda",
    "empty": "Inga bilder ännu",
    "emptyHint": "Bilder du tar under en runda visas här.",
    "loadError": "Kunde inte hämta bilderna.",
    "holeLabel": "Hål {hole}",
    "unknownUploader": "Okänd spelare",
    "delete": "Ta bort",
    "deleteConfirm": "Ta bort bilden för alla i touren?",
    "deleteConfirmYes": "Ta bort bild",
    "cancel": "Avbryt",
    "close": "Stäng",
    "captureAction": "Ta bild",
    "pickAction": "Lägg till från galleriet",
    "uploading": "Laddar upp {count}…",
    "uploadFailed": "En bild kunde inte laddas upp. Den finns kvar i galleriet – försök igen.",
    "cameraDenied": "Kameraåtkomst är avstängd. Slå på den i enhetens inställningar.",
    "libraryDenied": "Åtkomst till galleriet är avstängd. Slå på den i enhetens inställningar.",
    "tooLarge": "Bilden är för stor (max 15 MB).",
    "unsupportedType": "Använd en JPEG-, PNG- eller WebP-bild.",
    "uploadFailedTitle": "Bilden laddades inte upp",
    "setAsTourImage": "Använd som tourbild",
    "setAsTourImageQueued": "Sparad som tourbild. Det kan dröja en stund innan den syns.",
    "setAsTourImageFailed": "Kunde inte sätta tourbilden. Försök igen.",
    "makePublic": "Gör offentlig",
    "makePrivate": "Gör privat",
    "publicNote": "Offentlig – alla med länken kan se den här bilden.",
    "visibilityFailed": "Kunde inte ändra vem som kan se bilden. Försök igen.",
    "shareAction": "Dela länk",
    "shareCopied": "Länken har kopierats.",
    "shareFailed": "Kunde inte dela länken.",
    "sharePhoto": "Dela bild",
    "sharePhotoPreparing": "Förbereder bilden…",
    "sharePhotoFailed": "Kunde inte dela bilden. Försök igen.",
    "tourNotFound": "Touren hittades inte"
  },
  "tourInvite": {
    "title": "Inbjudan",
    "courseLabel": "Bana",
    "viewerTitle": "Vill du bara titta?",
    "viewerHint": "Följ touren, ronderna och livescoringen utan att claima en spelare.",
    "viewerCta": "Titta som åskådare"
  },
  "scorecard": {
    "title": "Scorekort",
    "player": "Spelare",
    "hole": "Hål",
    "par": "Par",
    "index": "Index",
    "strokes": "Slag",
    "points": "Poäng",
    "out": "Ut",
    "in": "In",
    "total": "Totalt",
    "totalGross": "Slag",
    "totalStableford": "Poäng",
    "selectRoundTitle": "Välj runda",
    "selectRoundLoading": "Laddar rundor...",
    "selectRoundEmpty": "Inga rundor tillgängliga.",
    "selectRound": "Välj",
    "selectRoundError": "Kunde inte ladda rundor.",
    "selectRoundFallback": "Runda",
    "missingRound": "Ingen runda vald.",
    "loadError": "Kunde inte ladda scorekort."
  },
  "language": {
    "english": "Engelska",
    "label": "Språk",
    "swedish": "Svenska",
    "danish": "Danska"
  },
  "modal": {
    "title": "Modal"
  },
  "deviceLink": {
    "title": "Logga in",
    "message": "Tar dig till inloggningen…"
  },
  "notFound": {
    "cta": "Gå till startskärmen!",
    "message": "Den här skärmen finns inte.",
    "title": "hoppsan!"
  },
  "qr": {
    "fallbackError": "Använder reservlänk eftersom backend inte är tillgänglig.",
    "subtitle": "Eller tryck nedan för att öppna den direkt",
    "title": "Skanna för att öppna länken"
  },
  "tab": {
    "qr": "QR-länk",
    "players": "Spelare"
  },
  "players": {
    "addedAt": "Tillagt:{date}",
    "empty": "Inga spelare ännu.",
    "loadError": "Det gick inte att ladda spelare.",
    "serviceError": "Fel i spelartjänsten",
    "title": "Spelare",
    "roundInitTitle": "Ny runda",
    "wsError": "WebSocket-anslutningen misslyckades.",
    "tourId": "Tour-ID: {id}",
    "tourNameFallback": "Tour",
    "activeRoundsTitle": "Aktiva rundor",
    "activeRoundsRefresh": "Uppdatera",
    "activeRoundsEmpty": "Inga aktiva rundor hittades.",
    "roundsLoadError": "Det gick inte att ladda rundor.",
    "roundStatus": "Status: {status}",
    "roundStatusWithDate": "Status: {status} · {date}",
    "roundOpen": "Öppna",
    "roundContinue": "Fortsätt",
    "roundFallbackName": "Bana",
    "finishedRoundsTitle": "Avslutade rundor",
    "roundResults": "Resultat",
    "roundMenuLabel": "Rondåtgärder",
    "roundMenuPause": "Pausa",
    "roundMenuFinish": "Avsluta",
    "roundMenuCancel": "Avbryt",
    "roundNamePlaceholder": "Rondnamn",
    "roundDescriptionTitle": "Rondbeskrivning",
    "roundDescriptionPlaceholder": "Lägg till en beskrivning...",
    "roundDescriptionButton": "Redigera rondbeskrivning",
    "playDateLabel": "Speldatum",
    "playDateQuick": "Snabba datum",
    "playDateToday": "Idag",
    "holesCountLabel": "Antal hål",
    "courseLabel": "Bana",
    "courseSearchPlaceholder": "Sök bana",
    "courseSearchEmpty": "Inga banor hittades.",
    "addCourse": "Lägg till bana",
    "holesCountOptionLabel": "{count} hål",
    "holesCountOptionValue": "{count} hål",
    "teeLabel": "Tee",
    "teeNone": "Ingen",
    "addTee": "Lägg till tee",
    "addTeeTitle": "Lägg till tee",
    "addTeeNameLabel": "Namn",
    "addTeeNamePlaceholder": "Tee-namn",
    "addTeeCourseRatingLabel": "Course rating (valfritt)",
    "addTeeSlopeRatingLabel": "Slope rating (valfritt)",
    "addTeeSave": "Lägg till tee",
    "addTeeNameRequired": "Tee-namn krävs.",
    "addTeeNeedsCourse": "Välj en bana först.",
    "addTeeFailed": "Kunde inte lägga till tee. Försök igen.",
    "addTemporary": "Lägg till tillfällig spelare",
    "temporaryNamePlaceholder": "Namn på tillfällig spelare",
    "temporaryCreateAction": "Skapa spelare",
    "temporaryNameRequired": "Ange namn för tillfällig spelare.",
    "temporaryCreateFailed": "Det gick inte att skapa tillfällig spelare.",
    "temporaryCreatePending": "Vänta tills tillfälliga spelare är skapade innan rundan startas.",
    "temporaryCreatePendingCount": "Skapar tillfälliga spelare: {count}",
    "inviteOthers": "Bjud in andra",
    "joinWithCode": "Gå med med kod",
    "showQr": "Visa QR",
    "selectFromMembership": "Välj spelare från tourens medlemslista.",
    "membersUpdateTimeout": "Ingen bekräftelse för uppdatering av tourmedlemmar.",
    "membersUpdateSendFailed": "Det gick inte att skicka uppdatering av tourmedlemmar.",
    "roundInitiateSendFailed": "Det gick inte att starta rundan.",
    "roundInitiateTimeout": "Start av runda tog för lång tid.",
    "roundInitiateRejected": "Start av runda nekades.",
    "missingTour": "Tour saknas, kan inte spara spelare.",
    "singleRoundHiddenTourName": "Enkel runda",
    "hiddenTourInitiateFailed": "Det gick inte att starta enkel runda just nu.",
    "recentlyPlayedTitle": "Senast spelade",
    "recentlyPlayedSubtitle": "Dina senaste ronder",
    "searchAnyCourseHint": "Sök valfri klubb, bana eller stad",
    "lookingForAnother": "Letar du efter en annan bana?",
    "nearbyCoursesTitle": "Banor i närheten",
    "courseOfficialBadge": "Officiell",
    "coursePrivateBadge": "Privat",
    "coursePendingBadge": "Väntar",
    "roundModeLabel": "Rundtyp",
    "roundModeStandard": "Vanlig runda"
  },
  "round": {
    "member": {
      "add": {
        "alreadyMember": "Spelaren ingår redan i den här rundan.",
        "playerNotInTour": "Spelaren måste vara medlem i touren innan den kan läggas till i rundan.",
        "statusNotAllowed": "Spelare kan bara läggas till när rundans status är draft, active eller playing.",
        "roundNotFound": "Rundan kunde inte hittas.",
        "invalid": "Begäran om tillägg av rundspelare är ogiltig."
      },
      "remove": {
        "invalid": "Begäran om borttagning av rundspelare är ogiltig.",
        "invalidPlayer": "Borttagning av rundspelare kräver en giltig spelare.",
        "roundNotFound": "Rundan kunde inte hittas.",
        "notMember": "Spelaren ingår inte i den här rundan.",
        "lastPlayer": "En runda måste ha minst en spelare kvar.",
        "hasScores": "Spelaren kan inte tas bort från rundan efter att scorer har registrerats."
      }
    },
    "remove": {
      "invalid": "Begäran om borttagning av runda är ogiltig.",
      "roundNotFound": "Rundan kunde inte hittas.",
      "hasScores": "Rundan kan inte tas bort efter att scorer har registrerats."
    },
    "initiate": {
      "membershipRequired": "Alla rundspelare måste vara medlemmar i touren."
    }
  },
  "roundResults": {
    "title": "Rundresultat",
    "backToHole": "<- Rondresultat",
    "missingRound": "Välj en runda för att se resultat.",
    "goPlayers": "Till spelare",
    "loadError": "Kunde inte ladda rundresultat.",
    "empty": "Inga resultat än.",
    "player": "Namn",
    "total": "Poäng",
    "gameFallback": "Spel",
    "unknownPlayer": "Spelare",
    "roundFallback": "Runda",
    "status": "Status: {status}"
  },
  "roundBoard": {
    "title": "Live-resultattavla",
    "loading": "Laddar tavlan…",
    "loadError": "Kunde inte ladda resultattavlan. Försöker igen.",
    "missingRound": "Ingen runda att visa.",
    "live": "Live",
    "reconnecting": "Återansluter",
    "noPlayers": "Inga spelare i rundan än.",
    "pos": "Plac",
    "player": "Spelare",
    "thru": "Hål",
    "gross": "Brutto",
    "net": "Netto",
    "game": "Spel",
    "shareTitle": "Visa på en skärm",
    "shareHint": "Ange koden på Goffys startsida för att öppna live-resultattavlan. Den kan bara titta.",
    "shareCta": "Tavelkod",
    "shareError": "Kunde inte hämta någon tavelkod.",
    "page": "Sida {page} av {pages}",
    "currentHole": "Hål {hole}",
    "parIs": "par {par}",
    "indexIs": "index {index}",
    "playing": "spelar",
    "positionByHole": "Placering per hål",
    "merits": "Pinnar",
    "statusActive": "Pågår",
    "statusFinished": "Avslutad",
    "statusCancelled": "Avbruten",
    "statusNotStarted": "Ej startad"
  },
  "gameGroups": {
    "main": "Huvudspel",
    "match": "Matchspel",
    "team": "Lagspel",
    "hazard": "Hazardspel",
    "achievement": "Prestationer",
    "challenge": "Utmaningar",
    "other": "Övriga spel",
    "tournament": "Tourspel"
  },
  "shareResults": {
    "action": "Dela resultatlänk",
    "hint": "Alla med länken kan följa resultaten live – inget konto behövs.",
    "copied": "Resultatlänken kopierades till urklipp.",
    "error": "Kunde inte dela resultatlänken på den här enheten."
  },
  "shareImage": {
    "andMore": "+{count} till",
    "action": "Dela bild",
    "preparing": "Skapar bild...",
    "downloaded": "Bilden sparades bland dina nedladdningar.",
    "unsupported": "Att dela bilder stöds inte på den här enheten.",
    "error": "Kunde inte skapa bilden."
  },
  "summary": {
    "title": "Rondsammanfattning",
    "missingInfo": "Saknar rond-ID eller användartoken.",
    "loadError": "Kunde inte ladda ronddata.",
    "overallTitle": "Total leaderboard",
    "playerHeader": "Spelare",
    "scoreHeader": "Score",
    "gameHeader": "Pinnar",
    "pointsHeader": "Totala pinnar",
    "eventsCount": "{count} händelser",
    "gamesTitle": "Resultat per spel",
    "gamesEmpty": "Inga spelresultat ännu.",
    "hazardsTitle": "Hazardspel",
    "hazardsEmpty": "Inga hazard-händelser registrerade.",
    "hazardTotal": "Totalt {count}",
    "hazardWater": "Vatten {count}",
    "hazardBunker": "Bunker {count}",
    "hazardThreePutt": "3-putt {count}",
    "hazardPenalty": "Straff {count}",
    "hazardOut": "Out {count}",
    "pointsValue": "{points} poäng",
    "meritsValue": "{merits} pinnar",
    "positionByHoleTitle": "Placering per hål",
    "positionByHoleEmpty": "Ingen placeringshistorik registrerad ännu.",
    "strokesValue": "{strokes} slag",
    "piecesValue": "{pieces} st",
    "holesValue": "{holes} hål",
    "holesUpValue": "{holes}UPP",
    "noLeadValue": "—",
    "skinsValue": "{skins} skins",
    "mysteryTitle": "Mystery-spel höjdpunkter",
    "mysteryEmpty": "Inga mystery-val hittades.",
    "mysteryHolePrize": "Hål {hole} - {prize}",
    "mysterySubgame": "Delspel: {subgame}",
    "mysteryWinner": "Vinnare: {winner}",
    "mysteryPrizeFallback": "Mystery-pris",
    "parBetterTitle": "Par eller bättre per spelare",
    "parBetterEmpty": "Inga par-eller-bättre resultat ännu.",
    "parBetterHoles": "Hål: {holes}",
    "parBetterHolesWithResult": "Hål: {holes}",
    "resultPar": "par",
    "resultBirdie": "birdie",
    "resultEagle": "eagle",
    "resultAlbatross": "albatross",
    "resultUnderPar": "under par",
    "unknownPlayer": "Okänd spelare",
    "unknownGame": "Okänt spel",
    "unknownWinner": "Okänd vinnare",
    "unknownMysteryPrize": "Okänt mystery-pris",
    "reopenRoundButton": "Öppna rundan igen",
    "doneButton": "OK",
    "shotTrackingTitle": "Slagmätning",
    "shotTrackingHole": "Hål {hole}",
    "shotTrackingShots": "{count} slag",
    "shotTrackingPutts": "{putts} puttar",
    "mysteryNoWinner": "Inte vunnen ännu"
  },
  "tour": {
    "member": {
      "claim": {
        "invalid": "Begäran om att claima tourspelare är ogiltig.",
        "unauthorized": "Logga in för att claima spelaren.",
        "tourNotFound": "Touren kunde inte hittas.",
        "sourceNotFound": "Spelaren kunde inte hittas.",
        "sourceNotMember": "Spelaren ingår inte i den här touren.",
        "sourceNotUnclaimed": "Spelaren är redan claimad.",
        "targetMissing": "Skapa din spelarprofil innan du claimar den här spelaren.",
        "targetAlreadyInTour": "Din spelare är redan med i den här touren.",
        "targetAlreadyInRound": "Din spelare finns redan i en eller flera rundor i den här touren.",
        "mergeConflict": "Claim kunde inte slutföras eftersom ronddata krockar med din befintliga spelare."
      },
      "remove": {
        "invalid": "Begäran om borttagning av tourspelare är ogiltig.",
        "invalidPlayer": "Borttagning av tourspelare kräver en giltig spelare.",
        "tourNotFound": "Touren kunde inte hittas.",
        "notMember": "Spelaren ingår inte i den här touren.",
        "creatorProtected": "Tourens skapare kan inte tas bort.",
        "lastMember": "En tour måste ha minst en medlem kvar.",
        "roundLastPlayer": "Spelaren kan inte tas bort eftersom en runda då blir tom.",
        "hasScores": "Spelaren kan inte tas bort från touren efter att scorer har registrerats."
      }
    },
    "initiate": {
      "creatorPlayerRequired": "Skapa din spelarprofil innan du skapar en tour.",
      "invalidPlayers": "En eller flera valda spelare kunde inte hittas.",
      "maxPlayersExceeded": "En tour kan ha max 8 spelare."
    }
  },
  "mysteryPrize": {
    "title": "Mysterypris",
    "subtitle": "Välj ett hål och ett delspel för varje spelare.",
    "loading": "Laddar mystery-setup...",
    "loadError": "Kunde inte ladda mysterypriset.",
    "validationError": "Välj ett hål och ett delspel för varje spelare.",
    "noPlayers": "Inga spelare hittades för rundan.",
    "noSubgames": "Inga delspel tillgängliga.",
    "holeLabel": "Hål",
    "subgameLabel": "Delspel",
    "selectHole": "Välj hål",
    "selectSubgame": "Välj delspel",
    "save": "Spara mysterypris",
    "skip": "Hoppa över mysterypris",
    "saving": "Sparar...",
    "holePickerTitle": "Välj hål",
    "subgamePickerTitle": "Välj delspel",
    "holeTaken": "Upptaget"
  },
  "blindFinish": {
    "title": "Blind avslutning",
    "settingLabel": "Blind avslutning",
    "off": "Av",
    "holesOption": "Sista {count}",
    "settingHintOff": "Dölj de sista hålen för de andra bollarna tills du avslöjar dem.",
    "settingHintOn": "De sista {count} hålen är dolda för de andra bollarna, och borta från live-ställningen, tills du avslöjar dem.",
    "hiddenBanner": "De sista {count} hålen är dolda tills arrangören avslöjar dem. Ställningen nedan räknar inte med dem.",
    "organizerBanner": "De sista {count} hålen är dolda för spelarna tills du avslöjar dem. Du ser allt.",
    "leaderboardBanner": "Blind avslutning: ställning utan de sista {count} hålen",
    "revealButton": "Avslöja avslutningen",
    "revealRejected": "Bara tourens arrangör kan avslöja avslutningen."
  },
  "meritBoost": {
    "settingLabel": "Poängboost",
    "off": "Normal",
    "option": "{percent}%",
    "settingHintOff": "Alla spel i rundan ger sina vanliga pinnar.",
    "settingHintOn": "Alla spel i rundan ger {percent}% pinnar, ovanpå varje spels egen viktning.",
    "settingHintLocked": "Rundan är avslutad, så dess pinnar är slutgiltiga. Öppna rundan igen för att ändra boosten."
  },
  "hole": {
    "title": "Hål",
    "holeLabel": "Hål",
    "loading": "Laddar hål...",
    "notRoundMember": "Du är inte spelare i denna rond — livevisning är inte tillgänglig.",
    "scoreButtonLabel": "Score",
    "frozenHoleBadge": "Hålet är fryst",
    "frozenHoleBadgePoints": "Hålet är fryst på {points} poäng",
    "unfrozenHoleBadge": "Hålet är inte fryst",
    "unfrozenHoleBadgePoints": "Hålet är inte fryst, {points} poäng att frysa",
    "eclecticBestBadge": "Eclectic bästa hittills {points} poäng",
    "scorePopupTitle": "{name} - {holeLabel} {hole}",
    "scorePopupHandicapLabel": "Handicapslag {value}",
    "scorePopupHandicapAndIndexLabel": "Handicapslag {handicap} · Hcp-index {index}",
    "scorePopupMeta": "Hcp-index {hcpIndex} · Par {par}",
    "placeholder": "Poängregistrering kommer här.",
    "roundId": "Rond: {id}",
    "tourId": "Tour: {id}",
    "gameFallbackName": "Spel",
    "playerBreakdownTitle": "Pinnar för {name}",
    "playerBreakdownPositionHeader": "Plac",
    "playerBreakdownGameHeader": "Spel",
    "playerBreakdownMeritsHeader": "Pinnar",
    "playerBreakdownTotal": "Totalt",
    "playerBreakdownEmpty": "Inga pinnar att visa.",
    "positionShort": "Plats {position}",
    "positionShared": "delad",
    "roundPointsMissing": "-",
    "leaderboardShortTitle": "Leaderboard (Pinnar)",
    "leaderboardShowAll": "Visa alla {count}",
    "leaderboardShowLess": "Visa topp 3",
    "ballHeading": "Boll {number}",
    "ballNumberLabel": "Boll {number}",
    "roundColumn": "Rond",
    "tourColumn": "Tour",
    "leaderboardRoundTitle": "⛳️ Leaderboard - rond (Tour)",
    "hazardCritter": "Fast i hindren",
    "noGamesSelected": "Inga spel valda. Leaderboarden är dold.",
    "unknownPlayer": "Okänd spelare",
    "gamesTitle": "🏆 Spel",
    "holesUpValue": "{holes}UPP",
    "noLeadValue": "—",
    "mysteryPrizeTitle": "Mysterypris",
    "mysteryPrizeSetup": "Mysterypris",
    "skinsCarry": "💰 Skins: {count} skins står på spel på detta hål!",
    "skinsCarryNext": "💰 Skins: {count} skins står på spel på nästa hål!",
    "missingPreviousScoreOne": "⚠️ {player} saknar resultat på hål {hole}.",
    "missingPreviousScoreMany": "⚠️ {player} saknar resultat på hål {holes}.",
    "shotTracker": {
      "lastShot": "🎯 {count} slag · senaste {distance}",
      "countOnly": "🎯 {count} slag registrerade",
      "putts": " · {putts} puttar"
    },
    "missingRound": "Ingen runda vald.",
    "goPlayers": "Gå till spelare",
    "mysteryPrizeEntry": "{subgame} - {player}",
    "mysteryPrizeEntryWinner": "{subgame} - {player} (vinnare {winner})",
    "mysteryPrizeNone": "Inget mysterypris för det här hålet.",
    "noPlayers": "Inga spelare att visa.",
    "puttOne": "1 putt",
    "puttTwo": "2 puttar",
    "puttThree": "3 puttar",
    "puttPlus": "+ puttar",
    "eightPlusLabelWithValue": "8+({value})",
    "mysteryPrizeUnknownSubgame": "Okänt delspel",
    "mysteryPrizeUnknownPlayer": "Okänd spelare",
    "mysteryPrizeWinnerTitle": "Välj vinnare",
    "mysteryPrizeWinnerSaveFailed": "Kunde inte spara mystery prize-vinnare.",
    "mysteryPrizeNextHoleTitle": "Mysterypris nästa hål",
    "mysteryPrizeNextHoleSubtitle": "På hål {hole} är mysterypriserna valda så här:",
    "mysteryPrizeSelectWinner": "Välj vinnare",
    "mysteryPrizeBack": "Tillbaka",
    "backButton": "<- Tillbaka",
    "showDetails": "Visa detaljer",
    "hideDetails": "Dölj detaljer",
    "pickup": "Pickup",
    "scoreChangeConfirmTitle": "Ändra score?",
    "scoreChangeConfirmMessage": "{name} har redan {current} på det här hålet. Vill du ändra till {next}?",
    "scoreChangeConfirmCta": "Ändra",
    "scoreChangeConfirmCancel": "Avbryt",
    "roundStateTitle": "Round state",
    "roundStateEmpty": "Ingen round state mottagen.",
    "close": "Stäng",
    "matchDormie": "Dormie i {game}: {team} leder med {lead} och {holes} hål kvar",
    "matchWon": "{team} har vunnit {game}: {lead} upp med {holes} hål kvar",
    "matchTeamFallback": "Lag",
    "leaderboardChangeTitle": "Leaderboard ändrad",
    "leaderboardChangeSubtitle": "Alla scorer är registrerade för hål {hole}",
    "leaderboardChangeSharedWith": "{name} +{count} till",
    "leaderboardChangeViewLeaderboard": "Visa leaderboard",
    "leaderboardChangeContinue": "Fortsätt",
    "netScoreLabel": "Netto",
    "netSummary": "Netto {net}{vsPar}",
    "netSummaryEmpty": "Netto –",
    "stablefordLabel": "Stableford",
    "menuTitle": "Välj hål",
    "menuButton": "Hål {hole}",
    "menuPlayed": "Spelat",
    "menuNotPlayed": "Ej spelat",
    "menuMyScore": "Min score: {score}",
    "menuScoreMissing": "—",
    "menuCurrent": "Aktuellt hål",
    "prevHole": "Föregående hål",
    "prevHoleSwipeHint": "Svep igen för att gå till föregående hål.",
    "nextHole": "Nästa hål",
    "nextHoleSwipeHint": "Svep igen för att gå till nästa hål.",
    "finishRound": "Avsluta rond",
    "continueToHole": "Fortsätt till hål {hole}",
    "finishRoundHint": "Tryck för att avsluta rundan.",
    "holeViewTitle": "Hål {hole}",
    "holeViewBeta": "Beta",
    "holeViewDisclaimerToggle": "Beta Ansvarsfriskrivning",
    "holeViewBetaNotice": "Beta: positionerna kommer från bankartläggningen och telefonens GPS. Avstånden är uppskattningar och kan vara fel – kontrollera dem innan du väljer klubba.",
    "holeViewDistance": "{distance} från bakre tee till greenens mitt",
    "holeViewElevationUphill": "{change} uppför till greenen",
    "holeViewElevationDownhill": "{change} nedför till greenen",
    "holeViewElevationLevel": "Greenen ligger i nivå med dig",
    "holeViewToGreen": "Till greenens mitt",
    "holeViewHoleLength": "Hålets längd",
    "holeViewYou": "Du",
    "holeViewTargetHint": "Tryck på kartan för att mäta till en punkt",
    "holeViewTargetFromYou": "Du till punkt",
    "holeViewTargetFromTee": "Tee till punkt",
    "holeViewTargetToGreen": "Punkt till green",
    "holeViewTargetClear": "Rensa",
    "holeViewZoomFit": "Anpassa",
    "holeViewFlyover": "Överflygning",
    "flyoverPlay": "Spela",
    "flyoverPause": "Pausa",
    "flyoverPosition": "Position i flygningen",
    "holeViewBasemap_satellite": "Satellit",
    "holeViewBasemap_hazards": "Hinder",
    "holeViewBasemap_drawing": "Ritning",
    "holeViewShapesNotice": "Bunkrar, vatten och greener hittas automatiskt i satellitbilder och är inte granskade. Stäm av mot det du ser på plats.",
    "holeViewWind_calm": "Stiltje",
    "holeViewWind_helping": "Medvind",
    "holeViewWind_into": "Motvind",
    "holeViewWind_leftToRight": "Från vänster",
    "holeViewWind_rightToLeft": "Från höger",
    "holeViewLocating": "Söker din position…",
    "holeViewOffHole": "Du är inte på det här hålet, så längden mäts från bakre tee.",
    "holeViewLocationDenied": "Platstjänster är av, så längden mäts från bakre tee.",
    "holeViewLocationUnavailable": "Ingen position tillgänglig, så längden mäts från bakre tee.",
    "holeViewTee": "Tee",
    "holeViewGreenCentre": "Greenens mitt",
    "holeViewHazardBunker": "Bunker",
    "holeViewHazardWater": "Vatten",
    "holeViewHazardToggle": "Avstånd till hinder",
    "holeViewUnavailable": "Hålet är inte kartlagt ännu. Tee- och greenpositioner visas när banan har kartlagts.",
    "finishSendFailed": "Det gick inte att avsluta rundan.",
    "eventSendFailed": "Det gick inte att skicka händelsen.",
    "offlinePending": "Offline — {count} sparade",
    "offlineSyncing": "Synkar…",
    "offlineSynced": "Synkat",
    "offlineSyncFailed": "{count} poster kunde inte synkas",
    "offlineRoundClosed": "Rundan är avslutad — öppna den igen för att registrera",
    "event": {
      "water": "Vatten",
      "penalty": "Straff",
      "out": "Out",
      "bunker": "Bunker",
      "threePutt": "3 puttar",
      "chipIn": "Chippa i",
      "fairway": "Fairway",
      "putts": "Puttar",
      "gir": "GIR"
    },
    "enhanced": {
      "unset": "–",
      "fairwayHit": "Träff",
      "fairwayLeft": "Vänster",
      "fairwayRight": "Höger",
      "girHit": "Träff",
      "girMiss": "Miss",
      "puttsDecrease": "En putt färre",
      "puttsIncrease": "En putt till"
    },
    "parBadge": "Par {par}",
    "hcpIndexBadge": "Index {hcpIndex}",
    "distanceToGreenBadge": "{distance}",
    "playersLoadFailed": "Kunde inte hämta spelare.",
    "holeViewAnalysis": "Dataanalys",
    "holeViewReportInaccurate": "Rapportera felaktig data",
    "holeViewReported": "Tack – rapporterat",
    "holeViewReanalyze": "Analysera banan igen",
    "holeViewReanalyzeRequesting": "Begär…",
    "holeViewReanalyzeQueued": "Köad för ny analys",
    "holeViewReanalyzeUnavailable": "Ny analys är inte tillgänglig",
    "skinsCarryBall": "Boll {ball}: {carry}"
  },
  "games": {
    "definitions": {
      "2f1c8d3a-6b54-4e29-9a7d-1c0e5b8f3a42": {
        "name": "Köpenhamn",
        "info": "Trespelarspel: bästa netto per hål ger 4, mitten 2, sämsta 0.",
        "description": "Köpenhamn är ett spel för tre spelare som räknas på nettoslag hål för hål. Bästa nettot ger 4 poäng, mittenspelaren 2 och sämsta 0. Spelare som delar placering delar de sammanlagda poängen jämnt (delad ledning 3/3/0, delad sista 4/1/1, alla lika 2/2/2). Flest poäng efter ronden vinner."
      },
      "3fb77a04-e479-4cd7-9ed8-8e8e110b4c53": {
        "name": "Stableford",
        "info": "Poängspel baserat på resultat mot par per hål.",
        "description": "Spelare får poäng per hål utifrån nettresultat mot par."
      },
      "c9d4b6a8-2a75-4d4f-bc35-9b0ec5b2f60b": {
        "name": "Slagspel",
        "info": "Lägst totala antal slag vinner.",
        "description": "Spelare rankas efter bruttoantal slag över rundan, där lägre total ger bättre placering."
      },
      "d06818bc-beea-41cc-8c59-2c176d46ef53": {
        "name": "Skins",
        "info": "Varje hål är värt en skin.",
        "description": "Bästa score på hålet vinner skin; delning rullar över till nästa hål."
      },
      "8dbf1961-9d07-4e15-bf95-e81d55fe41a4": {
        "name": "Best Ball",
        "info": "Lagformat som räknar bästa score per hål.",
        "description": "Varje lag räknar sin bästa spelares score på varje hål."
      },
      "4d3a1a42-4f67-41a4-b63d-9a9b50a83f1f": {
        "name": "Bunker",
        "info": "Händelsespel för bunkerutfall.",
        "description": "Spårar bunkerhändelser under rundan."
      },
      "e0b7c8af-3dc8-4a9f-8b77-5d99e5da0a4b": {
        "name": "Vatten",
        "info": "Händelsespel för vattenhinder.",
        "description": "Spårar vattenhinderhändelser under rundan."
      },
      "f9d88a1b-1a7e-4c86-9b2e-8e7f7f0fcb2b": {
        "name": "3 puttar",
        "info": "Händelsespel för treputtar.",
        "description": "Spårar hål där spelare behöver tre puttar."
      },
      "7a2e1c94-3b6d-4f81-9c2a-5d8e0f1a2b3c": {
        "name": "Chippa i",
        "info": "Händelsespel för chip-in.",
        "description": "Ger en poäng varje gång en spelare chippar i på ett hål."
      },
      "b1f4b6d5-3a7e-4d0a-8d3b-2e4f6a7b8c9d": {
        "name": "Mystery-pris",
        "info": "Hemligt sidospel med valt delspel och hål.",
        "description": "Varje spelare får ett dolt delspel för ett valt hål, sedan utses en vinnare."
      },
      "3f6a1d9c-2b84-4e07-9d15-8c4a7e2f5b60": {
        "name": "Eclectic",
        "info": "Bästa Stablefordpoäng per hål över alla tourrundor.",
        "description": "Ett spel över hela touren: för varje hål räknas dina bästa Stablefordpoäng från valfri runda i touren. Summan över 18 hål är din Eclectic-poäng."
      },
      "9b4e7c21-6f5a-4d38-a1c9-0e8d3b6f7a52": {
        "name": "Eclectic Freeze",
        "info": "Lås Stablefordpoäng på valda hål efter varje runda.",
        "description": "Ett vågspel över hela touren: efter varje runda låser du Stablefordpoängen på hål du är nöjd med. Låsta hål kan aldrig ändras. Hål som är öppna inför sista rundan får poängen du gör där."
      },
      "9e183962-7a3d-4719-b7e3-f64f095b8b6e": {
        "name": "Bästboll – sämsta boll",
        "info": "Lagspel som jämför bästa och näst bästa nettoresultat på varje hål.",
        "description": "Lagen jämför sina nettoresultat position för position på varje hål. Lägst netto i varje jämförelse ger en poäng."
      },
      "67fbf142-5a29-4e0d-bbe9-81bc4057d3cf": {
        "name": "Bingo Bango Bongo",
        "info": "Kul- och poängspel",
        "description": "Poäng delas ut för först på green, närmast flaggan och först i hål."
      },
      "5b74f4f7-4f6a-4a81-b2ee-c4c3dd760001": {
        "name": "Birdie eller bättre",
        "info": "Prestation",
        "description": "Par eller bättre på varje hål ger en poäng."
      },
      "a9099771-46ea-4210-91df-e4269c7428eb": {
        "name": "Hög–Låg",
        "info": "Lagspel",
        "description": "Lagets resultat är summan av det högsta och det lägsta individuella resultatet på varje hål."
      },
      "90c0ba8c-0fb0-4f5e-9a9e-4d2e8b1b0cc1": {
        "name": "Nassau",
        "info": "Matchspel / vadslagning",
        "description": "Tre separata tävlingar: första nio, andra nio och totalt 18 hål."
      },
      "6b9c72e0-6c1c-4d17-9f1f-6c0e2f71a742": {
        "name": "Pliktslag",
        "info": "Hinderspel",
        "description": "Räkna pliktslag per hål. Den sista som hamnar i ett hinder får -1."
      },
      "5b74f4f7-4f6a-4a81-b2ee-c4c3dd760003": {
        "name": "Sandy par",
        "info": "Prestation",
        "description": "Bunker och ändå par eller bättre ger en poäng."
      },
      "e1c62b4f-59a0-4b82-9c58-e4c6276933d0": {
        "name": "Vegas",
        "info": "Vadslagningsspel",
        "description": "Lagens resultat slås ihop till ett tvåsiffrigt tal per hål, vilket ger stora svängningar."
      },
      "5b74f4f7-4f6a-4a81-b2ee-c4c3dd760002": {
        "name": "Wet par",
        "info": "Prestation",
        "description": "Vattenhinder och ändå par eller bättre ger en poäng."
      },
      "4a6d988d-2077-4c1d-b6d6-e74f82d73115": {
        "name": "Wolf",
        "info": "Strategiskt lagspel",
        "description": "En roterande spelare (vargen) väljer partner eller spelar ensam mot gruppen."
      },
      "1b06cb5e-6edc-4d95-9c27-f008d9db7b98": {
        "name": "Sämsta boll",
        "info": "Lagspel",
        "description": "På varje hål räknas det högsta resultatet från någon spelare i laget som lagets resultat."
      },
      "eab96a21-05ee-4a7d-8cdb-13ec27752158": {
        "name": "Irish",
        "info": "Lagspel där fler resultat räknas ju längre ronden går.",
        "description": "Ett lagspel som räknas i netto-Stablefordpoäng, där antalet resultat som räknas växer under ronden. Över arton hål räknas bästa bollen på de första sex, de två bästa på de sex därefter, de tre bästa på de följande fyra och alla resultat på de två sista. En niohålsrond trappas upp på samma sätt. Antalet överstiger aldrig lagets storlek, och flest poäng vinner."
      },
      "703afbe7-85bb-422b-8359-7afb1e9abc81": {
        "name": "Bästa i laget",
        "info": "Lagspel där bara lagets bästa resultat räknas på varje hål.",
        "description": "Ett lagspel som räknas i netto-Stablefordpoäng. På varje hål tar laget det bästa resultatet bland sina spelare, och totalerna summeras över ronden. Lagmedlemmarna kan spela i samma boll eller i olika bollar. Flest poäng vinner."
      },
      "e61a49ce-e2dc-4f42-9a09-5f00e37f6dbc": {
        "name": "Scramble",
        "info": "Lagspel",
        "description": "Alla slår ut, laget spelar vidare från den bästa bollen och noterar ett resultat per hål."
      },
      "8b62c07d-7959-4677-8c75-39fecc966517": {
        "name": "Out",
        "info": "Händelsespel för out of bounds.",
        "description": "Spårar out of bounds under rundan."
      }
    },
    "subgames": {
      "d4d2a4b1-5a9b-4f0d-9b94-1a8f8a5c2e11": {
        "name": "Närmast flagg",
        "description": "Närmast flaggan på det valda hålet."
      },
      "3e92a03c-5b70-4a3a-aad1-7db36de37d5e": {
        "name": "Längsta drive",
        "description": "Längsta drive på det valda hålet."
      },
      "7c1cfd58-9171-4b4a-9a71-6f1d8b9b5c30": {
        "name": "Längsta 1 putt",
        "description": "Längsta enputt på det valda hålet."
      },
      "f0385fe1-a689-433a-ae70-480532077b12": {
        "name": "Övrigt",
        "description": "Valfri annan utmaning som spelarna kommer överens om på det valda hålet."
      }
    },
    "ruleSets": {
      "f9d88a1b-1a7e-4c86-9b2e-8e7f7f0fcb2b": {
        "standard": {
          "name": "Standard",
          "description": "Ett puttspel vid sidan om. Ett hål där du använder tre puttar eller fler är värt en poäng, och det räknas en gång hur många puttar det än blev. Det är snabbaste sättet att se vems närspel svek."
        }
      },
      "9e183962-7a3d-4719-b7e3-f64f095b8b6e": {
        "standard": {
          "name": "Standard",
          "description": "Två poäng står på spel varje hål. Lagen ställer upp sina nettoresultat i ordning och jämför dem ett mot ett: bästa boll mot bästa boll, sedan näst bästa mot näst bästa. Varje jämförelse vinns av det lägre nettoresultatet, så tar man båda vinner man hålet rakt av och delar man dem blir hålet delat. Det kräver att laget både har en låg rond och inga passagerare."
        }
      },
      "8dbf1961-9d07-4e15-bf95-e81d55fe41a4": {
        "standard": {
          "name": "Standard",
          "description": "Ett lagspel där bara bästa bollen räknas. På varje hål tar laget sitt lägsta nettoresultat och struntar i resten, så en spelare kan bära ett hål medan de andra plockar upp. Varje spelare som matchar det bästa resultatet får poängen, vilket belönar två lagkamrater som spelar hålet bra tillsammans."
        },
        "gross": {
          "name": "Brutto",
          "description": "Samma bästboll-format men utan handicap. Inga slag ges, så lagets lägsta verkliga resultat på hålet är det som räknas."
        }
      },
      "67fbf142-5a29-4e0d-bbe9-81bc4057d3cf": {
        "standard": {
          "name": "Standard",
          "description": "Tre poäng finns att ta på varje hål, och de belönar position snarare än ren längd. En går till först på green, en till den som är närmast flaggan när alla bollar är uppe, och en till den som först är i hål. Spelordningen spelar roll, så den kortaste slagmannen kan poängplocka lika fritt som någon annan."
        }
      },
      "5b74f4f7-4f6a-4a81-b2ee-c4c3dd760001": {
        "standard": {
          "name": "Standard",
          "description": "En poäng för varje hål du spelar på ett under par eller bättre, så birdie, eagle och albatross räknas var för sig en gång. Det bedöms på verkliga slag i stället för nettoresultat, vilket betyder att handicap inte hjälper här. Ett enkelt sätt att belöna de modiga hålen i en annars vanlig rond."
        }
      },
      "4d3a1a42-4f67-41a4-b63d-9a9b50a83f1f": {
        "standard": {
          "name": "Standard",
          "description": "Ett sidospel som räknar sand i stället för resultat. Ett hål där du är i bunkern är värt en poäng, och ett hål räknas högst en gång hur många besök det än blir. Kom överens före ronden om poängen är värda att ha eller värda att slippa."
        }
      },
      "7a2e1c94-3b6d-4f81-9c2a-5d8e0f1a2b3c": {
        "standard": {
          "name": "Standard",
          "description": "En poäng varje gång du sätter bollen från utanför green, oavsett om det är en chip, en pitch eller ett bunkerslag. Ett hål kan bara ge poäng en gång, och det registreras när det händer i stället för att räknas ut från ditt resultat. Ren tur räknas lika mycket som ren skicklighet."
        }
      },
      "3f6a1d9c-2b84-4e07-9d15-8c4a7e2f5b60": {
        "standard": {
          "name": "Standard",
          "description": "Ett spel som löper över hela touren i stället för en enskild rond. För varje hål räknas bara din bästa Stablefordpoäng på det från någon rond i touren, och ett bättre resultat senare ersätter ett tidigare. Din eclectic-total är dessa arton bästa hål sammanlagda, så ett bra hål är i hamn för resten av touren."
        }
      },
      "9b4e7c21-6f5a-4d38-a1c9-0e8d3b6f7a52": {
        "standard": {
          "name": "Standard",
          "description": "Eclectic med ett vågspel inbakat. Efter varje rond väljer du vilka hål du fryser och låser då in Stablefordpoängen du gjort på dem, och ett fryst hål kan aldrig ändras igen, varken till det bättre eller sämre. Hål du lämnar öppna behåller det du gör på dem i sista ronden, så att frysa för tidigt slösar bort ett bra hål och att frysa för sent riskerar att förlora ett."
        }
      },
      "a9099771-46ea-4210-91df-e4269c7428eb": {
        "standard": {
          "name": "Standard",
          "description": "Två separata poäng på varje hål. Lagen jämför sin bästa nettoboll mot varandra och sin sämsta nettoboll mot varandra, och varje jämförelse är värd en poäng. Det håller kvar en spelare som kämpar, eftersom den låga halvan av hålet är precis lika värdefull som den höga."
        }
      },
      "2f1c8d3a-6b54-4e29-9a7d-1c0e5b8f3a42": {
        "standard": {
          "name": "Standard",
          "description": "Ett trespelarspel där sex poäng delas på varje hål efter nettoresultat. Bästa bollen tar fyra, mittenspelaren två och sämsta noll. Spelare som delar placering delar poängen för de platser de upptar, så delad ledning ger tre var och delad sistaplats ger fyra till vinnaren och en var till de andra. Den som saknar resultat på hålet delar de nedersta platserna."
        }
      },
      "b1f4b6d5-3a7e-4d0a-8d3b-2e4f6a7b8c9d": {
        "standard": {
          "name": "Standard",
          "description": "Ett hål lottas i hemlighet innan ronden börjar, och ingen får veta vilket. Alla spelar alla arton hål som vanligt, och först efteråt avslöjas hålet och bästa resultatet på det tar priset. Eftersom man aldrig vet vilket hål som räknas är enda sättet att spela att spela varje hål ordentligt."
        }
      },
      "90c0ba8c-0fb0-4f5e-9a9e-4d2e8b1b0cc1": {
        "standard": {
          "name": "Standard",
          "description": "Tre matcher som spelas samtidigt på en och samma rond: ut, in och hela ronden. Varje match avgörs för sig, så att förlora ut kostar dig en match och inget mer. Den som ligger under kan ropa press, vilket startar en helt ny match som löper från det hålet till slutet av segmentet och ger en väg tillbaka utan att röra de matcher som redan pågår."
        },
        "front-back-only": {
          "name": "Endast ut och in",
          "description": "Samma två niohålsmatcher, ut och in, utan någon separat match över hela ronden. En bra utgång bankas i stället för att öppnas upp igen av totalmatchen, vilket passar ett sällskap som hellre spelar två korta tävlingar än en lång. Press fungerar precis som i den fulla varianten."
        }
      },
      "6b9c72e0-6c1c-4d17-9f1f-6c0e2f71a742": {
        "standard": {
          "name": "Standard",
          "description": "Ett sidospel för de slag ingen vill ha. Ett hål där du får ett pliktslag är värt en poäng, räknat en gång per hål oavsett hur pliktslaget uppstod. Som med de andra otursspelen, bestäm i förväg om vinnaren är den med flest eller minst."
        }
      },
      "5b74f4f7-4f6a-4a81-b2ee-c4c3dd760003": {
        "standard": {
          "name": "Standard",
          "description": "Belöningen för att ta sig ur knipan snyggt. Var du i bunkern på ett hål och ändå gick i mål på par eller bättre är hålet värt en poäng. Det bedöms på verkliga slag, så det är upp-och-in som ger poängen och inget annat."
        }
      },
      "d06818bc-beea-41cc-8c59-2c176d46ef53": {
        "standard": {
          "name": "Standard",
          "description": "Varje hål är värt en skin. Skinnen går till den som ensam har lägst nettoresultat, och bara rakt av: delar två eller fler bästa resultatet vinner ingen. Ett delat hål rullar sin skin vidare till nästa, så potten växer tills någon vinner ett hål ensam och tar hela högen. En lugn rond kan avgöras på ett enda sent hål."
        },
        "no-carry": {
          "name": "Ingen ackumulering",
          "description": "Varje hål är värt en skin, som vinns rakt av den ensamt lägsta nettoscoren. Ett delat hål är helt enkelt ogiltigt: inget rullar vidare och den skinnen är borta. Varje hål är alltså värt högst en skin, vilket håller spelet jämnt i stället för att låta ett sent hål avgöra allt."
        }
      },
      "3fb77a04-e479-4cd7-9ed8-8e8e110b4c53": {
        "standard": {
          "name": "Standard",
          "description": "Varje hål ger poäng mot par på ditt nettoresultat. Par ger två poäng, ett till för varje slag bättre och ett mindre för varje slag sämre. Ett hål kan aldrig ge minus, så ett katastrofhål kostar inget extra. Slag tilldelas efter handicap: ett på varje hål, plus ett extra på de svåraste hålen efter slagindex tills handicapet tar slut. Plockar du upp bollen ger hålet noll. Högst total efter ronden vinner."
        },
        "gross": {
          "name": "Brutto",
          "description": "Samma poängtabell, men spelad utan handicap. Ingen får slag, så resultatet på kortet är det som räknas. Allt annat är sig likt: par ger två poäng, bättre ger mer, sämre ger mindre, och inget hål går under noll."
        }
      },
      "c9d4b6a8-2a75-4d4f-bc35-9b0ec5b2f60b": {
        "standard": {
          "name": "Standard",
          "description": "Rakt spel: räkna varje slag och lägg ihop dem. Handicapslag dras av, så totalen är ditt nettoresultat för ronden och lägst total vinner. Det finns inget att hålla reda på hål för hål, vilket gör det till den ärligaste bilden av vem som faktiskt spelade bäst."
        },
        "gross": {
          "name": "Brutto",
          "description": "Samma räkning av varje slag, men utan handicap. Inget handicap dras av, så lägst antal verkliga slag vinner. Så avgörs ett klubbmästerskap."
        }
      },
      "e1c62b4f-59a0-4b82-9c58-e4c6276933d0": {
        "standard": {
          "name": "Standard",
          "description": "Ett pars två nettoresultat slås ihop till ett tvåsiffrigt tal med lägsta bollen först: en fyra och en sexa blir fyrtiosex, inte sextiofyra. De två lagen jämför tal och skillnaden mellan dem är hålets resultat. Eftersom en dålig boll flyttar den andra siffran kostar ett svagt resultat betydligt mer här än i de flesta lagspel."
        }
      },
      "e0b7c8af-3dc8-4a9f-8b77-5d99e5da0a4b": {
        "standard": {
          "name": "Standard",
          "description": "Ett sidospel som räknar otur i stället för bra spel. Ett hål där du hittar vattnet är värt en poäng, och ett hål räknas högst en gång oavsett hur många gånger du åker i. Om poängen är något att samla på eller något att undvika får sällskapet komma överens om före ronden."
        }
      },
      "5b74f4f7-4f6a-4a81-b2ee-c4c3dd760002": {
        "standard": {
          "name": "Standard",
          "description": "Samma belöning, men för vatten i stället för sand. Hittar du vattnet på ett hål och ändå går i mål på par eller bättre är hålet värt en poäng. Med tanke på pliktslaget som oftast följer med är det här det svåraste av de två att få."
        }
      },
      "4a6d988d-2077-4c1d-b6d6-e74f82d73115": {
        "standard": {
          "name": "Standard",
          "description": "Spelarna turas om att vara varg, i en fast ordning som roterar varje hål. Vargen slår ut sist och ser de andra, och väljer sedan antingen en av dem som partner för hålet eller tackar nej till alla och spelar ensam mot resten. Att gå ensam är värt mer om det lyckas och kostar mer om det inte gör det, så hela spelet ligger i tajmingen av det beslutet."
        }
      },
      "1b06cb5e-6edc-4d95-9c27-f008d9db7b98": {
        "standard": {
          "name": "Standard",
          "description": "Spegelbilden av bästboll, och mycket svårare än det låter. På varje hål räknas lagets högsta nettoresultat, så ingen kan gömma sig och alla måste spela klart hålet. Varje spelare med det resultatet får poängen. Det straffar ett slarvigt hål på ett sätt som bästboll aldrig gör."
        }
      },
      "eab96a21-05ee-4a7d-8cdb-13ec27752158": {
        "standard": {
          "name": "Standard",
          "description": "Lagen samlar netto-Stablefordpoäng, och antalet resultat som räknas växer allteftersom ronden går. Det börjar med bara bästa bollen i laget, sedan de två bästa efter en tredjedel av ronden, de tre bästa efter två tredjedelar, och alla resultat på de avslutande hålen: sex, sex, fyra och två över arton hål, eller tre, tre, två och ett över nio. Antalet överstiger aldrig lagets storlek, så ett par når helt enkelt sitt tak tidigt. Varje spelare bär lagets total."
        }
      },
      "703afbe7-85bb-422b-8359-7afb1e9abc81": {
        "standard": {
          "name": "Standard",
          "description": "På varje hål räknas lagets bästa netto-Stablefordresultat, och totalerna summeras över ronden. Lagmedlemmarna kan spela i olika bollar; lagen sätts upp på rondstartsskärmen. En spelare utan lag spelar som ett lag på en. Varje spelare bär lagets total."
        }
      },
      "e61a49ce-e2dc-4f42-9a09-5f00e37f6dbc": {
        "standard": {
          "name": "Standard",
          "description": "Varje spelare i laget slår ett utslag, laget väljer den boll det gillar bäst och alla slår sitt nästa slag därifrån. Så fortsätter det tills bollen är i hål. Laget noterar ett bruttoresultat per hål, och färrest slag över ronden vinner. Fungerar med ett lag på en till fyra spelare."
        }
      },
      "8b62c07d-7959-4677-8c75-39fecc966517": {
        "standard": {
          "name": "Standard",
          "description": "Ett sidospel som räknar vita pinnar i stället för resultat. Ett hål där du slår bollen out of bounds är värt en poäng, och ett hål räknas högst en gång hur många gånger du än hamnar fel. Kom överens före ronden om poängen är värda att ha eller värda att slippa."
        }
      }
    }
  },
  "freeze": {
    "title": "Eclectic Freeze",
    "subtitle": "Lås Stablefordpoäng på hål du är nöjd med. Låsta hål ändras aldrig.",
    "loading": "Laddar…",
    "loadError": "Kunde inte ladda Eclectic Freeze.",
    "noPlayers": "Inga spelare att visa ännu.",
    "chipLockedCount": "{locked} låsta",
    "lockedAvg": "snitt {avg}",
    "selectHint": "Välj hål att låsa för {name}.",
    "windowClosed": "Låsfönstret är stängt för den här spelaren.",
    "windowOtherRound": "Den här spelaren låser från en annan runda.",
    "openEarlierLabel": "Öppna denna tidigare runda för frysning",
    "openEarlierHint": "Bocka i rutan för att låsa hål från denna runda ändå.",
    "allLocked": "Alla hål är låsta.",
    "lockedTotalLabel": "Låsta",
    "selectedLabel": "Valda",
    "afterLockLabel": "Efter låsning",
    "avgLabel": "Snitt",
    "lockButton": "Lås {count} hål",
    "saving": "Låser…",
    "permanentNote": "Låsning är permanent. Fönstret stängs när nästa runda börjar.",
    "confirmTitle": "Lås hål?",
    "confirmMessage": "Lås {count} hål för {name}? Detta kan inte ångras.",
    "confirmCta": "Lås permanent",
    "cancel": "Avbryt",
    "lockSaved": "{count} hål låsta.",
    "lockRejected": "Kunde inte låsa hålen.",
    "lockTimeout": "Inget svar. Försök igen.",
    "switchTitle": "Släng valda hål?",
    "switchMessage": "Du har {count} valda hål för {name} som inte är låsta ännu. Byt spelare och släng dem?",
    "switchCta": "Byt och släng",
    "switchStay": "Behåll valet",
    "done": "Klar"
  },
  "claimSignup": {
    "title": "Behåll dina resultat",
    "body": "Skapa ett konto för att behålla dina resultat och använda dem på alla enheter.",
    "cta": "Skapa konto och behåll dina resultat"
  },
  "privacy": {
    "title": "Integritetspolicy",
    "updated": "Senast uppdaterad {date}",
    "intro": "Goffy registrerar golfrundor. Vi sparar det som behövs för det och inget mer. Vi säljer inte dina uppgifter, visar ingen reklam och använder ingen spårning från tredje part.",
    "collectH": "Vad vi samlar in",
    "collectP": "Din e-postadress och ditt lösenord, ditt spelarnamn och – om du lägger till dem – handicap, kön och foto, samt de rundor och resultat du spelar. Appen skickar även mätvärden om prestanda så att vi kan hitta fel. Om du har gått med på att hjälpa oss testa sparar vi dessutom en logg över de åtgärder appen skickar till oss under en runda, i upp till 30 dagar, så att vi kan återskapa förloppet som ett automatiskt test. Den innehåller inga namn och ingen fritext, och vi sparar den bara för testare som har bett att få vara med.",
    "locationH": "Plats",
    "locationP": "När du startar en runda frågar vi efter din plats för att visa banor i närheten. Koordinaterna används bara för den sökningen och sparas inte. Nekar du fungerar allt annat som vanligt.",
    "sharingH": "Vem ser uppgifterna",
    "sharingP": "De du spelar med ser de rundor du delar med dem. Ingen annan, om inte lagen kräver det.",
    "storageH": "Var de lagras",
    "storageP": "På servrar i Irland, krypterat under överföring. Rundor sparas så länge ditt konto finns.",
    "rightsH": "Dina rättigheter",
    "rightsP": "Du kan se och ändra din profil och radera ditt konto under Profil i menyn. Raderingen tar bort din inloggning, din profil och dina personuppgifter. Resultat ligger kvar på andra spelares scorekort med ditt namn, eftersom en radering skulle skriva om någon annans runda. Vill du ha en kopia av dina uppgifter, mejla privacy@goffy.app.",
    "contactH": "Kontakt",
    "contactP": "privacy@goffy.app"
  },
  "courseMapping": {
    "title": "Bankartläggning",
    "intro": "Goffy kan lära sig var tees och greener ligger på banorna du spelar, genom att spara din position under en runda. Det är avstängt tills du slår på det.",
    "toggleLabel": "Hjälp till att kartlägga banorna jag spelar",
    "unsupported": "Bankartläggning finns än så länge bara på Android.",
    "whatH": "Vad som sparas",
    "whatP": "Din position, ungefär var tredje sekund, medan en runda pågår. Inspelningen slutar när rundan är slut. Ingenting sparas mellan rundor.",
    "whyH": "Vad det används till",
    "whyP": "Positioner från många spelare kombineras för att räkna ut var varje tee och green ligger. Resultatet är en karta över banan, inte ett register över din runda. Dina positioner lagras under en kod som är olika på varje bana, så de kan inte kopplas ihop till en historik över var du har varit.",
    "batteryH": "Vad det kostar",
    "batteryP": "Räkna med ungefär 10-15% mer batteriförbrukning under en fyra timmar lång runda. Inspelning startar aldrig under 20% batteri och slutar om du kommer ner till 20% under en runda.",
    "retentionH": "Hur länge det sparas",
    "retentionP": "Råa positioner raderas efter 90 dagar. De tee- och greenpositioner som räknats fram behålls, eftersom de är det kartan består av och inte handlar om någon enskild spelare.",
    "controlH": "Du bestämmer",
    "controlP": "Stäng av när du vill så slutar inspelningen direkt. Raderar du ditt konto raderas dina sparade positioner med det. När en bana är färdigkartlagd slutar Goffy spela in där av sig självt."
  },
  "courseMappingReview": {
    "title": "Granska bankartläggning",
    "intro": "Tee- och greenpositioner framräknade ur spelarnas GPS-spår. Varje position är ett medelvärde, och säkerheten visar hur mycket den går att lita på. Godkänn en position för att göra den officiell, förkasta för att radera den.",
    "selectCourse": "Bana",
    "empty": "Inget framräknat för den här banan än. Positioner dyker upp när tillräckligt många rundor har spelats in.",
    "hole": "Hål {number}",
    "tee": "Tee",
    "green": "Green",
    "reviewed": "godkänd",
    "meta": "{confidence}% säkerhet · {contributors} bidragsgivare",
    "accept": "Godkänn",
    "reject": "Förkasta"
  },
  "courseHoleMap": {
    "title": "Bankartläggning",
    "overviewTitle": "Banöversikt",
    "overviewCounter": "{total} hål",
    "holeTitle": "Hål {hole}",
    "par": "Par {par}",
    "measuredLength": "{length} uppmätt",
    "empty": "Den här banan har inga hål att visa än.",
    "meta": "{source} · {confidence}% säkerhet · {contributors} bidragsgivare",
    "agreement": "{count} leverantörer är överens",
    "notServed": "Visas inte för spelare — under säkerhetsgränsen",
    "shapeMeta": "{area} · {points} punkter · hål {hole}",
    "basemap_esri-worldimagery": "Esri",
    "basemap_lantmateriet-orto": "Lantmäteriet",
    "basemap_geodanmark-orto": "GeoDanmark",
    "basemap_drawing": "Ritning",
    "source_esri-worldimagery": "Esri",
    "source_lantmateriet-orto": "Lantmäteriet",
    "source_geodanmark-orto": "GeoDanmark",
    "source_osm": "OSM",
    "close": "Stäng",
    "shapeKind_bunker": "Bunker",
    "shapeKind_water": "Vatten",
    "shapeKind_green": "Greenyta",
    "shapeKind_fairway": "Fairway",
    "shapeKind_trees": "Träd",
    "shapeKind_canopy": "Trädkronor (laserhöjd)",
    "shapeKind_path": "Väg eller stig",
    "counter": "{index} av {total} hål",
    "edit": "Redigera positioner",
    "editDone": "Klar",
    "placeTee": "Lägg till tee",
    "placeGreen": "Ange green",
    "revert": "Ångra ändringar",
    "save": "Spara",
    "saving": "Sparar…",
    "saved": "Positionerna är sparade. Bildanalys har köats för banan.",
    "saveFailed": "Kunde inte spara positionerna. Inget ändrades.",
    "remove": "Ta bort",
    "turnPoint": "Sving {index}",
    "turnHint": "Hålet svänger vid de ihåliga punkterna på linjen — en på ett par 4, två på ett par 5. Dra en för att sätta den; de övriga ligger kvar på den raka linjen tills de också dras.",
    "editHint": "Välj Lägg till tee eller Sätt green och klicka sedan på platsen på kartan. Dra en markör för att flytta den, dra någon annanstans för att panorera — koordinaten som visas är vyns mittpunkt.",
    "armedHint": "Klicka på kartan för att placera.",
    "measureAgainstTee": "{tee} {length} · {delta}",
    "measureAgainstCard": "{length} enligt kortet · {delta}",
    "teeNamed": "Stämmer med tee {tee} på scorekortet och har därför fått det namnet.",
    "unsavedWarning": "Spara eller ångra ändringarna på hålet först.",
    "closeWarning": "Stäng igen för att slänga de osparade ändringarna.",
    "goto": "Gå",
    "gotoPlaceholder": "Latitud, longitud",
    "gotoInvalid": "Kunde inte tolka det som latitud och longitud. Prova \"56.6776, 12.8578\".",
    "analyse": "Analysera",
    "analysing": "Köar…",
    "analysisQueued": "Köad för bildanalys. Den körs inom några minuter.",
    "analysisUnavailable": "Bildanalys är inte konfigurerad i den här miljön.",
    "analysisFailed": "Kunde inte köa bildanalys.",
    "savedAndMoved": "Sparat. Banans position låg långt härifrån, så den har flyttats hit och köats för analys.",
    "basemapUnavailable": "Ingen Lantmäteriet-bild sparad för den här banan än.",
    "candidates_classical": "Klassisk körning",
    "candidates_model": "Modellkörning",
    "candidatesLoading": "Hämtar körningarnas detektioner…",
    "detector_classical": "Klassisk",
    "detector_model": "ML-modell",
    "detectorModelUnavailable": "ML-modellen kräver en batch-arbetare med träningsavbilden igång; just nu kan bara den klassiska detektorn köras här.",
    "analysisQueuedModel": "Köad för analys med ML-modellen. Dess former sparas som kandidater och ändrar ingenting på banan.",
    "lengthTableTitle": "Lagrade längder",
    "lengthTableTee": "Tee",
    "lengthTableHole": "Hål",
    "lengthSource_analysis": "Vår mätning",
    "lengthSource_manual": "Inmatad",
    "lengthSource_golfisverige": "Golf i Sverige",
    "lengthSource_osm": "OSM",
    "lengthSource_unknown": "Okänd",
    "teeChip": "{tee} {length}",
    "teeLength": "{tee} {length} · {source}",
    "evaluation_classical": "Utvärderad klassisk",
    "evaluation_model": "Utvärderad modell",
    "evaluationCounts": "✓{matched} ✕{falsePositive} ○{missed}",
    "evaluationLegend": "Utvärderingsfärger: grönt — OSM håller med; rött — bara detektorn; gult — OSM har den, detektorn missade den."
  },
  "subscriptionPage": {
    "title": "Prenumeration",
    "signInPrompt": "Logga in för att hantera din prenumeration.",
    "loading": "Laddar din prenumerationsstatus…",
    "error": "Kunde inte läsa in din prenumerationsstatus.",
    "statusNone": "Du har ingen aktiv prenumeration än.",
    "statusActive": "Din prenumeration är aktiv. Förnyas {date}.",
    "statusActiveCancelling": "Din prenumeration är aktiv till {date}, sedan upphör den.",
    "statusPastDue": "Din senaste betalning misslyckades. Uppdatera din betalmetod för att behålla prenumerationen.",
    "statusCancelled": "Din prenumeration har upphört.",
    "statusPending": "Väntar på att du godkänner betalningen i Swish-appen.",
    "upgradeWithCardButton": "Prenumerera med kort",
    "upgradeWithSwishButton": "Prenumerera med Swish",
    "noProviders": "Inga betalmetoder är tillgängliga just nu.",
    "manageButton": "Hantera prenumeration",
    "checkoutError": "Kunde inte starta kassan. Försök igen.",
    "portalError": "Kunde inte öppna prenumerationshanteringen. Försök igen.",
    "cancelButton": "Avsluta prenumeration",
    "cancelError": "Kunde inte avsluta din prenumeration. Försök igen.",
    "cancelNoSubscription": "Du har ingen prenumeration att avsluta.",
    "providerUnavailable": "Den betalmetoden är inte tillgänglig just nu.",
    "swishBankNotSupported": "Din bank stödjer inte återkommande Swish-betalningar.",
    "swishAlreadySubscribed": "Du har redan en aktiv Swish-prenumeration.",
    "swishConsentInProgress": "Du har redan en Swish-förfrågan som väntar. Öppna Swish-appen för att slutföra den.",
    "featureDisabled": "Prenumerationer är inte tillgängliga än.",
    "successMessage": "Tack! Din prenumeration håller på att ställas in.",
    "cancelledMessage": "Kassan avbröts."
  },
  "subscriptionAdminPage": {
    "title": "Betalningar och prenumerationer",
    "forbidden": "Endast administratörer.",
    "loading": "Laddar prenumerationer…",
    "error": "Kunde inte läsa in prenumerationer.",
    "empty": "Inga prenumerationer än.",
    "provider": "Leverantör",
    "status": "Status",
    "cancelling": "avslutas",
    "price": "Pris",
    "renews": "Förnyas",
    "updated": "Uppdaterad",
    "failedCharges": "Misslyckade betalningar",
    "providerIds": "Kund/prenumeration"
  },
  "adminStatisticsPage": {
    "title": "Plattformsstatistik",
    "forbidden": "Endast administratörer.",
    "loading": "Läser in statistik…",
    "error": "Kunde inte läsa in statistiken.",
    "roundsPlayed": "Spelade ronder över 18 hål",
    "roundsPlayedHint": "{total} om ronderna våra egna konton skapat räknas med",
    "roundsPlayedUnknown": "Ej tillgängligt — administratörskontona eller ronddatan kunde inte läsas, och en ofiltrerad siffra vore missvisande.",
    "courses": "Banor",
    "coursesHint": "varav {disabled} avstängda",
    "coursesAnalysed": "Analyserade banor",
    "users": "Registrerade användare",
    "claimedPlayers": "Hämtade spelare",
    "claimedPlayersHint": "Gäster som någon annan lagt till och som senare hämtade spelaren vid registreringen."
  },
  "batchFleetPage": {
    "title": "Batch-flotta",
    "intro": "Servrarna utanför molnet som kör satellitanalys, flyover-renderingar och ML-träning (services/batch-worker): vilka som rapporterat in, hur långa köerna är och vad som körts nyligen.",
    "forbidden": "Den här sidan är för utvecklare och administratörer.",
    "loading": "Läser in flottan…",
    "failed": "Kunde inte läsa in flottan.",
    "retry": "Försök igen",
    "refresh": "Uppdatera",
    "updatedAt": "Uppdaterad {time}",
    "statisticsHeading": "Statistik",
    "queuesHeading": "Köer",
    "workersHeading": "Arbetare",
    "noWorkers": "Ingen arbetare har rapporterat in ännu. Lägg till en server nedan.",
    "addServerHeading": "Lägg till en server",
    "activityHeading": "Senaste aktivitet",
    "noActivity": "Inget har körts ännu.",
    "statsWorkersLabel": "Servrar online",
    "statsDetail": "{succeeded} ok · {failed} misslyckade · {total} totalt",
    "kind": {
      "course-analysis": "Bananalys",
      "course-data-acquire": "Datahämtning",
      "flyover": "Flyover-rendering",
      "ml": "ML-jobb",
      "osm-extract": "OSM-utdragsimport"
    },
    "queueCourseAnalysis": "Bananalyser i kö",
    "queueJobsByKind": "öppna per typ: {summary}",
    "queueAnalysisSplit": "{dispatched} hos en arbetare · {planned} väntar på data",
    "queueFlyover": "Flyover-renderingar i kö",
    "queueMl": "ML-jobb i kö",
    "queueOsmExtract": "OSM-utdrag i kö",
    "exchangeQueued": "I utbytet, ej hämtade: {summary}",
    "exchangeClaimed": "{count} tagna av arbetare",
    "exchangeEmpty": "Inget ligger i utbytet.",
    "exchangeClosed": "{count} köade i utbytet hör till arbete som databasen har avslutat — arbetarna skulle köra dem och varje svar skulle kastas. Svepet drar tillbaka dem inom en minut.",
    "exchangeOrphanedAcquisitions": "{count} bildhämtningar står i kö utan någon pågående körning att höra till. Svepet drar tillbaka dem inom en minut.",
    "exchangeClosedInFlight": "Arbetare kör minst {count} jobb som databasen har avslutat. Stoppa dem från arbetarkortet nedan.",
    "exchangeKind": {
      "modelDetection": "modelldetektioner",
      "detection": "detektioner",
      "elevation": "höjdprofiler",
      "canopy": "trädhöjd",
      "imagery": "bildprodukter",
      "acquire": "bildhämtningar",
      "flyover": "flyover-renderingar",
      "ml": "ML-jobb"
    },
    "queueEmpty": "Inget väntar i den här kön.",
    "queueLoading": "Laddar kön…",
    "queueFailed": "Kunde inte läsa kön.",
    "queueSummary": "{count} jobb väntar, äldst först",
    "queueClear": "Töm kön",
    "queueClearConfirm": "Bekräfta · avbryt {count}",
    "queueCancelJob": "Avbryt",
    "queueCancelFailed": "Kunde inte tömma kön.",
    "queueWaitingFor": "väntat {time}",
    "online": "Online",
    "offlineSince": "Offline — sågs senast {time}",
    "version": "Release {version}",
    "versionUnknown": "okänd",
    "capacityLine": "{platform} · {cpuCount} CPU:er · {memory}",
    "capacityUnknown": "Kapacitet ej rapporterad",
    "acceleratorGpu": "GPU · {device}",
    "acceleratorCpu": "Ingen GPU · endast CPU",
    "acceleratorUnknown": "GPU okänd · runnern svarar inte",
    "battery": "Batteri {percent}%",
    "batteryPaused": "Pausad · batteri {percent}% · fortsätter vid {resume}%",
    "models": "{count} modeller",
    "viewSteps": "Visa steg",
    "howAnalysisWorks": "Så fungerar en bananalys →",
    "stepsTitle": "Så gjordes körningen",
    "stepsClose": "Stäng",
    "stepsLoading": "Hämtar stegen…",
    "stepsFailed": "Kunde inte hämta stegen för den här körningen.",
    "stepsEmpty": "Inga steg registrerade för den här körningen — den är äldre än stegregistreringen, eller nådde aldrig en analysator.",
    "stepsSeconds": "{seconds} s",
    "stepName": {
      "imagery": "Bilder",
      "detect": "Detektering",
      "merge": "Sammanslagning",
      "promote": "Publicering",
      "read-plane": "Lagrat plan läst",
      "derive-plane": "Plan härlett direkt",
      "trace": "Bestånd ritade",
      "crop": "Hålbilder beskurna",
      "candidates": "Sparade som kandidater",
      "unknown": "Okänt steg"
    },
    "startedAt": "Startad {ago} · {time}",
    "startedUnknown": "Starttid ej rapporterad",
    "busy": "Arbetar",
    "busyDetail": "{kind} · {course}",
    "busyKindOnly": "{kind}",
    "busyWaiting": "väntar på analysatorn",
    "idle": "Ledig",
    "stopJob": "Stoppa körningen",
    "stopJobByRestart": "Stoppa den (startar om analysatorn)",
    "stoppingJob": "Stoppar…",
    "stopJobAsked": "Bad {worker} att stoppa den. Den agerar vid nästa hjärtslag, inom 30 s.",
    "stopJobAskedRestart": "Bad {worker} att stoppa den. Analysatorn startar om inom 30 s, och arbetaren tar sedan nästa köade jobb — som kan se likadant ut som det här.",
    "stopJobFailed": "Kunde inte stoppa den — den kan redan ha blivit klar.",
    "jobLogsLink": "Öppna jobbets loggar i Kibana",
    "addServerIntro": "Med goffy-repot utcheckat på maskinen: kör detta och följ anvisningarna. Första körningen skriver .env åt dig att fylla i; den andra startar uppdateraren, som hämtar aktuell release och håller servern på kanalen därefter.",
    "copyCommand": "Kopiera",
    "copied": "Kopierat",
    "addServerStep2": "Eller hoppa över redigeringssteget genom att skicka AWS-nyckeln och ett arbetar-id vid första körningen — då går det rakt igenom:",
    "addServerEnvHeading": "Enradare med inloggningsuppgifter",
    "fullDocsLink": "Fullständig installationsguide (services/batch-worker/README.md)",
    "byWorker": "av {id}",
    "secondsAgo": "{count} s sedan",
    "minutesAgo": "{count} min sedan",
    "hoursAgo": "{count} h sedan",
    "daysAgo": "{count} d sedan"
  },
  "courseStakes": {
    "title": "Gränspinnar",
    "adminOnly": "Endast administratörer.",
    "noCourse": "Ingen bana vald.",
    "nativeOnly": "För att registrera pinnar behövs telefonens GPS och kompass. Öppna detta i Goffy-appen på telefonen.",
    "intro": "Ställ dig vid pinnen, vänd dig mot out of bounds och ta fotot.",
    "hole": "Hål",
    "holeUnknown": "Okänt",
    "kind_out-of-bounds": "Out of bounds (vit)",
    "kind_penalty-red": "Pliktområde (röd)",
    "kind_penalty-yellow": "Pliktområde (gul)",
    "position": "Position",
    "accuracy": "±{meters} m",
    "waitingForFix": "Väntar på GPS-position…",
    "accuracyTooLow": "Stå stilla — noggrannhet {meters} m, behöver under {limit} m.",
    "heading": "Riktning",
    "headingDegrees": "{degrees}°",
    "headingUnavailable": "Kompassen är inte kalibrerad — rör telefonen i en åtta.",
    "takePhoto": "Ta foto och markera pinne",
    "markWithoutPhoto": "Markera utan foto",
    "permissionDenied": "Platsbehörighet krävs för att registrera en pinne.",
    "cameraDenied": "Kamerabehörighet krävs för att ta fotot.",
    "photoRejected": "Fotot kunde inte användas. Försök igen.",
    "recordedCount": "{count} pinnar registrerade i denna session",
    "statusPending": "Laddar upp…",
    "statusDone": "Sparad",
    "statusFailed": "Misslyckades: {error}",
    "retry": "Försök igen",
    "stakeRow": "Hål {hole} · {kind}",
    "stepDown": "Föregående hål",
    "stepUp": "Nästa hål"
  },
  "golfCourseAdminPage": {
    "title": "Golfbaneadministration",
    "forbidden": "Endast administratörer.",
    "totalCourses": "{count} banor i katalogen",
    "loadingCourses": "Laddar banor…",
    "loadCoursesError": "Kunde inte läsa in banor.",
    "searchPlaceholder": "Sök banor på namn, klubb eller id",
    "searchNoMatches": "Inga banor matchar.",
    "filterAll": "Alla",
    "filterAnalysed": "Analyserade",
    "filterNotAnalysed": "Ej analyserade",
    "countryAll": "Alla länder",
    "selectAllShown": "Markera alla visade",
    "selectedCount": "{count} markerade",
    "analyzeSelected": "Analysera markerade",
    "clearSelection": "Rensa",
    "pageRange": "{from}–{to} av {total} · sida {page}/{pages}",
    "previousPage": "Föregående",
    "nextPage": "Nästa",
    "osmFilterGreens": "OSM-greener",
    "osmFilterHoles": "OSM-hål",
    "osmFilterBunkers": "OSM-bunkrar",
    "osmFilterFairways": "OSM-fairways",
    "courseCardOsmFeatures": "OSM-data: {greens} greener · {holes} hål · {bunkers} bunkrar · {fairways} fairways",
    "courseCardScorecardImport": "Golf i Sverige: {holes} hål · {tees} tees · importerat {date}",
    "analysisUnknown": "Okänt",
    "courseCardDetails": "Par {par} · {holes} hål · {tees} tee · {visibility}",
    "courseCardCoordinates": "{lat}, {lon}",
    "courseCardOsm": "OSM {osmType}/{osmId}",
    "scorecardButton": "Scorekort",
    "holeMapButton": "Kartlagda hål",
    "stakesButton": "Registrera pinnar",
    "analysisStatusButton": "Analysstatus",
    "gisImportButton": "Importera GIS",
    "gisImportRunning": "Importerar…",
    "gisImportResult": "Golf i Sverige: {holes} hål och {tees} tee importerade.",
    "gisImportNothing": "Inget importerades från Golf i Sverige: {reason}",
    "gisImportNoReason": "tjänsten angav ingen orsak.",
    "gisImportClub": "Läste klubbsidan: {club}",
    "gisImportFailed": "Importen från Golf i Sverige gick inte att nå.",
    "gisImportForbidden": "Bara administratörer kan köra importen från Golf i Sverige.",
    "analysisFeaturesButton": "Analyserade objekt",
    "findOsmButton": "Hitta golfbanor från OSM",
    "modalTitle": "Importera golfbanor",
    "countryLabel": "Land",
    "importButton": "Importera",
    "importing": "Importerar…",
    "progressAuthoritativeSource": "Importerar gränser från {source}…",
    "progressSearching": "Söker i OpenStreetMap…",
    "progressFound": "Hittade {count} banor",
    "progressFoundWithUnnamed": "Hittade {count} banor, varav {unnamed} saknar namn i OpenStreetMap",
    "resultUnnamedSkipped": "{unnamed} banor saknar namn i OpenStreetMap och importerades som ”Unnamed course …”. Ingen kan hitta dem via sökning förrän de har fått ett namn.",
    "progressImporting": "Importerar {count} banor…",
    "resultFromSource": "{source}: {attached} gränser kopplade, {discovered} banor upptäckta",
    "sourceUnavailable": "{source} var inte tillgängligt — importerade endast från OpenStreetMap",
    "sourceAlreadyImported": "{count} redan importerade",
    "resultSummary": "Importerade {imported}, hoppade över {skipped} som redan fanns",
    "resultFailed": "{failed} kunde inte importeras",
    "importedListTitle": "Importerade banor",
    "error": "Importen misslyckades. Försök igen.",
    "featureImportTitle": "OSM-bandetaljer",
    "clubEnrichmentButton": "Klubbinfo",
    "clubEnrichmentRunning": "Läser …",
    "clubEnrichmentDisabled": "Klubbinformation är inte påslaget i den här miljön.",
    "clubEnrichmentFailed": "Kunde inte läsa klubbarnas webbplatser.",
    "featureImportHint": "Hämtar bunkrar, fairways, tees och greener från OpenStreetMap för varje bana i det valda landet. En batch-arbetare läser hela landets OpenStreetMap-utdrag i en enda genomgång, så den kör utan tillsyn — du kan stänga det här fönstret.",
    "featureImportQueued": "Köad för batch-flottan: {courses} banor.",
    "featureImportQueuedRunning": "Importen körs på en arbetare…",
    "extractQueued": "{country}: köad, {courses} banor.",
    "extractDone": "{country}: {applied} av {courses} banor uppdaterade — {written} objekt skrivna, {updated} uppdaterade.",
    "extractFailed": "{country}: importen misslyckades. {error}",
    "extractNoWorker": "Ingen batch-arbetare är online, så importen väntar tills en är det.",
    "extractCoursesShow": "Visa vad som hände per bana",
    "extractCoursesHide": "Dölj utfall per bana",
    "extractCoursesError": "Kunde inte läsa in utfallen per bana.",
    "extractOutcomeGroup": "{outcome} ({count})",
    "extractOutcomeApplied": "Uppdaterad",
    "extractOutcomeUnchanged": "Redan aktuell",
    "extractOutcomeNoHolesMapped": "Inga numrerade hållinjer i OSM, så inget kunde knytas till ett hål",
    "extractOutcomeNoElements": "Inget hittades i OSM nära banan",
    "extractOutcomeDroppedNoIdentity": "Ingen OSM-identitet, så den skickades inte",
    "extractOutcomeDroppedNoPosition": "Ingen position, så den skickades inte",
    "extractOutcomeSkippedNoIdentity": "Identiteten saknades vid skrivningen, så den hoppades över",
    "extractOutcomeNotRun": "Kördes inte, importen misslyckades först",
    "extractOutcomeFailed": "Misslyckades",
    "extractOutcomeRequested": "Köad",
    "extractOutcomeOther": "{outcome}",
    "osmExtractRow": "Senaste OSM-import: {outcome}",
    "featureImportButton": "Importera bandetaljer från OSM",
    "featureImportRunning": "Importerar OSM-detaljer…",
    "featureImportError": "Importen av OSM-detaljer misslyckades. Försök igen.",
    "featureImportNoExtract": "Inget OpenStreetMap-utdrag är konfigurerat för det här landet. Lägg till det i OsmExtract:Paths i geodata-service.",
    "featureImportNoCourses": "Ingen bana i det här landet har någon OpenStreetMap-identitet ännu. Importera landets banor från OpenStreetMap först.",
    "backfillButton": "Fyll i saknad analys",
    "backfillRunning": "Fyller i…",
    "backfillProgress": "{matched} matchade via OSM, {triggered} startade utan match, {failed} misslyckades",
    "backfillDone": "Klart: {matched} matchade via OSM, {triggered} startade utan match, {failed} misslyckades",
    "backfillError": "Kunde inte fylla i. Försök igen.",
    "setVisibility": "Ange synlighet",
    "visibilityChipOfficial": "Officiell",
    "visibilityChipPrivate": "Privat",
    "visibilityChipDisabled": "Inaktiverad",
    "editCourse": "Redigera",
    "visibilityPickerTitle": "Synlighet för {count} valda",
    "visibilityOfficial": "Officiell — i den delade katalogen, alla kan välja den",
    "visibilityPrivate": "Privat — bara skaparen och spelarna den delats med",
    "visibilityDisabled": "Avstängd — dold överallt, ingen kan välja den",
    "visibilityDone": "Synlighet satt på {updated} banor, {failed} misslyckades",
    "visibilityError": "Kunde inte ange synlighet. Försök igen.",
    "close": "Stäng",
    "flyoverButton": "Flygtur",
    "flyoverModalTitle": "Rendera flygturer: {name}",
    "flyoverExplainer": "Flygtursvideor renderas lokalt, en gång per bana (kräver Lantmäteriet-täckning). Kopiera kommandot och klistra in i en terminal i repots rot — skriptet öppnar en inloggningslänk; godkänn den i webbläsaren där du redan är inloggad. Kräver AWS-uppgifter, ffmpeg och course-analysis-tjänstens Python-venv. Ta bort --dry-run för att ladda upp resultatet.",
    "flyoverCopy": "Kopiera kommando",
    "flyoverCopied": "Kopierat",
    "osmRefreshButton": "Uppdatera OSM",
    "osmRefreshRunning": "Uppdaterar OSM…",
    "osmRefreshResult": "OSM uppdaterat: {written} nya, {updated} ändrade, {removed} borttagna, {unchanged} oförändrade",
    "osmRefreshFailed": "OSM-uppdatering misslyckades",
    "actionNoGeodata": "Banan har ännu ingen geodatapost, så det finns inget att arbeta med.",
    "analyzeNoPosition": "Banan har ingen registrerad position, så analysen har ingenstans att rikta sig.",
    "osmRefreshNoIdentity": "Banan har ingen OpenStreetMap-identitet att uppdatera från. Importera den från OpenStreetMap först.",
    "osmRefreshOverpassSilent": "OpenStreetMap svarade inte för den här banan. Försök igen senare.",
    "osmRefreshFailedStatus": "OSM-uppdatering misslyckades ({status}).",
    "analysisNotConfigured": "Bildanalys är inte konfigurerad i den här miljön.",
    "flyoverNoHoles": "Inget hål på den här banan har både utslagsplats och green, så det finns inget att flyga.",
    "flyoverRenderFailed": "Flygturen kunde inte köas. Försök igen.",
    "openInEsri": "Öppna i Esri",
    "openInOsm": "Öppna i OSM",
    "flyoverSelected": "Flygning vald",
    "flyoverRender": "Rendera flygningar",
    "flyoverRequesting": "Begär…",
    "flyoverQueued": "Köad. En arbetare tar den nästa gång någon är påslagen.",
    "flyoverNothingToFly": "Inget hål på den här banan går att flyga ännu.",
    "flyoverWorkerOnline": "En renderingsarbetare är online.",
    "flyoverWorkerOffline": "Ingen renderingsarbetare är online. Jobbet väntar tills någon är det.",
    "flyoverWorkerExplainer": "Flygningar renderas på en batcharbetare utanför molnet. Köa jobbet här så körs det nästa gång en arbetare slås på.",
    "flyoverShowCommand": "Visa det manuella kommandot",
    "flyoverHideCommand": "Dölj det manuella kommandot",
    "flyoverLastJob": "Senaste jobb: {status} — {rendered} renderade, {skipped} överhoppade",
    "flyoverStateRendered": "{holes} hål renderade",
    "flyoverStateQueued": "Flygning köad",
    "flyoverStateFailed": "Flygningen misslyckades",
    "flyoverJobStatus": {
      "queued": "köad",
      "succeeded": "lyckades",
      "failed": "misslyckades"
    },
    "clubEnrichmentDone": "Klubbinfo hämtad. Logotyp: {logo}. Beskrivning: {description}.",
    "clubEnrichmentSkipped": "Inget hämtat: {reason}",
    "clubEnrichmentNoReason": "ingen orsak angiven",
    "yes": "ja",
    "no": "nej",
    "openClubPage": "Klubbsida",
    "extractOutcomes": "{current} redan aktuella · {noOsm} saknar data i OpenStreetMap · {remaining} kvar att importera"
  },
  "deleteAccountPage": {
    "title": "Radera ditt Goffy-konto",
    "updated": "Senast uppdaterad {date}",
    "intro": "Du kan radera ditt Goffy-konto när du vill. Här står vad som tas bort, vad som ligger kvar och hur du gör.",
    "removedH": "Det här raderas",
    "removedP": "Din inloggning, din profil och uppgifterna på den — bild, handicap, kön och hemmaklubbar. Raderingen är permanent och går inte att ångra.",
    "keptH": "Det här ligger kvar",
    "keptP": "Ronder och tourer du spelat ligger kvar på de andra spelarnas scorekort, fortfarande med ditt namn, eftersom en radering skulle skriva om någon annans rond.",
    "inAppH": "I appen",
    "inAppP": "Öppna menyn, gå till Profil och använd Radera mitt konto längst ned på sidan.",
    "signedOutH": "Om du inte kan logga in",
    "signedOutP": "Mejla privacy@goffy.app från adressen på kontot, så raderar vi det åt dig."
  },
  "terms": {
    "title": "Tjänstevillkor",
    "updated": "Senast uppdaterad {date}",
    "intro": "Goffy sparar golfronder. Det här är villkoren för att använda tjänsten. Kort sagt: var schysst, använd Goffy till golf och håll ditt konto säkert.",
    "accountH": "Ditt konto",
    "accountP": "Du ansvarar för det som händer på ditt konto. Håll lösenordet för dig själv och använd ett namn som dina medspelare känner igen — scorekort delas med dem du spelar med.",
    "fairUseH": "Schysst användning",
    "fairUseP": "Missbruka, attackera eller störa inte tjänsten, och använd den inte för att trakassera andra spelare. Vi kan stänga ett konto som gör det.",
    "dataH": "Dina uppgifter",
    "dataP": "Vi lagrar de kontouppgifter som behövs för att driva tjänsten, inte mer. Vad vi samlar in, var det lagras och hur du får det borttaget står i integritetspolicyn.",
    "warrantyH": "Ingen garanti",
    "warrantyP": "Goffy tillhandahålls i befintligt skick. Vi gör vårt bästa för att hålla resultat säkra och tjänsten igång, men vi kan inte garantera att den är felfri eller alltid tillgänglig, och ett resultat som registreras här är inte en officiell handicapregistrering.",
    "changesH": "Ändringar",
    "changesP": "Villkoren kan uppdateras över tid. Datumet ovan ändras när de gör det."
  },
  "about": {
    "title": "Om",
    "version": "Version",
    "build": "Bygge",
    "commit": "Commit",
    "buildDate": "Byggdatum",
    "licensesHeading": "Licenser för öppen källkod",
    "licensesIntro": "Goffy är byggt med {count} paket med öppen källkod. Tryck på ett för att se dess licens.",
    "licenseTextUnavailable": "Licenstext ej tillgänglig.",
    "close": "Stäng"
  },
  "ai": {
    "playAgainstAi": "Spela mot AI-spelare",
    "revealMode": "AI-resultat",
    "revealInAdvance": "Visa i förväg",
    "revealAsIScore": "Visa när vi har fört score",
    "addAiPlayer": "Lägg till AI-spelare",
    "pureAi": "AI-spelare",
    "ghostOfMe": "Spöke av mig",
    "ghostOfFriend": "Spöke av en vän",
    "aiBadge": "AI",
    "ghostBadge": "Spöke",
    "pendingReveal": "Visas när alla har fört score",
    "ghostNamePrefix": "Spöket {name}",
    "aiCreateFailed": "Kunde inte skapa AI-spelaren. Försök igen.",
    "aiPlayersHint": "AI-spelare och människor delar samma lista — max {count} totalt."
  },
  "courseAnalysisStatusPage": {
    "noCourse": "Ingen bana angavs, så det finns inget att rapportera. Öppna den här sidan från en bana i adminlistan."
  },
  "courseScorecardPage": {
    "title": "Scorekort",
    "loading": "Hämtar banan…",
    "failed": "Kunde inte hämta banan.",
    "retry": "Försök igen",
    "courseMeta": "{holes} hål · par {par} · {visibility}",
    "teesTitle": "Tee",
    "noTees": "Inga tee är inlagda för den här banan.",
    "tee": "Tee",
    "courseRating": "Banvärde",
    "slopeRating": "Slope",
    "par": "Par",
    "holesTitle": "Hål",
    "hole": "Hål",
    "strokeIndex": "Index",
    "holeColumn": "Utan tee",
    "total": "Totalt",
    "noHoles": "Inga hål är inlagda för den här banan.",
    "noLengths": "Ingen längd är lagrad för något hål än.",
    "sourcesNote": "Längder som de är lagrade, bäst belagda först, var och en med källan som mätte den. Källor här: {sources}. Bara vår egen mätning visas någonsin för en spelare.",
    "unnamedTee": "Namnlös tee",
    "sex": {
      "male": "herr",
      "female": "dam",
      "unisex": "alla"
    },
    "cardColumn": "Kort (par / index)",
    "noCards": "Ingen källa har angett ett kort för något hål ännu.",
    "cardsNote": "Kort som de angetts, bäst underbyggda först, var och en med källan som angav det. Källor här: {sources}. Kolumnerna Par och SI är vad en spelare ser; ett angivet kort skriver aldrig över dem.",
    "cardsDifferNote": "{count} av {total} hål har ett angivet kort som avviker från lagrat par eller spelhandicapindex.",
    "useSource": "Använd {source}",
    "adopting": "Sparar…",
    "adoptNote": "”Använd …” under en kolumn gör den källans värden till de officiella för varje hål den täcker, lagrade som om en administratör hade skrivit in dem.",
    "adoptFailed": "Kunde inte göra värdena officiella. Försök igen."
  },
  "courseAnalysis": {
    "title": "Analys av bandata",
    "adminOnly": "Den här sidan är bara tillgänglig för administratörer.",
    "failed": "Kunde inte läsa in banans data.",
    "empty": "Ingen kartlagd data för banan ännu.",
    "holeTitle": "Hål {hole}",
    "unattributed": "Inte kopplad till något hål",
    "reports": "Rapporter",
    "reportBadge": "{count} rapporterat felaktig",
    "noFeatures": "Inga kartlagda objekt.",
    "meta": "Tillförlitlighet {confidence}% · {state}",
    "reviewed": "granskad",
    "unreviewed": "ogranskad",
    "polygon": "polygon",
    "centreOnly": "endast centrumpunkt, ingen gräns",
    "sampleCount": "{count} bidragsgivare",
    "kind": {
      "tee": "Tee",
      "green": "Green",
      "bunker": "Bunker",
      "water": "Vatten",
      "other": "Övrigt",
      "fairway": "Fairway",
      "trees": "Träd",
      "path": "Väg eller stig"
    },
    "source": {
      "osm": "OSM",
      "gps": "GPS",
      "lantmateriet": "Lantmäteriet",
      "satellite": "Satellit",
      "manual": "Manuell",
      "derived": "Härledd"
    },
    "holeChecks": {
      "title": "Hålkontroller",
      "intro": "Vad varje hål visar spelarna och från vem, och vad den senaste analysen höll tillbaka eller flaggade för en person att titta på.",
      "failed": "Kunde inte hämta hålkontrollerna.",
      "unavailable": "Hålkontroller är inte tillgängliga i den här miljön.",
      "notChecked": "Kontrollerna har inte körts på den här banan ännu.",
      "summary": "{held} tillbakahållna · {flagged} flaggade · {incomplete} hål ofullständiga",
      "par": "Par {par}",
      "featureLine": "{kind}: {sources}",
      "none": "inget",
      "missing": "Saknas: {kinds}",
      "held": "Tillbakahållen: {rule} ({kind}, {before} → {after})",
      "trimmed": "Beskuren: {rule} ({kind}, {share} borttaget)",
      "flagged": "Flaggad för en person: {rule} ({source}, {kind})",
      "flaggedHole": "Flaggat för en person: {rule}",
      "rule": {
        "one-green": "En andra green",
        "tee-distance": "Teeavståndet passar inte hålets par",
        "tee-back-half": "Tee efter halva hålet",
        "fairway-on-par-3": "Fairway på ett par 3",
        "fairway-missing": "Ingen fairway på ett par 4 eller 5",
        "trees-on-play": "Träd på fairway eller green",
        "cover-trimmed": "Överlappade en ritad gräns",
        "cover-covered": "Redan ritad av en starkare källa"
      }
    },
    "guide": {
      "title": "Banguide — hål {hole}",
      "length": "{metres} m",
      "unavailable": "För lite geometri för att rita hålet. Tee och green är minimum.",
      "arcsNote": "Bågarna är meter till greenens framkant.",
      "missingCover": "Saknas i kartan: {kinds} — kör satellitanalysen igen för att fylla i bilden.",
      "derivedNotice": "Ritad från ogranskad satellitanalys. Fairwaykanten skiljs från ruffen enbart på klipphöjd och trädlinjen är en skuggradient — betrakta varje gräns som ett förslag.",
      "nothingMapped": "Inga gränser kartlagda för hålet — bara tee- och greenpositionerna är kända. Satellitanalysen har ännu inte gett några polygoner för banan."
    },
    "status": {
      "open": "Bananalys",
      "title": "Bananalys",
      "failed": "Kunde inte hämta analysstatus.",
      "endpointMissing": "Den här backenden har inte analys-endpointen än. Frontend ligger före geodata-service — deploya den (migreringen körs vid uppstart) så fylls panelen i.",
      "attempts": "Försök {attempts} av {max}",
      "requestedAt": "Begärd",
      "analysedAt": "Analyserad",
      "never": "aldrig",
      "selectedRun": "Vald körning",
      "neverRun": "Ingen analys har någonsin körts för den här banan.",
      "visualise": "Visa analysen som diagram",
      "durationSeconds": "Tog {seconds} s",
      "durationMinutes": "Tog {minutes} min {seconds} s",
      "stored": "Sparade objekt",
      "noFeatures": "Inga objekt sparade för den här banan.",
      "featureMeta": "{count} från {source} · {polygons} med gränser",
      "run": "Kör analys nu",
      "running": "Begär…",
      "queued": "Köad. Analysen plockar upp den inom några minuter — öppna panelen igen för att se resultatet.",
      "runFailed": "Kunde inte begära analys.",
      "queueDepth": "Analysko",
      "queueDepthCount": "{count} väntar, alla banor",
      "queueDepthUnknown": "Kunde inte läsa köns storlek.",
      "state": {
        "disabled": "Avstängd",
        "neverRequested": "Aldrig begärd",
        "pending": "Väntar",
        "abandoned": "Övergiven",
        "analysed": "Analyserad"
      },
      "explain": {
        "disabled": "Ingen bildanalys är konfigurerad i den här miljön, så ingen bana kan analyseras. Det är en fråga om deploy och konfiguration — att köra om hjälper inte.",
        "neverRequested": "Banan har aldrig köats för analys — troligen importerad innan funktionen fanns. Att köra den nu är allt som behövs.",
        "pending": "Köad och väntar på bakgrundsloopen, som plockar banor med ett intervall.",
        "abandoned": "Analysen misslyckades med sina försök och görs inte om av sig själv. Se senaste körningen nedan för orsaken, och kör igen när den är åtgärdad.",
        "analysed": "En körning har slutförts för banan. Senaste körningen nedan visar vad den gav."
      },
      "providerLine": "{provider}: {written} skrivna, {replaced} ersatta, {skipped} hoppade över (starkare källa) · rutor {fetched}/{attempted}",
      "providerFailed": "misslyckades: {error}",
      "providerPartial": "bilderna är ofullständiga",
      "jobs": {
        "summary": "{done} av {total} jobb klara",
        "failed": "{count} misslyckades",
        "partial": "{count} delvis"
      },
      "jobStatus": {
        "planned": "Väntar",
        "dispatched": "Hos en arbetare",
        "succeeded": "Klart",
        "partial": "Delvis",
        "failed": "Misslyckades"
      },
      "jobKind": {
        "detection": "Detektering",
        "canopy-height": "Trädhöjd",
        "elevation": "Höjdprofil",
        "imagery-products": "Hålbilder",
        "locate": "Hitta banan"
      },
      "jobWaitingOn": "väntar på {source}",
      "jobLogs": "Loggar",
      "jobWorker": "hos {worker}",
      "runWithFailures": "med fel",
      "runStatus": {
        "awaiting-data": "Väntar på data",
        "dispatched": "Köad till en arbetare",
        "running": "Pågår",
        "succeeded": "Lyckades",
        "partial": "Delvis",
        "failed": "Misslyckades"
      },
      "externalTitle": "Se närmare",
      "externalLogs": "Loggar",
      "externalMetrics": "Instrumentpaneler",
      "externalHint": "Kibana och Grafana, öppnade på den senaste körningen."
    }
  },
  "shotTrackingDebug": {
    "title": "Felsökning slagmätning",
    "developersOnly": "Den här sidan är bara tillgänglig för utvecklare.",
    "status": "Status",
    "audio": "Ljud live",
    "noAudio": "Ingen ljuddata — mikrofonen öppnas när du står stilla, eller direkt när puttestet kör.",
    "simulate": "Simulera träff",
    "simulated": "Träff injicerad i den skarpa kedjan.",
    "noSession": "Ljudfångst otillgänglig på denna enhet — handledstoppar från klockan visas ändå.",
    "clear": "Rensa logg",
    "startSession": "Starta testsession",
    "stopSession": "Stoppa testsession",
    "sessionFailed": "Kunde inte starta testsession: {reason}",
    "puttTest": "Puttest",
    "puttTestHint": "Håller mikrofonen öppen (fungerar inomhus, ingen GPS behövs) och skickar inget till ronden. Sidan föreslår en kandidat för varje putt den hör eller känner — döm var och en, och tryck \"Missad putt\" när du puttade utan att något föreslogs. Kandidater födda i ett knapptryck räknas bort som tryckljud.",
    "puttTestStart": "Starta puttest",
    "puttTestStop": "Stoppa puttest",
    "marks": "Markeringar skickade från denna enhet",
    "server": "Fusionerade slag från servern",
    "log": "Händelselogg",
    "none": "Inget ännu.",
    "close": "Stäng",
    "judgePrompt": "döm nedan",
    "listening": "Lyssnar — putta när du är redo.",
    "verdictCorrect": "Rätt putt",
    "verdictWrong": "Inte en putt",
    "verdictMissed": "Missad putt",
    "puttEstimateSummary": "{correct} rätt · {wrong} fel · {missed} missade · {pending} ovärderade"
  },
  "schedule": {
    "title": "Schemalägg runda",
    "heading": "Schemalägg en runda",
    "teeTimeLabel": "Starttid",
    "pickTeeTime": "Välj starttid",
    "pickCourse": "Bana",
    "nameLabel": "Rundans namn (valfritt)",
    "namePlaceholder": "Rundans namn",
    "holesLabel": "Hål",
    "holes18": "18 hål",
    "holes9": "9 hål",
    "submit": "Schemalägg runda",
    "submitting": "Schemalägger...",
    "success": "Rundan är schemalagd.",
    "missingCourse": "Välj en bana först.",
    "missingTeeTime": "Välj en starttid först.",
    "error": "Det gick inte att schemalägga rundan.",
    "rejected": "Rundan kunde inte schemaläggas.",
    "creatingTour": "Förbereder...",
    "upcomingTitle": "Kommande rundor",
    "scheduleRoundCta": "Schemalägg runda",
    "notifyByEmail": "Skicka inbjudningar via e-post",
    "notifyByEmailHint": "Medlemmar ser den alltid i appen – e-post är valfritt."
  },
  "rsvp": {
    "title": "OSA",
    "heading": "Kommer du?",
    "teeTime": "Starttid",
    "course": "Bana",
    "accept": "Kommer",
    "decline": "Kommer inte",
    "maybe": "Kanske",
    "whoIsComing": "Vilka kommer",
    "respondedAt": "Svarade {time}",
    "noResponses": "Inga svar än.",
    "comingCount": "{count} kommer",
    "loading": "Laddar...",
    "loadError": "Det gick inte att ladda rundan.",
    "sending": "Sparar ditt svar...",
    "sendError": "Det gick inte att spara ditt svar.",
    "statusInvited": "Inbjuden",
    "statusAccepted": "Kommer",
    "statusDeclined": "Kommer inte",
    "statusTentative": "Kanske",
    "myStatusLabel": "Ditt svar"
  },
  "beta": {
    "badge": "Beta",
    "badgeLabel": "Goffy är i beta — tryck för att läsa vad det innebär",
    "title": "Goffy är i beta",
    "body": "Goffy byggs fortfarande. Du kommer att stöta på ojämnheter och sådant som ännu inte fungerar.",
    "feedback": "Hittade du något fel? Att berätta det för oss är snabbaste vägen till en rättning."
  },
  "mlModels": {
    "trainSet": "Träningsuppsättning: {name}",
    "open": "Modeller",
    "title": "Detekteringsmodeller",
    "close": "Stäng",
    "empty": "Ingen modell har poängsatts ännu.",
    "failed": "Kunde inte hämta modellerna.",
    "unavailable": "Modellpoäng är inte tillgängligt i den här miljön.",
    "legend": "Stjärnorna är F1 per objekttyp mot OpenStreetMap på banor modellen aldrig sett, 0–5, från senaste evaluate.py-körningen. Raden ovanför är vad train.py registrerade.",
    "datasets": "{count} träningsdatamängder",
    "trainingMiou": "Tränings-mIoU {value}",
    "epochs": "{count} epoker",
    "channelsRgb": "RGB",
    "channelsNir": "RGB + infrarött",
    "trainedOn": "{crops} utklipp från {courses} banor",
    "batchAndRate": "batch {batch} · lr {rate}",
    "providers": "bilder {providers}",
    "checkpointPublished": "checkpoint i det delade lagret",
    "checkpointLocal": "checkpoint bara på träningsmaskinen",
    "dataset": "Datamängd: {description}",
    "notEvaluated": "Inte utvärderad än — ingen evaluate.py-körning har bedömt modellen mot en holdout-bana, så det finns inga stjärnor att ge.",
    "noScore": "inget resultat",
    "starsLabel": "{stars} av 5 stjärnor",
    "scoreDetail": "F1 {f1} · P {p} · R {r}",
    "scoredOn": "{count} banor",
    "detailsShow": "Detaljer",
    "detailsHide": "Dölj detaljer",
    "detailId": "Modell-id",
    "detailName": "Namn och version",
    "detailArchitecture": "Arkitektur",
    "detailTrainedAt": "Tränad",
    "detailEncoder": "Encoder",
    "detailChannels": "Indatakanaler",
    "detailEpochs": "Epoker",
    "detailBatchSize": "Batchstorlek",
    "detailLearningRate": "Inlärningshastighet",
    "detailMiou": "Tränings-mIoU",
    "detailBestValLoss": "Lagrad bästa valideringsförlust",
    "detailProviders": "Bildkällor",
    "detailTrainSet": "Träningsuppsättning",
    "detailTrainCrops": "Träningsutklipp",
    "detailDatasetId": "Datamängds-id",
    "detailDataset": "Datamängd",
    "detailCheckpoint": "Checkpoint",
    "detailNotes": "Anteckningar",
    "detailTrainCourses": "Tränad på",
    "detailHoldoutCourses": "Undanhållna för poängsättning",
    "detailNone": "inga registrerade",
    "detailEvaluations": "Senaste resultat per objekttyp",
    "detailEvaluationLine": "{kind}: F1 {f1} · precision {p} · recall {r} · IoU {iou} · {matched} träffar, {missed} missade, {falsePositive} falska · {courses} banor · {provider} · {when}",
    "whyNoHoldout": "train.py registrerade ingen holdout-bana för körningen, så ingen utvärdering lades in: ett resultat är bara värt något på banor modellen aldrig sett. Träna från en datamängd vars uppdelning håller undan banor.",
    "whyWaitingForImagery": "En utvärdering är inlagd och väntar på att holdout-banornas bilder hämtas. Den kör av sig själv när sista banan rapporterat.",
    "whyQueued": "En utvärdering är köad och väntar på att en arbetare med ml-förmåga plockar upp den.",
    "whyFailed": "Utvärderingskörningen misslyckades: {error}",
    "whyCancelled": "Utvärderingskörningen avbröts innan den gav något resultat.",
    "whyRanWithoutScore": "Utvärderingskörningen blev klar utan att registrera något resultat.",
    "whyNotFiled": "Ingen utvärderingskörning som nämner den här modellen finns bland körningarna sidan har (de 50 senaste). Uppföljningen som geodata lägger in efter en träningskörning har antingen aldrig skett eller hunnit falla ur listan — titta i körningsfönstret, och köa en evaluate-körning i körfönstret om ingen finns.",
    "whyUnknown": "Det finns inget resultat registrerat, och sidan har inte hämtat körningarna — så den kan inte säga om någon utvärdering någonsin lades in. Öppna körningsfönstret för att ta reda på det.",
    "detailViewOnCourse": "Öppna på bankartan"
  },
  "mlModelVote": {
    "title": "Modellröster — A/B",
    "legend": "Varje klassisk detektion på banorna en modell har analyserat bedöms två gånger: som i dag, och med modellens röst — höjd där modellen ritade samma sak, sänkt där den tittade och inte ritade något. Verklig betyder att OSM, GPS eller en person säger att den finns; falsk betyder att en person har avvisat den. Allt annat är okänt. På kartlagda banor sparas de flesta verkliga detektioner aldrig, så de bedömda antalen är små.",
    "failed": "Kunde inte hämta jämförelsen av modellröster.",
    "unavailable": "Jämförelsen av modellröster är inte tillgänglig i den här miljön.",
    "empty": "Ingen tränad modell har analyserat någon bana ännu, så det finns inget att jämföra.",
    "inForce": "I bruk: {version}, rösterna flyttar detektioner med ±{delta}.",
    "notInForce": "Inga modellröster i produktion. Inget här ändrar vad spelarna ser förrän en har konfigurerats.",
    "model": "Modell",
    "delta": "Röststyrka",
    "coverage": "{judged} av {available} banor jämförda · visningsgräns {floor}",
    "updating": "Uppdaterar…",
    "votes": "{candidates} detektioner · modellen håller med om {agrees}, motsäger {contradicts}, är oklar om {inconclusive}, röstar inte om {notAsked}",
    "clears": "Klarar visningsgränsen: {without} i dag → {with} med röster",
    "judged": "Bedömda ({real} verkliga, {false} falska): precision {precisionWithout} → {precisionWith}, täckning {recallWithout} → {recallWith}",
    "judgedCounts": "Falska som visas {fpWithout} → {fpWith} · verkliga som döljs {missedWithout} → {missedWith}",
    "notJudged": "Ingen av de här detektionerna har bedömts ännu.",
    "course": "{name}: {without} → {with} klarar gränsen ({agrees} håller med, {contradicts} motsäger)",
    "holdoutTitle": "Utvärderingsbanor ({courses}, {provider}), jämförda mot OSM",
    "holdoutKind": "{kind} ({mapped} kartlagda): precision {precisionWithout} → {precisionWith}, täckning {recallWithout} → {recallWith}, F1 {f1Without} → {f1With}",
    "holdoutNone": "Modellen har inte utvärderats på utvärderingsbanor ännu.",
    "holdoutNoConfidence": "Den senaste utvärderingen av modellen är äldre än de sparade konfidenserna. Kör evaluate igen för att bedöma rösterna på utvärderingsbanorna."
  },
  "mlThresholdProfiles": {
    "title": "Intrimmade tröskelprofiler",
    "legend": "Registrerade av en trimningskörning. En profil gör ingenting förrän den tas i bruk; den börjar gälla vid nästa analys, och tas den ur bruk återgår tröskelvärdena till de inbyggda. Varje grupp av tröskelvärden tas i bruk för sig, eftersom en körning ofta är värd att behålla för en klass men inte för en annan.",
    "empty": "Ingen trimningskörning har registrerat någon profil ännu.",
    "failed": "Kunde inte hämta tröskelprofilerna.",
    "unavailable": "Tröskelprofiler är inte tillgängliga i den här miljön.",
    "tunedOn": "Trimmad {when} · {trainCrops} träningsutsnitt, {holdoutCrops} utvärdering",
    "trainScore": "Träning {tuned} (utgångsläge {baseline})",
    "holdoutScore": "Utvärdering {tuned} (utgångsläge {baseline})",
    "noHoldout": "Inga utvärderingsbanor i den här körningen",
    "baselineSource": "Utgick från profilen {source}",
    "changed": "Ändrat: {fields}",
    "changedNothing": "Körningen ändrade inget tröskelvärde som banorna var eniga om.",
    "group": "Tröskelvärden för {group} ({kinds})",
    "groupEverything": "Alla tröskelvärden i profilen",
    "overfitGroup": "De här tröskelvärdena får sämre resultat på utvärderingsbanorna än utgångsläget och kan därför inte tas i bruk.",
    "promoted": "I bruk",
    "promote": "Ta i bruk",
    "demote": "Ta ur bruk"
  },
  "myRounds": {
    "title": "Mina ronder",
    "signedOut": "Logga in för att se dina ronder.",
    "loading": "Hämtar dina ronder…",
    "empty": "Du har inte spelat någon räknad rond ännu.",
    "retry": "Försök igen",
    "noPlayer": "Vi hittade ingen spelarpost för dig.",
    "loadFailed": "Kunde inte hämta dina ronder.",
    "inProgress": "Pågår",
    "roundScore": "{gross} ({toPar})",
    "positionOf": "{position} av {total}",
    "addRound": "+ Lägg till rond"
  },
  "logRound": {
    "title": "Logga en rond",
    "courseLabel": "Bana",
    "teeLabel": "Tee",
    "holesLabel": "Hål",
    "dateLabel": "Datum",
    "handicapLabel": "Spelhandicap",
    "modeLabel": "Hur vill du registrera den?",
    "modeTotal": "Bara totalresultat",
    "modeHoleByHole": "Hål för hål",
    "createButton": "Skapa rond",
    "creating": "Skapar…",
    "createFailed": "Kunde inte skapa ronden. Försök igen."
  },
  "logTotalScore": {
    "title": "Totalresultat",
    "grossStrokesLabel": "Totalt antal slag",
    "saveButton": "Spara",
    "saving": "Sparar…",
    "saveFailed": "Kunde inte spara resultatet. Försök igen."
  },
  "logScorecard": {
    "title": "Scorekort",
    "hole": "Hål",
    "par": "Par",
    "hcpDot": "Hcp",
    "score": "Resultat",
    "finishButton": "Avsluta rond",
    "finishing": "Avslutar…",
    "enterAtLeastOne": "Ange ett resultat för minst ett hål.",
    "loadFailed": "Kunde inte hämta banans hål."
  },
  "documentationPage": {
    "title": "Dokumentation",
    "intro": "Var man läser om hur plattformen fungerar: presentationerna som följer med webbappen, och dokumenten som ligger bredvid koden i repot.",
    "forbidden": "Den här sidan är för utvecklare och administratörer.",
    "presentationsHeading": "Presentationer",
    "presentationsDetail": "Genomgångar med flödesdiagram och uppmätta siffror, framtagna ur koden som den såg ut det datum de bär.",
    "repositoryHeading": "Dokumentation i repot",
    "repositoryDetail": "Renderas från main-grenen på Gitea; inloggning i repot krävs.",
    "opensInBrowser": "Öppnas i webbläsaren",
    "opensHere": "Öppnas här, inne i appen",
    "nativeHint": "Presentationerna läses i webbappen; öppna goffy.app i en webbläsare och välj Dokumentation i adminmenyn.",
    "unknownDeck": "Det finns ingen presentation med det namnet.",
    "back": "Tillbaka till dokumentationslistan",
    "docs": {
      "courseAnalysis": {
        "title": "Bananalys: från ortofoto till hålobjekt",
        "description": "Hur en analyskörning planeras, fönstren och färggränserna, konfidens och publicering, sedan datasetet, U-Net-modellen, tröskelsökaren och dess resultat."
      },
      "mlModel": {
        "title": "Detektionsmodellen: träning, utvärdering och användning i analysen",
        "description": "Sömmen raw_masks, datasetet och uppdelningen, träningsloopen, varje checkpoints holdout-poäng, evaluate.py, modelljobb i en körning och registret."
      },
      "architectureRules": "Arkitektur- och kodregler (CLAUDE.md)",
      "courseAnalysisService": "Bananalystjänsten",
      "trainingTools": "Träningsverktyg: extract, train, evaluate, tune",
      "baseline": "Klassisk baslinje och trimningshistorik",
      "batchWorkers": "Batch-arbetare",
      "addingGolfGame": "Lägga till ett golfspel",
      "gitWorkflow": "Git-arbetsflöde",
      "keycloakProd": "Keycloak-åtkomst i produktion",
      "postgresBackup": "Postgres backup och återställning",
      "swish": "Återkommande Swish-betalningar",
      "envoy401": "Felsöka Envoy 401",
      "tourCreatorRepair": "Reparera tourskaparens medlemskap",
      "asyncApi": "AsyncAPI-meddelandekontrakt"
    }
  },
  "mlTrainingPage": {
    "title": "ML och träning",
    "intro": "Detektionsmodellerna: vad som har tränats, vad som återstår att träna på och knappen som köar en körning. Data — inte kod — har varit flaskhalsen, så avsnittet om träningsdata är det som betyder något.",
    "forbidden": "Den här sidan är för utvecklare och administratörer.",
    "loading": "Laddar…",
    "retry": "Försök igen",
    "refresh": "Uppdatera",
    "runHeading": "Köa en körning",
    "jobsHeading": "Senaste körningar",
    "modelsHeading": "Tränade modeller",
    "dataHeading": "Träningsdata",
    "jobsFailed": "Kunde inte hämta körhistoriken.",
    "noJobs": "Inget har körts än.",
    "showOutput": "Visa utdata",
    "outputTitle": "{tool} — utdata",
    "dataFailed": "Kunde inte hämta träningsdata.",
    "noData": "Ingen bana har några kartlagda objekt att träna på än.",
    "workerOnline": "En ML-arbetare är online — en köad körning startar direkt.",
    "workerOffline": "Ingen ML-arbetare är online. Körningen kan ändå köas och väntar tills en startar.",
    "workerBattery": "Maskinens batteri är på {percent}%. En körning pausas vid {pause}% och fortsätter vid {resume}%.",
    "workerBatteryPaused": "ML-arbetaren har pausat sin körning: maskinens batteri är på {percent}%. Körningen fortsätter av sig själv när batteriet når {resume}% — koppla in laddaren.",
    "tool": "Verktyg",
    "tools": {
      "extract": "Ta fram dataset",
      "train": "Träna",
      "evaluate": "Utvärdera",
      "tune": "Trimma tröskelvärden"
    },
    "toolHints": {
      "extract": "Klipper ut märkta bildrutor ur de lagrade bilderna och skriver dem under training/data.",
      "train": "Tränar ett Unet på de utklippta rutorna och skriver en checkpoint.",
      "evaluate": "Poängsätter en checkpoint, eller de klassiska tröskelvärdena, mot kartlagda banor — som standard modellens holdout, från lagrade bilder.",
      "tune": "Söker fram de bästa tröskelvärdena per bildkälla för den klassiska detektorn mot de märkta bildrutorna och rapporterar den bästa profilen."
    },
    "provider": "Bildleverantör",
    "fromS3": "Från lagrade bilder, i analysupplösning",
    "evaluateModel": "Modell",
    "evaluateClassical": "Endast klassiska tröskelvärden",
    "evaluateNoModels": "Ingen registrerad modell ännu — den klassiska detektorn poängsätts.",
    "evaluateCourses": "Banor att poängsätta",
    "evaluateHoldout": "Modellens holdout ({count})",
    "evaluateNoCourses": "Välj minst en bana — evaluate.py gissar inte.",
    "setsHeading": "Banuppsättningar",
    "setsDetail": "Namngivna uppsättningar banor att träna på eller poängsätta mot.",
    "setsCount": "{count} uppsättningar",
    "trainingSet": "Träningsuppsättning",
    "trainingSetAll": "Alla banor i träningsdelen",
    "trainDataHint": "Tränar på den senaste datamängden klippt från lagrade bilder i analysens zoomnivå. Täcker ingen alla dagens kvalificerade banor klipps en först, och körningen väntar på den.",
    "evaluationSet": "Utvärderingsuppsättning",
    "sets": {
      "legend": "En uppsättning är ett namn på en lista banor med ett syfte, så att 'quick' betyder samma tre banor nästa vecka. Körningsformuläret expanderar den valda uppsättningen till --course-argument; verktygen ser aldrig namnet.",
      "empty": "Ingen uppsättning ännu. Skapa en nedan.",
      "failed": "Kunde inte läsa banuppsättningarna.",
      "size": "{courses} banor · {labels} kartlagda objekt",
      "purposes": {
        "train": "Träning",
        "evaluate": "Utvärdering"
      },
      "new": "Ny uppsättning",
      "edit": "Redigera",
      "delete": "Ta bort",
      "name": "Namn",
      "namePlaceholder": "quick, full, holdout-5…",
      "purpose": "Syfte",
      "courses": "Banor",
      "allEligible": "Alla godkända",
      "clear": "Rensa",
      "notes": "Anteckningar",
      "save": "Spara uppsättning",
      "saving": "Sparar…",
      "cancel": "Avbryt",
      "saved": "Sparad.",
      "saveFailed": "Kunde inte spara uppsättningen.",
      "deleted": "Borttagen.",
      "deleteFailed": "Kunde inte ta bort uppsättningen.",
      "needsName": "Ge uppsättningen ett namn.",
      "needsCourses": "Välj minst en bana.",
      "buildHeading": "Bygg från ett dataset",
      "buildDatasetNone": "Inget registrerat dataset bär sin uppdelning ännu. Skär ett med extraheringsverktyget så dyker det upp här.",
      "buildTrainHint": "Tar de rikaste banorna ur datasetets träningsdel ({count} banor), så att en träningskörning i den här storleken är samma banor nästa vecka.",
      "buildEvaluateHint": "Tar banor ur datasetets utvärderingsdel ({count} banor), som ingen modell tränad på det har sett.",
      "build": "Bygg {count}",
      "trainHasHoldout": "{count} valda banor ligger i datasetets utvärderingsdel. En träningsuppsättning får inte innehålla dem, annars slutar utvärderingen vara ärlig.",
      "evaluateHasTrain": "{count} valda banor ligger i datasetets träningsdel. En utvärderingsuppsättning får inte innehålla dem, annars mäter den memorering."
    },
    "nir": "Använd infrarött",
    "register": "Spara i registret",
    "epochs": "Epoker",
    "extraArgs": "Extra argument",
    "extraArgsPlaceholder": "--course <uuid> --device mps",
    "command": "Kommando",
    "queue": "Köa körning",
    "queueing": "Köar…",
    "queued": "Köade en {tool}-körning.",
    "queueFailed": "Kunde inte köa körningen.",
    "eligibleCount": "{eligible} av {total} banor har tillräckligt med kartlagda objekt för träning.",
    "thresholds": "Golv per klass: {bunkers} bunkrar, {fairways} fairways. Det räcker att klara ett av dem.",
    "unnamedCourse": "Namnlös bana",
    "eligible": "Duger",
    "notEligible": "För lite data",
    "shortfall": "{missing} fler {kind} behövs (golv {required})",
    "openInOsm": "OpenStreetMap",
    "noOsm": "Inte matchad mot OSM",
    "noImages": "Inga lagrade bilder",
    "workerUnknown": "Okänd arbetarstatus — kön kunde inte läsas.",
    "httpStatus": "(HTTP {status})",
    "thresholdProfilesHeading": "Intrimmade tröskelvärden",
    "unavailable": "Kunde inte läsas",
    "runDetail": "Extrahera, träna, utvärdera eller trimma, på arbetaren.",
    "eligibleShort": "{eligible} av {total} banor duger",
    "jobsCount": "{count} körningar registrerade",
    "modelsDetail": "Alla registrerade checkpoints och deras resultat.",
    "thresholdProfilesDetail": "Intrimmade profiler och knapparna som sätter dem i kraft.",
    "votesHeading": "Modellröster (A/B)",
    "votesDetail": "Vad det skulle ändra att låta en tränad modell rösta om de klassiska detektionerna.",
    "dataHint": "Varje bana med kartlagda objekt, och vad var och en fortfarande saknar.",
    "jobsHint": "Nyast först. Varje körning har sin logg bakom en egen knapp.",
    "datasetsHeading": "Datamängder",
    "datasetsDetail": "Vad varje extraheringskörning klippte ut, och vad den innehåller.",
    "evaluateTrainedHidden": "{count} banor som modellen tränats på erbjuds inte: att poängsätta dem mäter memorering, och evaluate.py avvisar hela körningen om någon av dem nämns.",
    "evaluateSeenCourses": "Modellen har tränats på {courses}. Ta bort den — evaluate.py avvisar hela körningen när en träningsbana nämns, inte bara den banan.",
    "outputWrap": "Radbryt",
    "jobRunning": "kör"
  },
  "referee": {
    "title": "Goffy AI-domare",
    "emptyTitle": "Fråga om en regel",
    "emptyBody": "Domaren förklarar golfreglerna och hur Goffys egna spel räknas. Fråga med egna ord.",
    "suggestion1": "Min boll är i ett pliktområde. Vilka alternativ har jag?",
    "suggestion2": "Hur fungerar överföring av skins i Goffy?",
    "suggestion3": "Jag tror att min boll är out of bounds. Vad gör jag nu?",
    "placeholder": "Fråga om en regel…",
    "send": "Fråga",
    "thinking": "Kollar reglerna…",
    "newConversation": "Ny",
    "showHistory": "Historik",
    "hideHistory": "Tillbaka",
    "historyTitle": "Tidigare frågor",
    "historyEmpty": "Inga frågor ännu.",
    "disclaimer": "Endast vägledning, inte ett officiellt domslut. I tävling bestämmer kommittén.",
    "errors": {
      "unauthorized": "Logga in för att fråga domaren.",
      "invalidRequest": "Frågan kunde inte skickas. Försök igen.",
      "offTopic": "Domaren svarar bara på frågor om golf och om Goffy.",
      "unavailable": "Domaren är inte tillgänglig just nu. Försök snart igen.",
      "rateLimited": "Du har nått dagens gräns för frågor. Försök igen i morgon.",
      "questionTooLong": "Frågan är för lång. Försök korta ner den.",
      "emptyQuestion": "Skriv en fråga först.",
      "emptyAnswer": "Inget svar kom tillbaka. Försök fråga igen.",
      "refused": "Domaren kunde inte svara på den.",
      "notConfigured": "Domaren är inte konfigurerad på den här servern.",
      "providerFailed": "Domaren kunde inte nås. Försök snart igen."
    }
  },
  "speech": {
    "start": "Tala i stället för att skriva",
    "stop": "Sluta spela in",
    "errors": {
      "denied": "Åtkomst till mikrofonen nekades. Tillåt den i webbläsaren för att kunna diktera.",
      "failed": "Mikrofonen kunde inte användas. Skriv i stället."
    }
  },
  "mlDatasets": {
    "published": "Publicerat till datasetlagret — vilken arbetare som helst på det här utbytet kan träna på det.",
    "localOnly": "Finns bara på maskinen som skar det — inte publicerat, så ingen annan arbetare kan träna på det.",
    "split": "träningsdel {train} banor · utvärderingsdel {holdout} banor",
    "title": "Träningsdatamängder",
    "legend": "En rad per registrerad extraheringskörning. Själva utklippen — bild, mask och infrarött — stannar på maskinen som klippte dem, under training/data; bara den här sammanfattningen sparas.",
    "empty": "Ingen extraheringskörning har registrerat en datamängd än.",
    "failed": "Kunde inte läsa datamängderna.",
    "unavailable": "Modellregistret är inte tillgängligt i den här miljön.",
    "unnamed": "Namnlös datamängd",
    "courses": "{count} banor",
    "noPixels": "Inga märkta pixlar — körningen valde banor men klippte inget.",
    "trainedOn": "Tränat: {models}",
    "trainedNone": "Ingen modell har tränats på den."
  },
  "clubPage": {
    "title": "Golfklubb",
    "notFound": "Klubben kunde inte hittas.",
    "error": "Kunde inte hämta klubben.",
    "retry": "Försök igen",
    "logoAlt": "{club}s logotyp",
    "coursesTitle": "Banor",
    "noCourses": "Klubben har inga banor som du kan se.",
    "courseMeta": "Par {par} · {holes} hål · {tees} teer",
    "aboutTheClub": "Om klubben",
    "mapTitle": "Var den ligger",
    "zoomIn": "Zooma in",
    "zoomOut": "Zooma ut",
    "facilitiesTitle": "Faciliteter",
    "hoursFromWebsite": "Från klubbens webbplats – kontrollera innan du åker",
    "facilityKind": {
      "restaurant": "Restaurang",
      "cafe": "Café",
      "bar": "Bar",
      "pub": "Pub",
      "fast_food": "Snabbmat",
      "parking": "Parkering",
      "proshop": "Proshop",
      "driving_range": "Drivingrange",
      "clubhouse": "Klubbhus",
      "practice": "Övningsområde",
      "hotel": "Hotell",
      "guest_house": "Gästhus",
      "chalet": "Stugor",
      "caravan_site": "Husvagnsplats"
    }
  },
  "courseDetails": {
    "title": "Bana",
    "loading": "Hämtar bana...",
    "lat": "Lat: {value}",
    "lon": "Lon: {value}",
    "source": "Källa: {source}",
    "holesTitle": "Hål",
    "hole": "Hål {number}",
    "par": "Par {par}",
    "strokeIndex": "Hcp {index}",
    "noHoles": "Inga håldetaljer för den här banan.",
    "errorMissingId": "Inget bana-ID angivet.",
    "errorNotFound": "Banan hittades inte.",
    "errorLoad": "Kunde inte hämta banan."
  },
  "appUpdate": {
    "readyTitle": "Uppdatering klar",
    "readyMessage": "En ny version av Goffy har laddats ner. Starta om för att börja använda den.",
    "restart": "Starta om",
    "later": "Senare"
  }
}
